"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Utility function
function Util() {}

;
/* 
	class manipulation functions
*/

Util.hasClass = function (el, className) {
  if (el.classList) return el.classList.contains(className);else return !!el.getAttribute('class').match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
};

Util.addClass = function (el, className) {
  var classList = className.split(' ');
  if (el.classList) el.classList.add(classList[0]);else if (!Util.hasClass(el, classList[0])) el.setAttribute('class', el.getAttribute('class') + " " + classList[0]);
  if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.removeClass = function (el, className) {
  var classList = className.split(' ');
  if (el.classList) el.classList.remove(classList[0]);else if (Util.hasClass(el, classList[0])) {
    var reg = new RegExp('(\\s|^)' + classList[0] + '(\\s|$)');
    el.setAttribute('class', el.getAttribute('class').replace(reg, ' '));
  }
  if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};

Util.toggleClass = function (el, className, bool) {
  if (bool) Util.addClass(el, className);else Util.removeClass(el, className);
};

Util.setAttributes = function (el, attrs) {
  for (var key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};
/* 
  DOM manipulation
*/


Util.getChildrenByClassName = function (el, className) {
  var children = el.children,
      childrenByClass = [];

  for (var i = 0; i < el.children.length; i++) {
    if (Util.hasClass(el.children[i], className)) childrenByClass.push(el.children[i]);
  }

  return childrenByClass;
};

Util.is = function (elem, selector) {
  if (selector.nodeType) {
    return elem === selector;
  }

  var qa = typeof selector === 'string' ? document.querySelectorAll(selector) : selector,
      length = qa.length,
      returnArr = [];

  while (length--) {
    if (qa[length] === elem) {
      return true;
    }
  }

  return false;
};
/* 
	Animate height of an element
*/


Util.setHeight = function (start, to, element, duration, cb, timeFunction) {
  var change = to - start,
      currentTime = null;

  var animateHeight = function animateHeight(timestamp) {
    if (!currentTime) currentTime = timestamp;
    var progress = timestamp - currentTime;
    if (progress > duration) progress = duration;
    var val = parseInt(progress / duration * change + start);

    if (timeFunction) {
      val = Math[timeFunction](progress, start, to - start, duration);
    }

    element.style.height = val + "px";

    if (progress < duration) {
      window.requestAnimationFrame(animateHeight);
    } else {
      if (cb) cb();
    }
  }; //set the height of the element before starting animation -> fix bug on Safari


  element.style.height = start + "px";
  window.requestAnimationFrame(animateHeight);
};
/* 
	Smooth Scroll
*/


Util.scrollTo = function (_final, duration, cb, scrollEl) {
  var element = scrollEl || window;
  var start = element.scrollTop || document.documentElement.scrollTop,
      currentTime = null;
  if (!scrollEl) start = window.scrollY || document.documentElement.scrollTop;

  var animateScroll = function animateScroll(timestamp) {
    if (!currentTime) currentTime = timestamp;
    var progress = timestamp - currentTime;
    if (progress > duration) progress = duration;
    var val = Math.easeInOutQuad(progress, start, _final - start, duration);
    element.scrollTo(0, val);

    if (progress < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      cb && cb();
    }
  };

  window.requestAnimationFrame(animateScroll);
};
/* 
  Focus utility classes
*/
//Move focus to an element


Util.moveFocus = function (element) {
  if (!element) element = document.getElementsByTagName("body")[0];
  element.focus();

  if (document.activeElement !== element) {
    element.setAttribute('tabindex', '-1');
    element.focus();
  }
};
/* 
  Misc
*/


Util.getIndexInArray = function (array, el) {
  return Array.prototype.indexOf.call(array, el);
};

Util.cssSupports = function (property, value) {
  if ('CSS' in window) {
    return CSS.supports(property, value);
  } else {
    var jsProperty = property.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
    return jsProperty in document.body.style;
  }
}; // merge a set of user options into plugin defaults
// https://gomakethings.com/vanilla-javascript-version-of-jquery-extend/


Util.extend = function () {
  // Variables
  var extended = {};
  var deep = false;
  var i = 0;
  var length = arguments.length; // Check if a deep merge

  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0];
    i++;
  } // Merge the object into the extended object


  var merge = function merge(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        // If deep merge and property is an object, merge properties
        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = extend(true, extended[prop], obj[prop]);
        } else {
          extended[prop] = obj[prop];
        }
      }
    }
  }; // Loop through each object and conduct a merge


  for (; i < length; i++) {
    var obj = arguments[i];
    merge(obj);
  }

  return extended;
}; // Check if Reduced Motion is enabled


Util.osHasReducedMotion = function () {
  if (!window.matchMedia) return false;
  var matchMediaObj = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (matchMediaObj) return matchMediaObj.matches;
  return false; // return false if not supported
};
/* 
	Polyfills
*/
//Closest() method


if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;
    if (!document.documentElement.contains(el)) return null;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return null;
  };
} //Custom Event() constructor


if (typeof window.CustomEvent !== "function") {
  var _CustomEvent = function _CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  _CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = _CustomEvent;
}
/* 
	Animation curves
*/


Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

Math.easeInQuart = function (t, b, c, d) {
  t /= d;
  return c * t * t * t * t + b;
};

Math.easeOutQuart = function (t, b, c, d) {
  t /= d;
  t--;
  return -c * (t * t * t * t - 1) + b;
};

Math.easeInOutQuart = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t * t * t + b;
  t -= 2;
  return -c / 2 * (t * t * t * t - 2) + b;
};

Math.easeOutElastic = function (t, b, c, d) {
  var s = 1.70158;
  var p = d * 0.7;
  var a = c;
  if (t == 0) return b;
  if ((t /= d) == 1) return b + c;
  if (!p) p = d * .3;

  if (a < Math.abs(c)) {
    a = c;
    var s = p / 4;
  } else var s = p / (2 * Math.PI) * Math.asin(c / a);

  return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
};
/* JS Utility Classes */
// make focus ring visible only for keyboard navigation (i.e., tab key) 


(function () {
  var focusTab = document.getElementsByClassName('js-tab-focus'),
      shouldInit = false,
      outlineStyle = false,
      eventDetected = false;

  function detectClick() {
    if (focusTab.length > 0) {
      resetFocusStyle(false);
      window.addEventListener('keydown', detectTab);
    }

    window.removeEventListener('mousedown', detectClick);
    outlineStyle = false;
    eventDetected = true;
  }

  ;

  function detectTab(event) {
    if (event.keyCode !== 9) return;
    resetFocusStyle(true);
    window.removeEventListener('keydown', detectTab);
    window.addEventListener('mousedown', detectClick);
    outlineStyle = true;
  }

  ;

  function resetFocusStyle(bool) {
    var outlineStyle = bool ? '' : 'none';

    for (var i = 0; i < focusTab.length; i++) {
      focusTab[i].style.setProperty('outline', outlineStyle);
    }
  }

  ;

  function initFocusTabs() {
    if (shouldInit) {
      if (eventDetected) resetFocusStyle(outlineStyle);
      return;
    }

    shouldInit = focusTab.length > 0;
    window.addEventListener('mousedown', detectClick);
  }

  ;
  initFocusTabs();
  window.addEventListener('initFocusTabs', initFocusTabs);
})();

function resetFocusTabsStyle() {
  window.dispatchEvent(new CustomEvent('initFocusTabs'));
}

;
var Shopify = Shopify || {}; // ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

Shopify.money_format = "£{{amount}}";

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}; // File#: _1_accordion
// Usage: codyhouse.co/license


(function () {
  var Accordion = function Accordion(element) {
    this.element = element;
    this.items = Util.getChildrenByClassName(this.element, 'js-accordion__item');
    this.version = this.element.getAttribute('data-version') ? '-' + this.element.getAttribute('data-version') : '';
    this.showClass = 'accordion' + this.version + '__item--is-open';
    this.animateHeight = this.element.getAttribute('data-animation') == 'on';
    this.multiItems = !(this.element.getAttribute('data-multi-items') == 'off'); // deep linking options

    this.deepLinkOn = this.element.getAttribute('data-deep-link') == 'on'; // init accordion

    this.initAccordion();
  };

  Accordion.prototype.initAccordion = function () {
    //set initial aria attributes
    for (var i = 0; i < this.items.length; i++) {
      var button = this.items[i].getElementsByTagName('button')[0],
          content = this.items[i].getElementsByClassName('js-accordion__panel')[0],
          isOpen = Util.hasClass(this.items[i], this.showClass) ? 'true' : 'false';
      Util.setAttributes(button, {
        'aria-expanded': isOpen,
        'aria-controls': 'accordion-content-' + i,
        'id': 'accordion-header-' + i
      });
      Util.addClass(button, 'js-accordion__trigger');
      Util.setAttributes(content, {
        'aria-labelledby': 'accordion-header-' + i,
        'id': 'accordion-content-' + i
      });
    } //listen for Accordion events


    this.initAccordionEvents(); // check deep linking option

    this.initDeepLink();
  };

  Accordion.prototype.initAccordionEvents = function () {
    var self = this;
    this.element.addEventListener('click', function (event) {
      var trigger = event.target.closest('.js-accordion__trigger'); //check index to make sure the click didn't happen inside a children accordion

      if (trigger && Util.getIndexInArray(self.items, trigger.parentElement) >= 0) self.triggerAccordion(trigger);
    });
  };

  Accordion.prototype.triggerAccordion = function (trigger) {
    var bool = trigger.getAttribute('aria-expanded') === 'true';
    this.animateAccordion(trigger, bool, false);

    if (!bool && this.deepLinkOn) {
      history.replaceState(null, '', '#' + trigger.getAttribute('aria-controls'));
    }
  };

  Accordion.prototype.animateAccordion = function (trigger, bool, deepLink) {
    var self = this;
    var item = trigger.closest('.js-accordion__item'),
        content = item.getElementsByClassName('js-accordion__panel')[0],
        ariaValue = bool ? 'false' : 'true';
    if (!bool) Util.addClass(item, this.showClass);
    trigger.setAttribute('aria-expanded', ariaValue);
    self.resetContentVisibility(item, content, bool);
    if (!this.multiItems && !bool || deepLink) this.closeSiblings(item);
  };

  Accordion.prototype.resetContentVisibility = function (item, content, bool) {
    Util.toggleClass(item, this.showClass, !bool);
    content.removeAttribute("style");

    if (bool && !this.multiItems) {
      // accordion item has been closed -> check if there's one open to move inside viewport 
      this.moveContent();
    }
  };

  Accordion.prototype.closeSiblings = function (item) {
    //if only one accordion can be open -> search if there's another one open
    var index = Util.getIndexInArray(this.items, item);

    for (var i = 0; i < this.items.length; i++) {
      if (Util.hasClass(this.items[i], this.showClass) && i != index) {
        this.animateAccordion(this.items[i].getElementsByClassName('js-accordion__trigger')[0], true, false);
        return false;
      }
    }
  };

  Accordion.prototype.moveContent = function () {
    // make sure title of the accordion just opened is inside the viewport
    var openAccordion = this.element.getElementsByClassName(this.showClass);
    if (openAccordion.length == 0) return;
    var boundingRect = openAccordion[0].getBoundingClientRect();

    if (boundingRect.top < 0 || boundingRect.top > window.innerHeight) {
      var windowScrollTop = window.scrollY || document.documentElement.scrollTop;
      window.scrollTo(0, boundingRect.top + windowScrollTop);
    }
  };

  Accordion.prototype.initDeepLink = function () {
    if (!this.deepLinkOn) return;
    var hash = window.location.hash.substr(1);
    if (!hash || hash == '') return;
    var trigger = this.element.querySelector('.js-accordion__trigger[aria-controls="' + hash + '"]');

    if (trigger && trigger.getAttribute('aria-expanded') !== 'true') {
      this.animateAccordion(trigger, false, true);
      setTimeout(function () {
        trigger.scrollIntoView(true);
      });
    }
  };

  window.Accordion = Accordion; //initialize the Accordion objects

  var accordions = document.getElementsByClassName('js-accordion');

  if (accordions.length > 0) {
    for (var i = 0; i < accordions.length; i++) {
      (function (i) {
        new Accordion(accordions[i]);
      })(i);
    }
  } /// close filter accordions --custom fix


  document.addEventListener("click", function (event) {
    // console.log(event.target.closest('.accordion__item'));
    if (event.target.closest('.accordion__item-filter') == null) {
      var open_accordian = document.getElementsByClassName('accordion__item-filter accordion__item--is-open');

      if (open_accordian.length > 0) {
        for (var i = 0; i < open_accordian.length; i++) {
          open_accordian[i].getElementsByTagName('button')[0].setAttribute('aria-expanded', 'false');
          open_accordian[i].classList.remove("accordion__item--is-open");
        }
      }

      return;
    }
  });
})();

(function ($) {
  var shippingAlerts = $('.shipping-notification').find('p');

  function updateCartAmount(cart) {
    $('.cart-qty').html(cart.item_count);

    if (cart.item_count > 0) {
      $('.cart-qty').removeClass('opacity-0');
    } else {
      $('.cart-qty').addClass('opacity-0');
    }
  }

  function checkShippingValue(cart) {
    shippingAlerts.addClass('loaded');
    var freeShippingAmount = window.shippingAlerts.amount;
    var currentCartBalance = cart.total_price;

    if (currentCartBalance > 0) {
      var doTheyQualify = freeShippingAmount - currentCartBalance; //// Do they 

      var theyDontQualify = Shopify.formatMoney(doTheyQualify, window.shippingAlerts.currency_format);
      var sentenceConstruct = window.shippingAlerts.hasItems.replace('AMOUNT', theyDontQualify);
      shippingAlerts.text(sentenceConstruct);

      if (doTheyQualify < 0) {
        shippingAlerts.text(window.shippingAlerts.qualifies);
        showAlert(window.shippingAlerts.qualifies, 'success');
      } else {
        localStorage.removeItem("NoShowAlert");
      }
    } else {
      var amount = Shopify.formatMoney(window.shippingAlerts.amount, window.shippingAlerts.currency_format);
      shippingAlerts.text(window.shippingAlerts.hasNoItems + ' ' + amount);
      localStorage.removeItem("NoShowAlert");
    }
  }

  $(document).on('cart.ready', function (event, cart) {
    return checkShippingValue(cart);
  });
  $(document).on('cart.requestComplete', function (event, cart) {
    updateCartAmount(cart);
    checkShippingValue(cart);
  });
})(jQuery); // File#: _1_alert
// Usage: codyhouse.co/license


function showAlert(copy, alert_type) {
  if (localStorage.getItem("NoShowAlert") === null) {
    var alert_body = document.querySelector('#shipping-alert');

    if (alert_type == 'success') {
      alert_body.classList.add("alert--success");
      alert_body.classList.add('active');
      alert_body.querySelector('#alert-text').innerHTML = copy;
    }

    localStorage.setItem("NoShowAlert", false);
    setTimeout(function () {
      alert_body.classList.remove("alert--success");
      alert_body.classList.remove('active');
      alert_body.querySelector('#alert-text').innerHTML = '';
    }, 6000);
  }
} // File#: _1_anim-menu-btn
// Usage: codyhouse.co/license


(function () {
  var menuBtns = document.getElementsByClassName('js-anim-menu-btn');

  if (menuBtns.length > 0) {
    var i;

    (function () {
      var initMenuBtn = function initMenuBtn(btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          var status = !Util.hasClass(btn, 'anim-menu-btn--state-b');
          Util.toggleClass(btn, 'anim-menu-btn--state-b', status); // emit custom event

          var event = new CustomEvent('anim-menu-btn-clicked', {
            detail: status
          });
          btn.dispatchEvent(event);
        });
      };

      for (i = 0; i < menuBtns.length; i++) {
        (function (i) {
          initMenuBtn(menuBtns[i]);
        })(i);
      }

      ;
    })();
  }
})(); // File#: _1_btn-states
// Usage: codyhouse.co/license


(function ($) {
  function checkBtnStatus($this) {
    if (!$($this).hasClass('btn--state-b')) {
      $($this).addClass('btn--state-b');
    }

    var btn_target = $this;
    $(document).on('cart.requestComplete', function () {
      if ($(btn_target).hasClass('btn--state-b')) {
        $(btn_target).removeClass('btn--state-b');
        $(btn_target).addClass('btn--state-c');
        setTimeout(function () {
          $(btn_target).removeClass('btn--state-c');
          return;
        }, 1000);

        if (!$('#drawer-cart').hasClass('drawer--is-visible')) {
          $('#cart-toggle').trigger('click');
          document.dispatchEvent(spiceCloseQuickAdd);
        }
      } else {
        return;
      }
    });
  }

  $('button.js-btn-states').on('click', function () {
    checkBtnStatus(this);
  });
})(jQuery); // File#: _1_character-count
// Usage: codyhouse.co/license


var CharacterCount = function CharacterCount(element) {
  this.element = element;
  this.input = this.element.getElementsByClassName('js-character-count__input')[0];
  this.characterLimit = Number(this.input.getAttribute('maxlength')) || 200;
  this.counter = this.element.getElementsByClassName('js-character-count__counter')[0];
  this.initCount();
};

CharacterCount.prototype.initCount = function () {
  var self = this;
  this.counter.textContent = this.getCount(); //set counter value 

  this.input.addEventListener('input', function (event) {
    //listen for content changes
    self.counter.textContent = self.getCount();
  });
};

CharacterCount.prototype.getCount = function () {
  return this.characterLimit - this.input.value.length;
}; //initialize the CharacterCount objects


var characterCounts = document.getElementsByClassName('js-character-count');

if (characterCounts.length > 0) {
  for (var i = 0; i < characterCounts.length; i++) {
    (function (i) {
      new CharacterCount(characterCounts[i]);
    })(i);
  }
}

; // File#: _1_choice-buttons
// Usage: codyhouse.co/license

(function () {
  var ChoiceButton = function ChoiceButton(element) {
    this.element = element;
    this.btns = this.element.getElementsByClassName('js-choice-btn');
    this.inputs = getChoiceInput(this);
    this.isRadio = this.inputs[0].type.toString() == 'radio';
    resetCheckedStatus(this); // set initial classes

    initChoiceButtonEvent(this); // add listeners
  };

  function getChoiceInput(element) {
    // store input elements in an object property
    var inputs = [];

    for (var i = 0; i < element.btns.length; i++) {
      inputs.push(element.btns[i].getElementsByTagName('input')[0]);
    }

    return inputs;
  }

  ;

  function initChoiceButtonEvent(choiceBtn) {
    choiceBtn.element.addEventListener('click', function (event) {
      // update status on click
      if (Util.getIndexInArray(choiceBtn.inputs, event.target) > -1) return; // triggered by change in input element -> will be detected by the 'change' event

      var selectedBtn = event.target.closest('.js-choice-btn');
      if (!selectedBtn) return;
      var index = Util.getIndexInArray(choiceBtn.btns, selectedBtn);

      if (choiceBtn.isRadio && choiceBtn.inputs[index].checked) {
        // radio input already checked
        if (event.target.tagName.toLowerCase() != "input") choiceBtn.inputs[index].focus(); // move focus to input element

        return;
      }

      choiceBtn.inputs[index].checked = !choiceBtn.inputs[index].checked;
      choiceBtn.inputs[index].dispatchEvent(new CustomEvent('change', {
        bubbles: true
      })); // trigger change event

      if (event.target.tagName.toLowerCase() != "input") choiceBtn.inputs[index].focus(); // move focus to input element
    });

    for (var i = 0; i < choiceBtn.btns.length; i++) {
      (function (i) {
        // change + focus events
        choiceBtn.inputs[i].addEventListener('change', function (event) {
          choiceBtn.isRadio ? resetCheckedStatus(choiceBtn) : resetSingleStatus(choiceBtn, i);
        });
        choiceBtn.inputs[i].addEventListener('focus', function (event) {
          resetFocusStatus(choiceBtn, i, true);
        });
        choiceBtn.inputs[i].addEventListener('blur', function (event) {
          resetFocusStatus(choiceBtn, i, false);
        });
      })(i);
    }
  }

  ;

  function resetCheckedStatus(choiceBtn) {
    for (var i = 0; i < choiceBtn.btns.length; i++) {
      resetSingleStatus(choiceBtn, i);
    }
  }

  ;

  function resetSingleStatus(choiceBtn, index) {
    // toggle .choice-btn--checked class
    Util.toggleClass(choiceBtn.btns[index], 'choice-btn--checked', choiceBtn.inputs[index].checked);
  }

  ;

  function resetFocusStatus(choiceBtn, index, bool) {
    // toggle .choice-btn--focus class
    Util.toggleClass(choiceBtn.btns[index], 'choice-btn--focus', bool);
  }

  ; //initialize the ChoiceButtons objects

  var choiceButton = document.getElementsByClassName('js-choice-btns');

  if (choiceButton.length > 0) {
    for (var i = 0; i < choiceButton.length; i++) {
      (function (i) {
        new ChoiceButton(choiceButton[i]);
      })(i);
    }
  }

  ;
})(); // File#: _1_choice-images
// Usage: codyhouse.co/license


(function () {
  var ChoiceImgs = function ChoiceImgs(element) {
    this.element = element;
    this.imgs = this.element.getElementsByClassName('js-choice-img');
    this.isRadio = this.imgs[0].getAttribute('role') == 'radio';
    resetChoiceImgs(this); // set initial aria values

    initChoiceImgsEvent(this);
  };

  var change = new Event('change', {
    'bubbles': true
  });

  function initChoiceImgsEvent(choiceImgs) {
    // on click -> select new item
    choiceImgs.element.addEventListener('click', function (event) {
      var selectedImg = event.target.closest('.js-choice-img');
      if (!selectedImg) return;
      var index = Util.getIndexInArray(choiceImgs.imgs, selectedImg);

      if (choiceImgs.isRadio) {
        setRadio(choiceImgs, selectedImg, index);
      } else {
        setCheckbox(choiceImgs, selectedImg, index);
      }
    }); // keyboard events

    choiceImgs.element.addEventListener('keydown', function (event) {
      var selectedImg = event.target.closest('.js-choice-img');
      if (!selectedImg) return;

      if (event.keyCode && event.keyCode == 32 || event.key && event.key.toLowerCase() == ' ') {
        // spacebar ->if this is a checkbox choice, toggle the state
        if (choiceImgs.isRadio) return;
        event.preventDefault();
        var index = Util.getIndexInArray(choiceImgs.imgs, selectedImg);
        setCheckbox(choiceImgs, selectedImg, index);
      } else if (event.keyCode && (event.keyCode == 40 || event.keyCode == 39) || event.key && (event.key.toLowerCase() == 'arrowdown' || event.key.toLowerCase() == 'arrowright')) {
        // arrow right/arrow down
        if (!choiceImgs.isRadio) return;
        event.preventDefault();
        navigateRadioImgs(choiceImgs, 1);
      } else if (event.keyCode && (event.keyCode == 38 || event.keyCode == 37) || event.key && (event.key.toLowerCase() == 'arrowup' || event.key.toLowerCase() == 'arrowleft')) {
        // arrow left/up down
        if (!choiceImgs.isRadio) return;
        event.preventDefault();
        navigateRadioImgs(choiceImgs, -1);
      }
    });
  }

  ;

  function setCheckbox(choiceImgs, selectedImg, index) {
    var check = selectedImg.getAttribute('aria-checked') == 'false' ? 'true' : 'false';
    selectedImg.setAttribute('aria-checked', check);
    selectedImg.focus(); // move focus to input element
  }

  ;

  function setRadio(choiceImgs, selectedImg, index) {
    var check = selectedImg.getAttribute('aria-checked') == 'false' ? 'true' : 'false';

    if (check == 'true') {
      selectedImg.setAttribute('aria-checked', check);
      selectedImg.querySelector('input[type="radio"]').checked = true;
      selectedImg.setAttribute('tabindex', '0');

      for (var i = 0; i < choiceImgs.imgs.length; i++) {
        if (i != index) {
          choiceImgs.imgs[i].setAttribute('aria-checked', 'false');
          choiceImgs.imgs[i].removeAttribute('tabindex');
        }
      }
    }

    selectedImg.dispatchEvent(change);
    selectedImg.focus(); // move focus to input element
  }

  ;

  function navigateRadioImgs(choiceImgs, increment) {
    // navigate radio items with keyboard
    var selectedImg = choiceImgs.element.querySelector('[aria-checked="true"]');
    if (!selectedImg) return;
    var index = Util.getIndexInArray(choiceImgs.imgs, selectedImg);
    index = index + increment;
    if (index < 0) index = choiceImgs.imgs.length - 1;
    if (index >= choiceImgs.imgs.length) index = 0;
    setRadio(choiceImgs, choiceImgs.imgs[index], index);
  }

  ;

  function resetChoiceImgs(choiceImgs) {
    for (var i = 0; i < choiceImgs.imgs.length; i++) {
      var check = choiceImgs.imgs[i].getAttribute('aria-checked');

      if (check == 'true') {
        choiceImgs.imgs[i].setAttribute('tabindex', '0'); // make it focusable
      } else {
        // if radio -> element not focusable
        // if checkbox -> element still focusable
        choiceImgs.isRadio ? choiceImgs.imgs[i].removeAttribute('tabindex') : choiceImgs.imgs[i].setAttribute('tabindex', '0');
      }
    }
  }

  ; //initialize the ChoiceImgs objects

  var choiceImg = document.getElementsByClassName('js-choice-imgs');

  if (choiceImg.length > 0) {
    for (var i = 0; i < choiceImg.length; i++) {
      (function (i) {
        new ChoiceImgs(choiceImg[i]);
      })(i);
    }
  }

  ;
})(); // File#: _1_custom-select
// Usage: codyhouse.co/license


(function () {
  // NOTE: you need the js code only when using the --custom-dropdown variation of the Custom Select component. Default version does nor require JS.
  var CustomSelect = function CustomSelect(element) {
    this.element = element;
    this.select = this.element.getElementsByTagName('select')[0];
    this.optGroups = this.select.getElementsByTagName('optgroup');
    this.options = this.select.getElementsByTagName('option');
    this.selectedOption = getSelectedOptionText(this);
    this.selectId = this.select.getAttribute('id');
    this.trigger = false;
    this.dropdown = false;
    this.customOptions = false;
    this.arrowIcon = this.element.getElementsByTagName('svg');
    this.label = document.querySelector('[for="' + this.selectId + '"]');
    this.optionIndex = 0; // used while building the custom dropdown

    initCustomSelect(this); // init markup

    initCustomSelectEvents(this); // init event listeners
  };

  function initCustomSelect(select) {
    // create the HTML for the custom dropdown element
    select.element.insertAdjacentHTML('beforeend', initButtonSelect(select) + initListSelect(select)); // save custom elements

    select.dropdown = select.element.getElementsByClassName('js-select__dropdown')[0];
    select.trigger = select.element.getElementsByClassName('js-select__button')[0];
    select.customOptions = select.dropdown.getElementsByClassName('js-select__item'); // hide default select

    Util.addClass(select.select, 'is-hidden');
    if (select.arrowIcon.length > 0) select.arrowIcon[0].style.display = 'none'; // place dropdown

    placeDropdown(select);
  }

  ;

  function initCustomSelectEvents(select) {
    // option selection in dropdown
    initSelection(select); // click events

    select.trigger.addEventListener('click', function () {
      toggleCustomSelect(select, false);
    });

    if (select.label) {
      // move focus to custom trigger when clicking on <select> label
      select.label.addEventListener('click', function () {
        Util.moveFocus(select.trigger);
      });
    } // keyboard navigation


    select.dropdown.addEventListener('keydown', function (event) {
      if (event.keyCode && event.keyCode == 38 || event.key && event.key.toLowerCase() == 'arrowup') {
        keyboardCustomSelect(select, 'prev', event);
      } else if (event.keyCode && event.keyCode == 40 || event.key && event.key.toLowerCase() == 'arrowdown') {
        keyboardCustomSelect(select, 'next', event);
      }
    }); // native <select> element has been updated -> update custom select as well

    select.element.addEventListener('select-updated', function (event) {
      resetCustomSelect(select);
    });
  }

  ;

  function toggleCustomSelect(select, bool) {
    var ariaExpanded;

    if (bool) {
      ariaExpanded = bool;
    } else {
      ariaExpanded = select.trigger.getAttribute('aria-expanded') == 'true' ? 'false' : 'true';
    }

    select.trigger.setAttribute('aria-expanded', ariaExpanded);

    if (ariaExpanded == 'true') {
      var selectedOption = getSelectedOption(select);
      Util.moveFocus(selectedOption); // fallback if transition is not supported

      select.dropdown.addEventListener('transitionend', function cb() {
        Util.moveFocus(selectedOption);
        select.dropdown.removeEventListener('transitionend', cb);
      });
      placeDropdown(select); // place dropdown based on available space
    }
  }

  ;

  function placeDropdown(select) {
    // remove placement classes to reset position
    Util.removeClass(select.dropdown, 'select__dropdown--right select__dropdown--up');
    var triggerBoundingRect = select.trigger.getBoundingClientRect();
    Util.toggleClass(select.dropdown, 'select__dropdown--right', document.documentElement.clientWidth - 5 < triggerBoundingRect.left + select.dropdown.offsetWidth); // check if there's enough space up or down

    var moveUp = window.innerHeight - triggerBoundingRect.bottom - 5 < triggerBoundingRect.top;
    Util.toggleClass(select.dropdown, 'select__dropdown--up', moveUp); // check if we need to set a max width

    var maxHeight = moveUp ? triggerBoundingRect.top - 20 : window.innerHeight - triggerBoundingRect.bottom - 20; // set max-height based on available space

    select.dropdown.setAttribute('style', 'max-height: ' + maxHeight + 'px; width: ' + triggerBoundingRect.width + 'px;');
  }

  ;

  function keyboardCustomSelect(select, direction, event) {
    // navigate custom dropdown with keyboard
    event.preventDefault();
    var index = Util.getIndexInArray(select.customOptions, document.activeElement);
    index = direction == 'next' ? index + 1 : index - 1;
    if (index < 0) index = select.customOptions.length - 1;
    if (index >= select.customOptions.length) index = 0;
    Util.moveFocus(select.customOptions[index]);
  }

  ;

  function initSelection(select) {
    // option selection
    select.dropdown.addEventListener('click', function (event) {
      var option = event.target.closest('.js-select__item');
      if (!option) return;
      selectOption(select, option);
    });
  }

  ;

  function selectOption(select, option) {
    if (option.hasAttribute('aria-selected') && option.getAttribute('aria-selected') == 'true') {
      // selecting the same option
      select.trigger.setAttribute('aria-expanded', 'false'); // hide dropdown
    } else {
      var selectedOption = select.dropdown.querySelector('[aria-selected="true"]');
      if (selectedOption) selectedOption.setAttribute('aria-selected', 'false');
      option.setAttribute('aria-selected', 'true');
      select.trigger.getElementsByClassName('js-select__label')[0].textContent = option.textContent;
      select.trigger.setAttribute('aria-expanded', 'false'); // new option has been selected -> update native <select> element _ arai-label of trigger <button>

      updateNativeSelect(select, option.getAttribute('data-index'));
      updateTriggerAria(select);
    } // move focus back to trigger


    select.trigger.focus();
  }

  ;

  function updateNativeSelect(select, index) {
    select.select.selectedIndex = index;
    select.select.dispatchEvent(new CustomEvent('change', {
      bubbles: true
    })); // trigger change event
  }

  ;

  function updateTriggerAria(select) {
    select.trigger.setAttribute('aria-label', select.options[select.select.selectedIndex].innerHTML + ', ' + select.label.textContent);
  }

  ;

  function getSelectedOptionText(select) {
    // used to initialize the label of the custom select button
    var label = '';

    if ('selectedIndex' in select.select) {
      label = select.options[select.select.selectedIndex].text;
    } else {
      label = select.select.querySelector('option[selected]').text;
    }

    return label;
  }

  ;

  function initButtonSelect(select) {
    // create the button element -> custom select trigger
    // check if we need to add custom classes to the button trigger
    var customClasses = select.element.getAttribute('data-trigger-class') ? ' ' + select.element.getAttribute('data-trigger-class') : '';
    var label = select.options[select.select.selectedIndex].innerHTML + ', ' + select.label.textContent;
    var button = '<button type="button" class="js-select__button select__button' + customClasses + '" aria-label="' + label + '" aria-expanded="false" aria-controls="' + select.selectId + '-dropdown"><span aria-hidden="true" class="js-select__label select__label">' + select.selectedOption + '</span>';

    if (select.arrowIcon.length > 0 && select.arrowIcon[0].outerHTML) {
      var clone = select.arrowIcon[0].cloneNode(true);
      Util.removeClass(clone, 'select__icon');
      button = button + clone.outerHTML;
    }

    return button + '</button>';
  }

  ;

  function initListSelect(select) {
    // create custom select dropdown
    var list = '<div class="js-select__dropdown select__dropdown" aria-describedby="' + select.selectId + '-description" id="' + select.selectId + '-dropdown">';
    list = list + getSelectLabelSR(select);

    if (select.optGroups.length > 0) {
      for (var i = 0; i < select.optGroups.length; i++) {
        var optGroupList = select.optGroups[i].getElementsByTagName('option'),
            optGroupLabel = '<li><span class="select__item select__item--optgroup">' + select.optGroups[i].getAttribute('label') + '</span></li>';
        list = list + '<ul class="select__list" role="listbox">' + optGroupLabel + getOptionsList(select, optGroupList) + '</ul>';
      }
    } else {
      list = list + '<ul class="select__list" role="listbox">' + getOptionsList(select, select.options) + '</ul>';
    }

    return list;
  }

  ;

  function getSelectLabelSR(select) {
    if (select.label) {
      return '<p class="sr-only" id="' + select.selectId + '-description">' + select.label.textContent + '</p>';
    } else {
      return '';
    }
  }

  ;

  function resetCustomSelect(select) {
    // <select> element has been updated (using an external control) - update custom select
    var selectedOption = select.dropdown.querySelector('[aria-selected="true"]');
    if (selectedOption) selectedOption.setAttribute('aria-selected', 'false');
    var option = select.dropdown.querySelector('.js-select__item[data-index="' + select.select.selectedIndex + '"]');
    option.setAttribute('aria-selected', 'true');
    select.trigger.getElementsByClassName('js-select__label')[0].textContent = option.textContent;
    select.trigger.setAttribute('aria-expanded', 'false');
    updateTriggerAria(select);
  }

  ;

  function getOptionsList(select, options) {
    var list = '';

    for (var i = 0; i < options.length; i++) {
      var selected = options[i].hasAttribute('selected') ? ' aria-selected="true"' : ' aria-selected="false"';
      list = list + '<li><button type="button" class="reset js-select__item select__item select__item--option" role="option" data-value="' + options[i].value + '" ' + selected + ' data-index="' + select.optionIndex + '">' + options[i].text + '</button></li>';
      select.optionIndex = select.optionIndex + 1;
    }

    ;
    return list;
  }

  ;

  function getSelectedOption(select) {
    var option = select.dropdown.querySelector('[aria-selected="true"]');
    if (option) return option;else return select.dropdown.getElementsByClassName('js-select__item')[0];
  }

  ;

  function moveFocusToSelectTrigger(select) {
    if (!document.activeElement.closest('.js-select')) return;
    select.trigger.focus();
  }

  ;

  function checkCustomSelectClick(select, target) {
    // close select when clicking outside it
    if (!select.element.contains(target)) toggleCustomSelect(select, 'false');
  }

  ; //initialize the CustomSelect objects

  var customSelect = document.getElementsByClassName('js-select');

  if (customSelect.length > 0) {
    var selectArray = [];

    for (var i = 0; i < customSelect.length; i++) {
      (function (i) {
        selectArray.push(new CustomSelect(customSelect[i]));
      })(i);
    } // listen for key events


    window.addEventListener('keyup', function (event) {
      if (event.keyCode && event.keyCode == 27 || event.key && event.key.toLowerCase() == 'escape') {
        // close custom select on 'Esc'
        selectArray.forEach(function (element) {
          moveFocusToSelectTrigger(element); // if focus is within dropdown, move it to dropdown trigger

          toggleCustomSelect(element, 'false'); // close dropdown
        });
      }
    }); // close custom select when clicking outside it

    window.addEventListener('click', function (event) {
      selectArray.forEach(function (element) {
        checkCustomSelectClick(element, event.target);
      });
    });
  }
})(); // Usage: codyhouse.co/license


(function () {
  var DatePicker = function DatePicker(opts) {
    this.options = Util.extend(DatePicker.defaults, opts);
    this.element = this.options.element;
    this.input = this.element.getElementsByClassName('js-date-input__text')[0];
    this.trigger = this.element.getElementsByClassName('js-date-input__trigger')[0];
    this.triggerLabel = this.trigger.getAttribute('aria-label');
    this.datePicker = this.element.getElementsByClassName('js-date-picker')[0];
    this.body = this.datePicker.getElementsByClassName('js-date-picker__dates')[0];
    this.navigation = this.datePicker.getElementsByClassName('js-date-picker__month-nav')[0];
    this.heading = this.datePicker.getElementsByClassName('js-date-picker__month-label')[0];
    this.pickerVisible = false; // date format

    this.dateIndexes = getDateIndexes(this); // store indexes of date parts (d, m, y)
    // set initial date

    resetCalendar(this); // selected date

    this.dateSelected = false;
    this.selectedDay = false;
    this.selectedMonth = false;
    this.selectedYear = false; // focus trap

    this.firstFocusable = false;
    this.lastFocusable = false; // date value - for custom control variation

    this.dateValueEl = this.element.getElementsByClassName('js-date-input__value');

    if (this.dateValueEl.length > 0) {
      this.dateValueLabelInit = this.dateValueEl[0].textContent; // initial input value
    }

    initCalendarAria(this);
    initCalendarEvents(this); // place picker according to available space

    placeCalendar(this);
  };

  DatePicker.prototype.showCalendar = function () {
    showCalendar(this);
  };

  DatePicker.prototype.showNextMonth = function () {
    showNext(this, true);
  };

  DatePicker.prototype.showPrevMonth = function () {
    showPrev(this, true);
  };

  function initCalendarAria(datePicker) {
    // reset calendar button label
    resetLabelCalendarTrigger(datePicker);

    if (datePicker.dateValueEl.length > 0) {
      resetCalendar(datePicker);
      resetLabelCalendarValue(datePicker);
    } // create a live region used to announce new month selection to SR


    var srLiveReagion = document.createElement('div');
    srLiveReagion.setAttribute('aria-live', 'polite');
    Util.addClass(srLiveReagion, 'sr-only js-date-input__sr-live');
    datePicker.element.appendChild(srLiveReagion);
    datePicker.srLiveReagion = datePicker.element.getElementsByClassName('js-date-input__sr-live')[0];
  }

  ;

  function initCalendarEvents(datePicker) {
    datePicker.input.addEventListener('focus', function (event) {
      toggleCalendar(datePicker, true); // toggle calendar when focus is on input
    });

    if (datePicker.trigger) {
      datePicker.trigger.addEventListener('click', function (event) {
        // open calendar when clicking on calendar button
        event.preventDefault();
        datePicker.pickerVisible = false;
        toggleCalendar(datePicker);
        datePicker.trigger.setAttribute('aria-expanded', 'true');
      });
    } // select a date inside the date picker


    datePicker.body.addEventListener('click', function (event) {
      event.preventDefault();
      var day = event.target.closest('button');

      if (day) {
        datePicker.dateSelected = true;
        datePicker.selectedDay = day.innerText;
        datePicker.selectedMonth = datePicker.currentMonth;
        datePicker.selectedYear = datePicker.currentYear;
        setInputValue(datePicker);
        datePicker.input.focus(); // focus on the input element and close picker

        resetLabelCalendarTrigger(datePicker);
        resetLabelCalendarValue(datePicker);
      }
    }); // navigate using month nav

    datePicker.navigation.addEventListener('click', function (event) {
      event.preventDefault();
      var btn = event.target.closest('.js-date-picker__month-nav-btn');

      if (btn) {
        Util.hasClass(btn, 'js-date-picker__month-nav-btn--prev') ? showPrev(datePicker, true) : showNext(datePicker, true);
      }
    }); // hide calendar

    window.addEventListener('keydown', function (event) {
      // close calendar on esc
      if (event.keyCode && event.keyCode == 27 || event.key && event.key.toLowerCase() == 'escape') {
        if (document.activeElement.closest('.js-date-picker')) {
          datePicker.input.focus(); //if focus is inside the calendar -> move the focus to the input element 
        } else {
          // do not move focus -> only close calendar
          hideCalendar(datePicker);
        }
      }
    });
    window.addEventListener('click', function (event) {
      if (!event.target.closest('.js-date-picker') && !event.target.closest('.js-date-input') && datePicker.pickerVisible) {
        hideCalendar(datePicker);
      }
    }); // navigate through days of calendar

    datePicker.body.addEventListener('keydown', function (event) {
      var day = datePicker.currentDay;

      if (event.keyCode && event.keyCode == 40 || event.key && event.key.toLowerCase() == 'arrowdown') {
        day = day + 7;
        resetDayValue(day, datePicker);
      } else if (event.keyCode && event.keyCode == 39 || event.key && event.key.toLowerCase() == 'arrowright') {
        day = day + 1;
        resetDayValue(day, datePicker);
      } else if (event.keyCode && event.keyCode == 37 || event.key && event.key.toLowerCase() == 'arrowleft') {
        day = day - 1;
        resetDayValue(day, datePicker);
      } else if (event.keyCode && event.keyCode == 38 || event.key && event.key.toLowerCase() == 'arrowup') {
        day = day - 7;
        resetDayValue(day, datePicker);
      } else if (event.keyCode && event.keyCode == 35 || event.key && event.key.toLowerCase() == 'end') {
        // move focus to last day of week
        event.preventDefault();
        day = day + 6 - getDayOfWeek(datePicker.currentYear, datePicker.currentMonth, day);
        resetDayValue(day, datePicker);
      } else if (event.keyCode && event.keyCode == 36 || event.key && event.key.toLowerCase() == 'home') {
        // move focus to first day of week
        event.preventDefault();
        day = day - getDayOfWeek(datePicker.currentYear, datePicker.currentMonth, day);
        resetDayValue(day, datePicker);
      } else if (event.keyCode && event.keyCode == 34 || event.key && event.key.toLowerCase() == 'pagedown') {
        event.preventDefault();
        showNext(datePicker); // show next month
      } else if (event.keyCode && event.keyCode == 33 || event.key && event.key.toLowerCase() == 'pageup') {
        event.preventDefault();
        showPrev(datePicker); // show prev month
      }
    }); // trap focus inside calendar

    datePicker.datePicker.addEventListener('keydown', function (event) {
      if (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab') {
        //trap focus inside modal
        trapFocus(event, datePicker);
      }
    });
    datePicker.input.addEventListener('keydown', function (event) {
      if (event.keyCode && event.keyCode == 13 || event.key && event.key.toLowerCase() == 'enter') {
        // update calendar on input enter
        resetCalendar(datePicker);
        resetLabelCalendarTrigger(datePicker);
        resetLabelCalendarValue(datePicker);
        hideCalendar(datePicker);
      } else if (event.keyCode && event.keyCode == 40 || event.key && event.key.toLowerCase() == 'arrowdown' && datePicker.pickerVisible) {
        // move focus to calendar using arrow down
        datePicker.body.querySelector('button[tabindex="0"]').focus();
      }

      ;
    });
  }

  ;

  function getCurrentDay(date) {
    return date ? getDayFromDate(date) : new Date().getDate();
  }

  ;

  function getCurrentMonth(date) {
    return date ? getMonthFromDate(date) : new Date().getMonth();
  }

  ;

  function getCurrentYear(date) {
    return date ? getYearFromDate(date) : new Date().getFullYear();
  }

  ;

  function getDayFromDate(date) {
    var day = parseInt(date.split('-')[2]);
    return isNaN(day) ? getCurrentDay(false) : day;
  }

  ;

  function getMonthFromDate(date) {
    var month = parseInt(date.split('-')[1]) - 1;
    return isNaN(month) ? getCurrentMonth(false) : month;
  }

  ;

  function getYearFromDate(date) {
    var year = parseInt(date.split('-')[0]);
    return isNaN(year) ? getCurrentYear(false) : year;
  }

  ;

  function showNext(datePicker, bool) {
    // show next month
    datePicker.currentYear = datePicker.currentMonth === 11 ? datePicker.currentYear + 1 : datePicker.currentYear;
    datePicker.currentMonth = (datePicker.currentMonth + 1) % 12;
    datePicker.currentDay = checkDayInMonth(datePicker);
    showCalendar(datePicker, bool);
    datePicker.srLiveReagion.textContent = datePicker.options.months[datePicker.currentMonth] + ' ' + datePicker.currentYear;
  }

  ;

  function showPrev(datePicker, bool) {
    // show prev month
    datePicker.currentYear = datePicker.currentMonth === 0 ? datePicker.currentYear - 1 : datePicker.currentYear;
    datePicker.currentMonth = datePicker.currentMonth === 0 ? 11 : datePicker.currentMonth - 1;
    datePicker.currentDay = checkDayInMonth(datePicker);
    showCalendar(datePicker, bool);
    datePicker.srLiveReagion.textContent = datePicker.options.months[datePicker.currentMonth] + ' ' + datePicker.currentYear;
  }

  ;

  function checkDayInMonth(datePicker) {
    return datePicker.currentDay > daysInMonth(datePicker.currentYear, datePicker.currentMonth) ? 1 : datePicker.currentDay;
  }

  ;

  function daysInMonth(year, month) {
    return 32 - new Date(year, month, 32).getDate();
  }

  ;

  function resetCalendar(datePicker) {
    var currentDate = false,
        selectedDate = datePicker.input.value;
    datePicker.dateSelected = false;

    if (selectedDate != '') {
      var date = getDateFromInput(datePicker);
      datePicker.dateSelected = true;
      currentDate = date;
    }

    datePicker.currentDay = getCurrentDay(currentDate);
    datePicker.currentMonth = getCurrentMonth(currentDate);
    datePicker.currentYear = getCurrentYear(currentDate);
    datePicker.selectedDay = datePicker.dateSelected ? datePicker.currentDay : false;
    datePicker.selectedMonth = datePicker.dateSelected ? datePicker.currentMonth : false;
    datePicker.selectedYear = datePicker.dateSelected ? datePicker.currentYear : false;
  }

  ;

  function showCalendar(datePicker, bool) {
    // show calendar element
    var firstDay = getDayOfWeek(datePicker.currentYear, datePicker.currentMonth, '01');
    datePicker.body.innerHTML = '';
    datePicker.heading.innerHTML = datePicker.options.months[datePicker.currentMonth] + ' ' + datePicker.currentYear; // creating all cells

    var buttonDisabled = '';
    var date = 1,
        calendar = '';

    for (var i = 0; i < 6; i++) {
      for (var j = 0; j < 7; j++) {
        if (i === 0 && j < firstDay) {
          calendar = calendar + '<li></li>';
        } else if (date > daysInMonth(datePicker.currentYear, datePicker.currentMonth)) {
          break;
        } else {
          var classListDate = '',
              tabindexValue = '-1';

          if (date === datePicker.currentDay) {
            tabindexValue = '0';
          }

          var todayDate = new Date(getCurrentYear(), getCurrentMonth(), getCurrentDay());
          var compareDate = new Date(datePicker.currentYear, datePicker.currentMonth, date);

          if (todayDate > compareDate) {
            classListDate = classListDate + ' date-picker__date--past';
            buttonDisabled = 'disabled';
          }

          if (getCurrentMonth() == datePicker.currentMonth && getCurrentYear() == datePicker.currentYear && date == getCurrentDay()) {
            classListDate = classListDate + ' date-picker__date--today';
            buttonDisabled = '';
          }

          if (datePicker.dateSelected && date === datePicker.selectedDay && datePicker.currentYear === datePicker.selectedYear && datePicker.currentMonth === datePicker.selectedMonth) {
            classListDate = classListDate + '  date-picker__date--selected';
            buttonDisabled = '';
          }

          calendar = calendar + '<li><button class="date-picker__date' + classListDate + '" tabindex="' + tabindexValue + '" type="button" ' + buttonDisabled + ' >' + date + '</button></li>';
          date++;
        }
      }
    }

    datePicker.body.innerHTML = calendar; // appending days into calendar body
    // show calendar

    if (!datePicker.pickerVisible) Util.addClass(datePicker.datePicker, 'date-picker--is-visible');
    datePicker.pickerVisible = true; //  if bool is false, move focus to calendar day

    if (!bool) datePicker.body.querySelector('button[tabindex="0"]').focus(); // store first/last focusable elements

    getFocusableElements(datePicker); //place calendar

    placeCalendar(datePicker);
  }

  ;

  function hideCalendar(datePicker) {
    Util.removeClass(datePicker.datePicker, 'date-picker--is-visible');
    datePicker.pickerVisible = false; // reset first/last focusable

    datePicker.firstFocusable = false;
    datePicker.lastFocusable = false; // reset trigger aria-expanded attribute

    if (datePicker.trigger) datePicker.trigger.setAttribute('aria-expanded', 'false');
  }

  ;

  function toggleCalendar(datePicker, bool) {
    if (!datePicker.pickerVisible) {
      resetCalendar(datePicker);
      showCalendar(datePicker, bool);
    } else {
      hideCalendar(datePicker);
    }
  }

  ;

  function getDayOfWeek(year, month, day) {
    var weekDay = new Date(year, month, day).getDay() - 1;
    if (weekDay < 0) weekDay = 6;
    return weekDay;
  }

  ;

  function getDateIndexes(datePicker) {
    var dateFormat = datePicker.options.dateFormat.toLowerCase().replace(/-/g, '');
    return [dateFormat.indexOf('d'), dateFormat.indexOf('m'), dateFormat.indexOf('y')];
  }

  ;

  function setInputValue(datePicker) {
    datePicker.input.value = getDateForInput(datePicker);
    var triggerChange = new Event("change", {
      bubbles: true
    });
    datePicker.input.dispatchEvent(triggerChange);
  }

  ;

  function getDateForInput(datePicker) {
    var dateArray = [];
    dateArray[datePicker.dateIndexes[0]] = getReadableDate(datePicker.selectedDay);
    dateArray[datePicker.dateIndexes[1]] = getReadableDate(datePicker.selectedMonth + 1);
    dateArray[datePicker.dateIndexes[2]] = datePicker.selectedYear;
    return dateArray[0] + datePicker.options.dateSeparator + dateArray[1] + datePicker.options.dateSeparator + dateArray[2];
  }

  ;

  function getDateFromInput(datePicker) {
    var dateArray = datePicker.input.value.split(datePicker.options.dateSeparator);
    return dateArray[datePicker.dateIndexes[2]] + '-' + dateArray[datePicker.dateIndexes[1]] + '-' + dateArray[datePicker.dateIndexes[0]];
  }

  ;

  function getReadableDate(date) {
    return date < 10 ? '0' + date : date;
  }

  ;

  function resetDayValue(day, datePicker) {
    var totDays = daysInMonth(datePicker.currentYear, datePicker.currentMonth);

    if (day > totDays) {
      datePicker.currentDay = day - totDays;
      showNext(datePicker, false);
    } else if (day < 1) {
      var newMonth = datePicker.currentMonth == 0 ? 11 : datePicker.currentMonth - 1;
      datePicker.currentDay = daysInMonth(datePicker.currentYear, newMonth) + day;
      showPrev(datePicker, false);
    } else {
      datePicker.currentDay = day;
      datePicker.body.querySelector('button[tabindex="0"]').setAttribute('tabindex', '-1'); // set new tabindex to selected item

      var buttons = datePicker.body.getElementsByTagName("button");

      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].textContent == datePicker.currentDay) {
          buttons[i].setAttribute('tabindex', '0');
          buttons[i].focus();
          break;
        }
      }

      getFocusableElements(datePicker); // update first focusable/last focusable element
    }
  }

  ;

  function resetLabelCalendarTrigger(datePicker) {
    if (!datePicker.trigger) return; // reset accessible label of the calendar trigger

    datePicker.selectedYear && datePicker.selectedMonth !== false && datePicker.selectedDay ? datePicker.trigger.setAttribute('aria-label', datePicker.triggerLabel + ', selected date is ' + new Date(datePicker.selectedYear, datePicker.selectedMonth, datePicker.selectedDay).toDateString()) : datePicker.trigger.setAttribute('aria-label', datePicker.triggerLabel);
  }

  ;

  function resetLabelCalendarValue(datePicker) {
    // this is used for the --custom-control variation -> there's a label that should be updated with the selected date
    if (datePicker.dateValueEl.length < 1) return;
    datePicker.selectedYear && datePicker.selectedMonth !== false && datePicker.selectedDay ? datePicker.dateValueEl[0].textContent = getDateForInput(datePicker) : datePicker.dateValueEl[0].textContent = datePicker.dateValueLabelInit;
  }

  ;

  function getFocusableElements(datePicker) {
    var allFocusable = datePicker.datePicker.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary');
    getFirstFocusable(allFocusable, datePicker);
    getLastFocusable(allFocusable, datePicker);
  }

  function getFirstFocusable(elements, datePicker) {
    for (var i = 0; i < elements.length; i++) {
      if ((elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) && elements[i].getAttribute('tabindex') != '-1') {
        datePicker.firstFocusable = elements[i];
        return true;
      }
    }
  }

  ;

  function getLastFocusable(elements, datePicker) {
    //get last visible focusable element inside the modal
    for (var i = elements.length - 1; i >= 0; i--) {
      if ((elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) && elements[i].getAttribute('tabindex') != '-1') {
        datePicker.lastFocusable = elements[i];
        return true;
      }
    }
  }

  ;

  function trapFocus(event, datePicker) {
    if (datePicker.firstFocusable == document.activeElement && event.shiftKey) {
      //on Shift+Tab -> focus last focusable element when focus moves out of calendar
      event.preventDefault();
      datePicker.lastFocusable.focus();
    }

    if (datePicker.lastFocusable == document.activeElement && !event.shiftKey) {
      //on Tab -> focus first focusable element when focus moves out of calendar
      event.preventDefault();
      datePicker.firstFocusable.focus();
    }
  }

  ;

  function placeCalendar(datePicker) {
    // reset position
    datePicker.datePicker.style.left = '0px';
    datePicker.datePicker.style.right = 'auto'; //check if you need to modify the calendar postion

    var pickerBoundingRect = datePicker.datePicker.getBoundingClientRect();

    if (pickerBoundingRect.right > window.innerWidth) {
      datePicker.datePicker.style.left = 'auto';
      datePicker.datePicker.style.right = '0px';
    }
  }

  ;
  DatePicker.defaults = {
    element: '',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    dateFormat: 'd-m-y',
    dateSeparator: '/'
  };
  window.DatePicker = DatePicker;
  var datePicker = document.getElementsByClassName('js-date-input'),
      flexSupported = Util.cssSupports('align-items', 'stretch');

  if (datePicker.length > 0) {
    for (var i = 0; i < datePicker.length; i++) {
      (function (i) {
        if (!flexSupported) {
          Util.addClass(datePicker[i], 'date-input--hide-calendar');
          return;
        }

        var opts = {
          element: datePicker[i]
        };

        if (datePicker[i].getAttribute('data-date-format')) {
          opts.dateFormat = datePicker[i].getAttribute('data-date-format');
        }

        if (datePicker[i].getAttribute('data-date-separator')) {
          opts.dateSeparator = datePicker[i].getAttribute('data-date-separator');
        }

        if (datePicker[i].getAttribute('data-months')) {
          opts.months = datePicker[i].getAttribute('data-months').split(',').map(function (item) {
            return item.trim();
          });
        }

        new DatePicker(opts);
      })(i);
    }
  }
})(); // File#: _1_drawer
// Usage: codyhouse.co/license


(function () {
  var Drawer = function Drawer(element) {
    this.element = element;
    this.content = document.getElementsByClassName('js-drawer__body')[0];
    this.triggers = document.querySelectorAll('[aria-controls="' + this.element.getAttribute('id') + '"]');
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.selectedTrigger = null;
    this.isModal = Util.hasClass(this.element, 'js-drawer--modal');
    this.showClass = "drawer--is-visible";
    this.initDrawer();
  };

  Drawer.prototype.initDrawer = function () {
    var self = this; //open drawer when clicking on trigger buttons

    if (this.triggers) {
      for (var i = 0; i < this.triggers.length; i++) {
        this.triggers[i].addEventListener('click', function (event) {
          event.preventDefault();

          if (Util.hasClass(self.element, self.showClass)) {
            self.closeDrawer(event.target);
            return;
          }

          self.selectedTrigger = event.target;
          self.showDrawer();
          self.initDrawerEvents();
        });
      }
    } // if drawer is already open -> we should initialize the drawer events


    if (Util.hasClass(this.element, this.showClass)) this.initDrawerEvents();
  };

  Drawer.prototype.showDrawer = function () {
    var self = this;
    this.content.scrollTop = 0;
    Util.addClass(this.element, this.showClass);
    this.getFocusableElements();
    Util.moveFocus(this.element); // wait for the end of transitions before moving focus

    this.element.addEventListener("transitionend", function cb(event) {
      Util.moveFocus(self.element);
      self.element.removeEventListener("transitionend", cb);
    });
    this.emitDrawerEvents('drawerIsOpen', this.selectedTrigger);
  };

  Drawer.prototype.closeDrawer = function (target) {
    Util.removeClass(this.element, this.showClass);
    this.firstFocusable = null;
    this.lastFocusable = null;
    if (this.selectedTrigger) this.selectedTrigger.focus(); //remove listeners

    this.cancelDrawerEvents();
    this.emitDrawerEvents('drawerIsClose', target);
  };

  Drawer.prototype.initDrawerEvents = function () {
    //add event listeners
    this.element.addEventListener('keydown', this);
    this.element.addEventListener('click', this);
  };

  Drawer.prototype.cancelDrawerEvents = function () {
    //remove event listeners
    this.element.removeEventListener('keydown', this);
    this.element.removeEventListener('click', this);
  };

  Drawer.prototype.handleEvent = function (event) {
    switch (event.type) {
      case 'click':
        {
          this.initClick(event);
        }

      case 'keydown':
        {
          this.initKeyDown(event);
        }
    }
  };

  Drawer.prototype.initKeyDown = function (event) {
    if (event.keyCode && event.keyCode == 27 || event.key && event.key == 'Escape') {
      //close drawer window on esc
      this.closeDrawer(false);
    } else if (this.isModal && (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab')) {
      //trap focus inside drawer
      this.trapFocus(event);
    }
  };

  Drawer.prototype.initClick = function (event) {
    //close drawer when clicking on close button or drawer bg layer 
    if (!event.target.closest('.js-drawer__close') && !Util.hasClass(event.target, 'js-drawer')) return;
    event.preventDefault();
    this.closeDrawer(event.target);
  };

  Drawer.prototype.trapFocus = function (event) {
    if (this.firstFocusable == document.activeElement && event.shiftKey) {
      //on Shift+Tab -> focus last focusable element when focus moves out of drawer
      event.preventDefault();
      this.lastFocusable.focus();
    }

    if (this.lastFocusable == document.activeElement && !event.shiftKey) {
      //on Tab -> focus first focusable element when focus moves out of drawer
      event.preventDefault();
      this.firstFocusable.focus();
    }
  };

  Drawer.prototype.getFocusableElements = function () {
    //get all focusable elements inside the drawer
    var allFocusable = this.element.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary');
    this.getFirstVisible(allFocusable);
    this.getLastVisible(allFocusable);
  };

  Drawer.prototype.getFirstVisible = function (elements) {
    //get first visible focusable element inside the drawer
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
        this.firstFocusable = elements[i];
        return true;
      }
    }
  };

  Drawer.prototype.getLastVisible = function (elements) {
    //get last visible focusable element inside the drawer
    for (var i = elements.length - 1; i >= 0; i--) {
      if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
        this.lastFocusable = elements[i];
        return true;
      }
    }
  };

  Drawer.prototype.emitDrawerEvents = function (eventName, target) {
    var event = new CustomEvent(eventName, {
      detail: target
    });
    this.element.dispatchEvent(event);
  };

  window.Drawer = Drawer; //initialize the Drawer objects

  var drawer = document.getElementsByClassName('js-drawer');

  if (drawer.length > 0) {
    for (var i = 0; i < drawer.length; i++) {
      (function (i) {
        new Drawer(drawer[i]);
      })(i);
    }
  }
})(); // File#: _1_filter-navigation
// Usage: codyhouse.co/license


(function () {
  var FilterNav = function FilterNav(element) {
    this.element = element;
    this.wrapper = this.element.getElementsByClassName('js-filter-nav__wrapper')[0];
    this.nav = this.element.getElementsByClassName('js-filter-nav__nav')[0];
    this.list = this.nav.getElementsByClassName('js-filter-nav__list')[0];
    this.control = this.element.getElementsByClassName('js-filter-nav__control')[0];
    this.modalClose = this.element.getElementsByClassName('js-filter-nav__close-btn')[0];
    this.placeholder = this.element.getElementsByClassName('js-filter-nav__placeholder')[0];
    this.marker = this.element.getElementsByClassName('js-filter-nav__marker');
    this.layout = 'expanded';
    initFilterNav(this);
  };

  function initFilterNav(element) {
    checkLayout(element); // init layout

    if (element.layout == 'expanded') placeMarker(element);
    element.element.addEventListener('update-layout', function (event) {
      // on resize - modify layout
      checkLayout(element);
    }); // update selected item

    element.wrapper.addEventListener('click', function (event) {
      var newItem = event.target.closest('.js-filter-nav__btn');

      if (newItem) {
        updateCurrentItem(element, newItem);
        return;
      } // close modal list - mobile version only


      if (Util.hasClass(event.target, 'js-filter-nav__wrapper') || event.target.closest('.js-filter-nav__close-btn')) toggleModalList(element, false);
    }); // open modal list - mobile version only

    element.control.addEventListener('click', function (event) {
      toggleModalList(element, true);
    }); // listen for key events

    window.addEventListener('keyup', function (event) {
      // listen for esc key
      if (event.keyCode && event.keyCode == 27 || event.key && event.key.toLowerCase() == 'escape') {
        // close navigation on mobile if open
        if (element.control.getAttribute('aria-expanded') == 'true' && isVisible(element.control)) {
          toggleModalList(element, false);
        }
      } // listen for tab key


      if (event.keyCode && event.keyCode == 9 || event.key && event.key.toLowerCase() == 'tab') {
        // close navigation on mobile if open when nav loses focus
        if (element.control.getAttribute('aria-expanded') == 'true' && isVisible(element.control) && !document.activeElement.closest('.js-filter-nav__wrapper')) toggleModalList(element, false);
      }
    });
  }

  ;

  function updateCurrentItem(element, btn) {
    if (btn.getAttribute('aria-current') == 'true') {
      toggleModalList(element, false);
      return;
    }

    var activeBtn = element.wrapper.querySelector('[aria-current]');
    if (activeBtn) activeBtn.removeAttribute('aria-current');
    btn.setAttribute('aria-current', 'true'); // update trigger label on selection (visible on mobile only)

    element.placeholder.textContent = btn.textContent;
    toggleModalList(element, false);
    if (element.layout == 'expanded') placeMarker(element);
  }

  ;

  function toggleModalList(element, bool) {
    element.control.setAttribute('aria-expanded', bool);
    Util.toggleClass(element.wrapper, 'filter-nav__wrapper--is-visible', bool);

    if (bool) {
      element.nav.querySelectorAll('[href], button:not([disabled])')[0].focus();
    } else if (isVisible(element.control)) {
      element.control.focus();
    }
  }

  ;

  function isVisible(element) {
    return element.offsetWidth || element.offsetHeight || element.getClientRects().length;
  }

  ;

  function checkLayout(element) {
    if (element.layout == 'expanded' && switchToCollapsed(element)) {
      // check if there's enough space 
      element.layout = 'collapsed';
      Util.removeClass(element.element, 'filter-nav--expanded');
      Util.addClass(element.element, 'filter-nav--collapsed');
      Util.removeClass(element.modalClose, 'is-hidden');
      Util.removeClass(element.control, 'is-hidden');
    } else if (element.layout == 'collapsed' && switchToExpanded(element)) {
      element.layout = 'expanded';
      Util.addClass(element.element, 'filter-nav--expanded');
      Util.removeClass(element.element, 'filter-nav--collapsed');
      Util.addClass(element.modalClose, 'is-hidden');
      Util.addClass(element.control, 'is-hidden');
    } // place background element


    if (element.layout == 'expanded') placeMarker(element);
  }

  ;

  function switchToCollapsed(element) {
    return element.nav.scrollWidth > element.nav.offsetWidth;
  }

  ;

  function switchToExpanded(element) {
    element.element.style.visibility = 'hidden';
    Util.addClass(element.element, 'filter-nav--expanded');
    Util.removeClass(element.element, 'filter-nav--collapsed');
    var switchLayout = element.nav.scrollWidth <= element.nav.offsetWidth;
    Util.removeClass(element.element, 'filter-nav--expanded');
    Util.addClass(element.element, 'filter-nav--collapsed');
    element.element.style.visibility = 'visible';
    return switchLayout;
  }

  ;

  function placeMarker(element) {
    var activeElement = element.wrapper.querySelector('.js-filter-nav__btn[aria-current="true"]');
    if (element.marker.length == 0 || !activeElement) return;
    element.marker[0].style.width = activeElement.offsetWidth + 'px';
    element.marker[0].style.transform = 'translateX(' + (activeElement.getBoundingClientRect().left - element.list.getBoundingClientRect().left) + 'px)';
  }

  ;
  var filterNav = document.getElementsByClassName('js-filter-nav');

  if (filterNav.length > 0) {
    var doneResizing = function doneResizing() {
      for (var i = 0; i < filterNavArray.length; i++) {
        (function (i) {
          filterNavArray[i].element.dispatchEvent(customEvent);
        })(i);
      }

      ;
    };

    var filterNavArray = [];

    for (var i = 0; i < filterNav.length; i++) {
      filterNavArray.push(new FilterNav(filterNav[i]));
    }

    var resizingId = false,
        customEvent = new CustomEvent('update-layout');
    window.addEventListener('resize', function () {
      clearTimeout(resizingId);
      resizingId = setTimeout(doneResizing, 100);
    }); // wait for font to be loaded

    if (document.fonts) {
      document.fonts.onloadingdone = function (fontFaceSetEvent) {
        doneResizing();
      };
    }

    ;
  }
})(); // File#: _1_filter
// Usage: codyhouse.co/license


(function () {
  var Filter = function Filter(opts) {
    this.options = Util.extend(Filter.defaults, opts); // used to store custom filter/sort functions

    this.element = this.options.element;
    this.elementId = this.element.getAttribute('id');
    this.items = this.element.querySelectorAll('.js-filter__item');
    this.controllers = document.querySelectorAll('[aria-controls="' + this.elementId + '"]'); // controllers wrappers

    this.fallbackMessage = document.querySelector('[data-fallback-gallery-id="' + this.elementId + '"]');
    this.filterString = []; // combination of different filter values

    this.sortingString = ''; // sort value - will include order and type of argument (e.g., number or string)
    // store info about sorted/filtered items

    this.filterList = []; // list of boolean for each this.item -> true if still visible , otherwise false

    this.sortingList = []; // list of new ordered this.item -> each element is [item, originalIndex]
    // store grid info for animation

    this.itemsGrid = []; // grid coordinates

    this.itemsInitPosition = []; // used to store coordinates of this.items before animation

    this.itemsIterPosition = []; // used to store coordinates of this.items before animation - intermediate state

    this.itemsFinalPosition = []; // used to store coordinates of this.items after filtering
    // animation off

    this.animateOff = this.element.getAttribute('data-filter-animation') == 'off'; // used to update this.itemsGrid on resize

    this.resizingId = false; // default acceleration style - improve animation

    this.accelerateStyle = 'will-change: transform, opacity; transform: translateZ(0); backface-visibility: hidden;'; // handle multiple changes

    this.animating = false;
    this.reanimate = false;
    initFilter(this);
  };

  function initFilter(filter) {
    resetFilterSortArray(filter, true, true); // init array filter.filterList/filter.sortingList

    createGridInfo(filter); // store grid coordinates in filter.itemsGrid

    initItemsOrder(filter); // add data-orders so that we can reset the sorting
    // events handling - filter update

    for (var i = 0; i < filter.controllers.length; i++) {
      filter.filterString[i] = ''; // reset filtering
      // get proper filter/sorting string based on selected controllers

      (function (i) {
        filter.controllers[i].addEventListener('change', function (event) {
          if (event.target.tagName.toLowerCase() == 'select') {
            // select elements
            !event.target.getAttribute('data-filter') ? setSortingString(filter, event.target.value, event.target.options[event.target.selectedIndex]) : setFilterString(filter, i, 'select');
          } else if (event.target.tagName.toLowerCase() == 'input' && (event.target.getAttribute('type') == 'radio' || event.target.getAttribute('type') == 'checkbox')) {
            // input (radio/checkboxed) elements
            !event.target.getAttribute('data-filter') ? setSortingString(filter, event.target.getAttribute('data-sort'), event.target) : setFilterString(filter, i, 'input');
          } else {
            // generic inout element
            !filter.controllers[i].getAttribute('data-filter') ? setSortingString(filter, filter.controllers[i].getAttribute('data-sort'), filter.controllers[i]) : setFilterString(filter, i, 'custom');
          }

          updateFilterArray(filter);
        });
        filter.controllers[i].addEventListener('click', function (event) {
          // retunr if target is select/input elements
          var filterEl = event.target.closest('[data-filter]');
          var sortEl = event.target.closest('[data-sort]');
          if (!filterEl && !sortEl) return;
          if (filterEl && (filterEl.tagName.toLowerCase() == 'input' || filterEl.tagName.toLowerCase() == 'select')) return;
          if (sortEl && (sortEl.tagName.toLowerCase() == 'input' || sortEl.tagName.toLowerCase() == 'select')) return;
          if (sortEl && Util.hasClass(sortEl, 'js-filter__custom-control')) return;
          if (filterEl && Util.hasClass(filterEl, 'js-filter__custom-control')) return; // this will be executed only for a list of buttons -> no inputs

          event.preventDefault();
          resetControllersList(filter, i, filterEl, sortEl);
          sortEl ? setSortingString(filter, sortEl.getAttribute('data-sort'), sortEl) : setFilterString(filter, i, 'button');
          updateFilterArray(filter);
        }); // target search inputs -> update them on 'input'

        filter.controllers[i].addEventListener('input', function (event) {
          if (event.target.tagName.toLowerCase() == 'input' && (event.target.getAttribute('type') == 'search' || event.target.getAttribute('type') == 'text')) {
            setFilterString(filter, i, 'custom');
            updateFilterArray(filter);
          }
        });
      })(i);
    } // handle resize - update grid coordinates in filter.itemsGrid


    window.addEventListener('resize', function () {
      clearTimeout(filter.resizingId);
      filter.resizingId = setTimeout(function () {
        createGridInfo(filter);
      }, 300);
    }); // check if there are filters/sorting values already set

    checkInitialFiltering(filter); // reset filtering results if filter selection was changed by an external control (e.g., form reset) 

    filter.element.addEventListener('update-filter-results', function (event) {
      // reset filters first
      for (var i = 0; i < filter.controllers.length; i++) {
        filter.filterString[i] = '';
      }

      filter.sortingString = '';
      checkInitialFiltering(filter);
    });
  }

  ;

  function checkInitialFiltering(filter) {
    for (var i = 0; i < filter.controllers.length; i++) {
      // check if there's a selected option
      // buttons list
      var selectedButton = filter.controllers[i].getElementsByClassName('js-filter-selected');

      if (selectedButton.length > 0) {
        var sort = selectedButton[0].getAttribute('data-sort');
        sort ? setSortingString(filter, selectedButton[0].getAttribute('data-sort'), selectedButton[0]) : setFilterString(filter, i, 'button');
        continue;
      } // input list


      var selectedInput = filter.controllers[i].querySelectorAll('input:checked');

      if (selectedInput.length > 0) {
        var sort = selectedInput[0].getAttribute('data-sort');
        sort ? setSortingString(filter, sort, selectedInput[0]) : setFilterString(filter, i, 'input');
        continue;
      } // select item


      if (filter.controllers[i].tagName.toLowerCase() == 'select') {
        var sort = filter.controllers[i].getAttribute('data-sort');
        sort ? setSortingString(filter, filter.controllers[i].value, filter.controllers[i].options[filter.controllers[i].selectedIndex]) : setFilterString(filter, i, 'select');
        continue;
      } // check if there's a generic custom input


      var radioInput = filter.controllers[i].querySelector('input[type="radio"]'),
          checkboxInput = filter.controllers[i].querySelector('input[type="checkbox"]');

      if (!radioInput && !checkboxInput) {
        var sort = filter.controllers[i].getAttribute('data-sort');
        var filterString = filter.controllers[i].getAttribute('data-filter');
        if (sort) setSortingString(filter, sort, filter.controllers[i]);else if (filterString) setFilterString(filter, i, 'custom');
      }
    }

    updateFilterArray(filter);
  }

  ;

  function setSortingString(filter, value, item) {
    // get sorting string value-> sortName:order:type
    var order = item.getAttribute('data-sort-order') ? 'desc' : 'asc';
    var type = item.getAttribute('data-sort-number') ? 'number' : 'string';
    filter.sortingString = value + ':' + order + ':' + type;
  }

  ;

  function setFilterString(filter, index, type) {
    // get filtering array -> [filter1:filter2, filter3, filter4:filter5]
    if (type == 'input') {
      var checkedInputs = filter.controllers[index].querySelectorAll('input:checked');
      filter.filterString[index] = '';

      for (var i = 0; i < checkedInputs.length; i++) {
        filter.filterString[index] = filter.filterString[index] + checkedInputs[i].getAttribute('data-filter') + ':';
      }
    } else if (type == 'select') {
      if (filter.controllers[index].multiple) {
        // select with multiple options
        filter.filterString[index] = getMultipleSelectValues(filter.controllers[index]);
      } else {
        // select with single option
        filter.filterString[index] = filter.controllers[index].value;
      }
    } else if (type == 'button') {
      var selectedButtons = filter.controllers[index].querySelectorAll('.js-filter-selected');
      filter.filterString[index] = '';

      for (var i = 0; i < selectedButtons.length; i++) {
        filter.filterString[index] = filter.filterString[index] + selectedButtons[i].getAttribute('data-filter') + ':';
      }
    } else if (type == 'custom') {
      filter.filterString[index] = filter.controllers[index].getAttribute('data-filter');
    }
  }

  ;

  function resetControllersList(filter, index, target1, target2) {
    // for a <button>s list -> toggle js-filter-selected + custom classes
    var multi = filter.controllers[index].getAttribute('data-filter-checkbox'),
        customClass = filter.controllers[index].getAttribute('data-selected-class');
    customClass = customClass ? 'js-filter-selected ' + customClass : 'js-filter-selected';

    if (multi == 'true') {
      // multiple options can be on
      target1 ? Util.toggleClass(target1, customClass, !Util.hasClass(target1, 'js-filter-selected')) : Util.toggleClass(target2, customClass, !Util.hasClass(target2, 'js-filter-selected'));
    } else {
      // only one element at the time
      // remove the class from all siblings
      var selectedOption = filter.controllers[index].querySelector('.js-filter-selected');
      if (selectedOption) Util.removeClass(selectedOption, customClass);
      target1 ? Util.addClass(target1, customClass) : Util.addClass(target2, customClass);
    }
  }

  ;

  function updateFilterArray(filter) {
    // sort/filter strings have been updated -> so you can update the gallery
    if (filter.animating) {
      filter.reanimate = true;
      return;
    }

    filter.animating = true;
    filter.reanimate = false;
    createGridInfo(filter); // get new grid coordinates

    sortingGallery(filter); // update sorting list 

    filteringGallery(filter); // update filter list

    resetFallbackMessage(filter, true); // toggle fallback message

    if (reducedMotion || filter.animateOff) {
      resetItems(filter);
    } else {
      updateItemsAttributes(filter);
    }
  }

  ;

  function sortingGallery(filter) {
    // use sorting string to reorder gallery
    var sortOptions = filter.sortingString.split(':');

    if (sortOptions[0] == '' || sortOptions[0] == '*') {
      // no sorting needed
      restoreSortOrder(filter);
    } else {
      // need to sort
      if (filter.options[sortOptions[0]]) {
        // custom sort function -> user takes care of it
        filter.sortingList = filter.options[sortOptions[0]](filter.sortingList);
      } else {
        filter.sortingList.sort(function (left, right) {
          var leftVal = left[0].getAttribute('data-sort-' + sortOptions[0]),
              rightVal = right[0].getAttribute('data-sort-' + sortOptions[0]);

          if (sortOptions[2] == 'number') {
            leftVal = parseFloat(leftVal);
            rightVal = parseFloat(rightVal);
          }

          if (sortOptions[1] == 'desc') return leftVal <= rightVal ? 1 : -1;else return leftVal >= rightVal ? 1 : -1;
        });
      }
    }
  }

  ;

  function filteringGallery(filter) {
    // use filtering string to reorder gallery
    resetFilterSortArray(filter, true, false); // we can have multiple filters

    for (var i = 0; i < filter.filterString.length; i++) {
      //check if multiple filters inside the same controller
      if (filter.filterString[i] != '' && filter.filterString[i] != '*' && filter.filterString[i] != ' ') {
        singleFilterGallery(filter, filter.filterString[i].split(':'));
      }
    }
  }

  ;

  function singleFilterGallery(filter, subfilter) {
    if (!subfilter || subfilter == '' || subfilter == '*') return; // check if we have custom options

    var customFilterArray = [];

    for (var j = 0; j < subfilter.length; j++) {
      if (filter.options[subfilter[j]]) {
        // custom function
        customFilterArray[subfilter[j]] = filter.options[subfilter[j]](filter.items);
      }
    }

    for (var i = 0; i < filter.items.length; i++) {
      var filterValues = filter.items[i].getAttribute('data-filter').split(' ');
      var present = false;

      for (var j = 0; j < subfilter.length; j++) {
        if (filter.options[subfilter[j]] && customFilterArray[subfilter[j]][i]) {
          // custom function
          present = true;
          break;
        } else if (subfilter[j] == '*' || filterValues.indexOf(subfilter[j]) > -1) {
          present = true;
          break;
        }
      }

      filter.filterList[i] = !present ? false : filter.filterList[i];
    }
  }

  ;

  function updateItemsAttributes(filter) {
    // set items before triggering the update animation
    // get offset of all elements before animation
    storeOffset(filter, filter.itemsInitPosition); // set height of container

    filter.element.setAttribute('style', 'height: ' + parseFloat(filter.element.offsetHeight) + 'px; width: ' + parseFloat(filter.element.offsetWidth) + 'px;');

    for (var i = 0; i < filter.items.length; i++) {
      // remove is-hidden class from items now visible and scale to zero
      if (Util.hasClass(filter.items[i], 'is-hidden') && filter.filterList[i]) {
        filter.items[i].setAttribute('data-scale', 'on');
        filter.items[i].setAttribute('style', filter.accelerateStyle + 'transform: scale(0.5); opacity: 0;');
        Util.removeClass(filter.items[i], 'is-hidden');
      }
    } // get new elements offset


    storeOffset(filter, filter.itemsIterPosition); // translate items so that they are in the right initial position

    for (var i = 0; i < filter.items.length; i++) {
      if (filter.items[i].getAttribute('data-scale') != 'on') {
        filter.items[i].setAttribute('style', filter.accelerateStyle + 'transform: translateX(' + parseInt(filter.itemsInitPosition[i][0] - filter.itemsIterPosition[i][0]) + 'px) translateY(' + parseInt(filter.itemsInitPosition[i][1] - filter.itemsIterPosition[i][1]) + 'px);');
      }
    }

    animateItems(filter);
  }

  ;

  function animateItems(filter) {
    var transitionValue = 'transform ' + filter.options.duration + 'ms cubic-bezier(0.455, 0.03, 0.515, 0.955), opacity ' + filter.options.duration + 'ms'; // get new index of items in the list

    var j = 0;

    for (var i = 0; i < filter.sortingList.length; i++) {
      var item = filter.items[filter.sortingList[i][1]];

      if (Util.hasClass(item, 'is-hidden') || !filter.filterList[filter.sortingList[i][1]]) {
        // item is hidden or was previously hidden -> final position equal to first one
        filter.itemsFinalPosition[filter.sortingList[i][1]] = filter.itemsIterPosition[filter.sortingList[i][1]];
        if (item.getAttribute('data-scale') == 'on') j = j + 1;
      } else {
        filter.itemsFinalPosition[filter.sortingList[i][1]] = [filter.itemsGrid[j][0], filter.itemsGrid[j][1]]; // left/top

        j = j + 1;
      }
    }

    setTimeout(function () {
      for (var i = 0; i < filter.items.length; i++) {
        if (filter.filterList[i] && filter.items[i].getAttribute('data-scale') == 'on') {
          // scale up item
          filter.items[i].setAttribute('style', filter.accelerateStyle + 'transition: ' + transitionValue + '; transform: translateX(' + parseInt(filter.itemsFinalPosition[i][0] - filter.itemsIterPosition[i][0]) + 'px) translateY(' + parseInt(filter.itemsFinalPosition[i][1] - filter.itemsIterPosition[i][1]) + 'px) scale(1); opacity: 1;');
        } else if (filter.filterList[i]) {
          // translate item
          filter.items[i].setAttribute('style', filter.accelerateStyle + 'transition: ' + transitionValue + '; transform: translateX(' + parseInt(filter.itemsFinalPosition[i][0] - filter.itemsIterPosition[i][0]) + 'px) translateY(' + parseInt(filter.itemsFinalPosition[i][1] - filter.itemsIterPosition[i][1]) + 'px);');
        } else {
          // scale down item
          filter.items[i].setAttribute('style', filter.accelerateStyle + 'transition: ' + transitionValue + '; transform: scale(0.5); opacity: 0;');
        }
      }

      ;
    }, 50); // wait for the end of transition of visible elements

    setTimeout(function () {
      resetItems(filter);
    }, filter.options.duration + 100);
  }

  ;

  function resetItems(filter) {
    // animation was off or animation is over -> reset attributes
    for (var i = 0; i < filter.items.length; i++) {
      filter.items[i].removeAttribute('style');
      Util.toggleClass(filter.items[i], 'is-hidden', !filter.filterList[i]);
      filter.items[i].removeAttribute('data-scale');
    }

    for (var i = 0; i < filter.items.length; i++) {
      // reorder
      filter.element.appendChild(filter.items[filter.sortingList[i][1]]);
    }

    filter.items = [];
    filter.items = filter.element.querySelectorAll('.js-filter__item');
    resetFilterSortArray(filter, false, true);
    filter.element.removeAttribute('style');
    filter.animating = false;

    if (filter.reanimate) {
      updateFilterArray(filter);
    }

    resetFallbackMessage(filter, false); // toggle fallback message
    // emit custom event - end of filtering

    filter.element.dispatchEvent(new CustomEvent('filter-selection-updated'));
  }

  ;

  function resetFilterSortArray(filter, filtering, sorting) {
    for (var i = 0; i < filter.items.length; i++) {
      if (filtering) filter.filterList[i] = true;
      if (sorting) filter.sortingList[i] = [filter.items[i], i];
    }
  }

  ;

  function createGridInfo(filter) {
    var containerWidth = parseFloat(window.getComputedStyle(filter.element).getPropertyValue('width')),
        itemStyle,
        itemWidth,
        itemHeight,
        marginX,
        marginY,
        colNumber; // get offset first visible element

    for (var i = 0; i < filter.items.length; i++) {
      if (!Util.hasClass(filter.items[i], 'is-hidden')) {
        itemStyle = window.getComputedStyle(filter.items[i]), itemWidth = parseFloat(itemStyle.getPropertyValue('width')), itemHeight = parseFloat(itemStyle.getPropertyValue('height')), marginX = parseFloat(itemStyle.getPropertyValue('margin-left')) + parseFloat(itemStyle.getPropertyValue('margin-right')), marginY = parseFloat(itemStyle.getPropertyValue('margin-bottom')) + parseFloat(itemStyle.getPropertyValue('margin-top'));

        if (marginX == 0 && marginY == 0) {
          // grid is set using the gap property and not margins
          var margins = resetMarginValues(filter);
          marginX = margins[0];
          marginY = margins[1];
        }

        var colNumber = parseInt((containerWidth + marginX) / (itemWidth + marginX));
        filter.itemsGrid[0] = [filter.items[i].offsetLeft, filter.items[i].offsetTop]; // left, top

        break;
      }
    }

    for (var i = 1; i < filter.items.length; i++) {
      var x = i < colNumber ? i : i % colNumber,
          y = i < colNumber ? 0 : Math.floor(i / colNumber);
      filter.itemsGrid[i] = [filter.itemsGrid[0][0] + x * (itemWidth + marginX), filter.itemsGrid[0][1] + y * (itemHeight + marginY)];
    }
  }

  ;

  function storeOffset(filter, array) {
    for (var i = 0; i < filter.items.length; i++) {
      array[i] = [filter.items[i].offsetLeft, filter.items[i].offsetTop];
    }
  }

  ;

  function initItemsOrder(filter) {
    for (var i = 0; i < filter.items.length; i++) {
      filter.items[i].setAttribute('data-init-sort-order', i);
    }
  }

  ;

  function restoreSortOrder(filter) {
    for (var i = 0; i < filter.items.length; i++) {
      filter.sortingList[parseInt(filter.items[i].getAttribute('data-init-sort-order'))] = [filter.items[i], i];
    }
  }

  ;

  function resetFallbackMessage(filter, bool) {
    if (!filter.fallbackMessage) return;
    var show = true;

    for (var i = 0; i < filter.filterList.length; i++) {
      if (filter.filterList[i]) {
        show = false;
        break;
      }
    }

    ;

    if (bool) {
      // reset visibility before animation is triggered
      if (!show) Util.addClass(filter.fallbackMessage, 'is-hidden');
      return;
    }

    Util.toggleClass(filter.fallbackMessage, 'is-hidden', !show);
  }

  ;

  function getMultipleSelectValues(multipleSelect) {
    // get selected options of a <select multiple> element
    var options = multipleSelect.options,
        value = '';

    for (var i = 0; i < options.length; i++) {
      if (options[i].selected) {
        if (value != '') value = value + ':';
        value = value + options[i].value;
      }
    }

    return value;
  }

  ;

  function resetMarginValues(filter) {
    var gapX = getComputedStyle(filter.element).getPropertyValue('--gap-x'),
        gapY = getComputedStyle(filter.element).getPropertyValue('--gap-y'),
        gap = getComputedStyle(filter.element).getPropertyValue('--gap'),
        gridGap = [0, 0]; // tif the gap property is used to create the grid (not margin left/right) -> get gap values rather than margins
    // check if the --gap/--gap-x/--gap-y

    var newDiv = document.createElement('div'),
        cssText = 'position: absolute; opacity: 0; width: 0px; height: 0px';

    if (gapX && gapY) {
      cssText = 'position: absolute; opacity: 0; width: ' + gapX + '; height: ' + gapY;
    } else if (gap) {
      cssText = 'position: absolute; opacity: 0; width: ' + gap + '; height: ' + gap;
    } else if (gapX) {
      cssText = 'position: absolute; opacity: 0; width: ' + gapX + '; height: 0px';
    } else if (gapY) {
      cssText = 'position: absolute; opacity: 0; width: 0px; height: ' + gapY;
    }

    newDiv.style.cssText = cssText;
    document.body.appendChild(newDiv);
    gridGap = [newDiv.offsetWidth, newDiv.offsetHeight];
    document.body.removeChild(newDiv);
    return gridGap;
  }

  ;
  Filter.defaults = {
    element: false,
    duration: 400
  };
  window.Filter = Filter; // init Filter object

  var filterGallery = document.getElementsByClassName('js-filter'),
      reducedMotion = Util.osHasReducedMotion();

  if (filterGallery.length > 0) {
    for (var i = 0; i < filterGallery.length; i++) {
      var duration = filterGallery[i].getAttribute('data-filter-duration');
      if (!duration) duration = Filter.defaults.duration;
      new Filter({
        element: filterGallery[i],
        duration: duration
      });
    }
  }
})(); // // File#: _1_header
// // Usage: codyhouse.co/license
// (function($) {
//     var mainHeader = document.getElementsByClassName('js-header');
//     if( mainHeader.length > 0 ) {
//       var trigger = mainHeader[0].getElementsByClassName('js-header__trigger')[0],
//         nav = mainHeader[0].getElementsByClassName('js-header__nav')[0];
//       // we'll use these to store the node that needs to receive focus when the mobile menu is closed 
//       var focusMenu = false;
//       // listen for key events
//       window.addEventListener('keyup', function(event){
//         // listen for esc key
//         if( (event.keyCode && event.keyCode == 27) || (event.key && event.key.toLowerCase() == 'escape' )) {
//           // close navigation on mobile if open
//           if(trigger.getAttribute('aria-expanded') == 'true' && isVisible(trigger)) {
//             focusMenu = trigger; // move focus to menu trigger when menu is close
//             trigger.click();
//           }
//         }
//         // listen for tab key
//         if( (event.keyCode && event.keyCode == 9) || (event.key && event.key.toLowerCase() == 'tab' )) {
//           // close navigation on mobile if open when nav loses focus
//           if(trigger.getAttribute('aria-expanded') == 'true' && isVisible(trigger) && !document.activeElement.closest('.js-header')) trigger.click();
//         }
//       });
//       // listen for resize
//       var resizingId = false;
//       window.addEventListener('resize', function() {
//         clearTimeout(resizingId);
//         resizingId = setTimeout(doneResizing, 500);
//       });
//       function doneResizing() {
//         if( !isVisible(trigger) && Util.hasClass(mainHeader[0], 'header--expanded')) toggleNavigation(false); 
//       };
//     }
//     function isVisible(element) {
//       return (element.offsetWidth || element.offsetHeight || element.getClientRects().length);
//     };
//     function toggleNavigation(bool) { // toggle navigation visibility on small device
//       Util.toggleClass(nav, 'header__nav--is-visible', bool);
//       Util.toggleClass(mainHeader[0], 'header--expanded', bool);
//       trigger.setAttribute('aria-expanded', bool);
//       if(bool) { //opening menu -> move focus to first element inside nav
//         nav.querySelectorAll('[href], input:not([disabled]), button:not([disabled])')[0].focus();
//       } else if(focusMenu) {
//         focusMenu.focus();
//         focusMenu = false;
//       }
//     };
//   }(jQuery));
// File#: _1_hiding-nav
// Usage: codyhouse.co/license


(function () {
  var hidingNav = document.getElementsByClassName('js-hide-nav');

  if (hidingNav.length > 0 && window.requestAnimationFrame) {
    var getHeaderHeight = function getHeaderHeight() {
      headerHeight = mainNav[0].offsetHeight;
    };

    var initSecondaryNav = function initSecondaryNav() {
      // if there's a secondary nav, set its top equal to the header height
      if (subNav.length < 1 || mainNav.length < 1) return;
      subNav[0].style.top = headerHeight - 1 + 'px';
    };

    var initFixedNav = function initFixedNav() {
      if (!navIsFixed || mainNav.length < 1) return;
      mainNav[0].style.marginBottom = '-' + headerHeight + 'px';
    };

    var resetHideNav = function resetHideNav() {
      // check if navs need to be hidden/revealed
      currentTop = window.scrollY;

      if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
        hideNavScrollDown();
      } else if (previousTop - currentTop > scrollDelta || previousTop - currentTop > 0 && currentTop < scrollOffset) {
        hideNavScrollUp();
      } else if (previousTop - currentTop > 0 && subNav.length > 0 && subNav[0].getBoundingClientRect().top > 0) {
        setTranslate(subNav[0], '0%');
      } // if primary nav is fixed -> toggle bg class


      if (navIsFixed) {
        var scrollTop = window.scrollY || window.pageYOffset;
        Util.toggleClass(mainNav[0], 'hide-nav--has-bg', scrollTop > headerHeight + mainNavTop);
      }

      previousTop = currentTop;
      scrolling = false;
    };

    var hideNavScrollDown = function hideNavScrollDown() {
      // if there's a secondary nav -> it has to reach the top before hiding nav
      if (subNav.length > 0 && subNav[0].getBoundingClientRect().top > headerHeight) return; // on mobile -> hide navigation only if dropdown is not open

      if (triggerMobile && triggerMobile.getAttribute('aria-expanded') == "true") return; // check if main nav has one of the following classes

      if (mainNav.length > 0 && (!navOpenClasses || !checkNavExpanded())) {
        setTranslate(mainNav[0], '-100%', '0');
        mainNav[0].addEventListener('transitionend', addOffCanvasClass);
      }

      if (subNav.length > 0) setTranslate(subNav[0], '-' + headerHeight + 'px');
    };

    var hideNavScrollUp = function hideNavScrollUp() {
      if (mainNav.length > 0) {
        setTranslate(mainNav[0], '0%', '1');
        Util.removeClass(mainNav[0], 'hide-nav--off-canvas');
        mainNav[0].removeEventListener('transitionend', addOffCanvasClass);
      }

      if (subNav.length > 0) setTranslate(subNav[0], '0%', '1');
    };

    var addOffCanvasClass = function addOffCanvasClass() {
      mainNav[0].removeEventListener('transitionend', addOffCanvasClass);
      Util.addClass(mainNav[0], 'hide-nav--off-canvas');
    };

    var setTranslate = function setTranslate(element, val, opa) {
      element.style.transform = 'translateY(' + val + ')';
      element.style.opacity = opa;
    };

    var getTriggerMobileMenu = function getTriggerMobileMenu() {
      // store trigger that toggle mobile navigation dropdown
      var triggerMobileClass = hidingNav[0].getAttribute('data-mobile-trigger');
      if (!triggerMobileClass) return false;

      if (triggerMobileClass.indexOf('#') == 0) {
        // get trigger by ID
        var trigger = document.getElementById(triggerMobileClass.replace('#', ''));
        if (trigger) return trigger;
      } else {
        // get trigger by class name
        var trigger = hidingNav[0].getElementsByClassName(triggerMobileClass);
        if (trigger.length > 0) return trigger[0];
      }

      return false;
    };

    var createPrevElement = function createPrevElement() {
      // create element to be inserted right before the mainNav to get its top value
      if (mainNav.length < 1) return false;
      var newElement = document.createElement("div");
      newElement.setAttribute('aria-hidden', 'true');
      mainNav[0].parentElement.insertBefore(newElement, mainNav[0]);
      var prevElement = mainNav[0].previousElementSibling;
      prevElement.style.opacity = '0';
      return prevElement;
    };

    var getMainNavTop = function getMainNavTop() {
      if (!prevElement) return;
      mainNavTop = prevElement.getBoundingClientRect().top + window.scrollY;
    };

    var checkNavExpanded = function checkNavExpanded() {
      var navIsOpen = false;

      for (var i = 0; i < navOpenArrayClasses.length; i++) {
        if (Util.hasClass(mainNav[0], navOpenArrayClasses[i].trim())) {
          navIsOpen = true;
          break;
        }
      }

      return navIsOpen;
    };

    var mainNav = Array.prototype.filter.call(hidingNav, function (element) {
      return Util.hasClass(element, 'js-hide-nav--main');
    }),
        subNav = Array.prototype.filter.call(hidingNav, function (element) {
      return Util.hasClass(element, 'js-hide-nav--sub');
    });
    var scrolling = false,
        previousTop = window.scrollY,
        currentTop = window.scrollY,
        scrollDelta = 10,
        scrollOffset = 150,
        // scrollY needs to be bigger than scrollOffset to hide navigation
    headerHeight = 0;
    var navIsFixed = false; // check if main navigation is fixed

    if (mainNav.length > 0 && Util.hasClass(mainNav[0], 'hide-nav--fixed')) navIsFixed = true; // store button that triggers navigation on mobile

    var triggerMobile = getTriggerMobileMenu();
    var prevElement = createPrevElement();
    var mainNavTop = 0; // list of classes the hide-nav has when it is expanded -> do not hide if it has those classes

    var navOpenClasses = hidingNav[0].getAttribute('data-nav-target-class'),
        navOpenArrayClasses = [];
    if (navOpenClasses) navOpenArrayClasses = navOpenClasses.split(' ');
    getMainNavTop();

    if (mainNavTop > 0) {
      scrollOffset = scrollOffset + mainNavTop;
    } // init navigation and listen to window scroll event


    getHeaderHeight();
    initSecondaryNav();
    initFixedNav();
    resetHideNav();
    window.addEventListener('scroll', function (event) {
      if (scrolling) return;
      scrolling = true;
      window.requestAnimationFrame(resetHideNav);
    });
    window.addEventListener('resize', function (event) {
      if (scrolling) return;
      scrolling = true;
      window.requestAnimationFrame(function () {
        if (headerHeight > 0) {
          getMainNavTop();
          getHeaderHeight();
          initSecondaryNav();
          initFixedNav();
        } // reset both navigation


        hideNavScrollUp();
        scrolling = false;
      });
    });
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
  } else {
    // if window requestAnimationFrame is not supported -> add bg class to fixed header
    var mainNav = document.getElementsByClassName('js-hide-nav--main');
    if (mainNav.length < 1) return;
    if (Util.hasClass(mainNav[0], 'hide-nav--fixed')) Util.addClass(mainNav[0], 'hide-nav--has-bg');
  }
})(); // File#: _1_lazy-load
// Usage: codyhouse.co/license


(function () {
  var LazyLoad = function LazyLoad(elements) {
    this.elements = elements;
    initLazyLoad(this);
  };

  function initLazyLoad(asset) {
    if (lazySupported) setAssetsSrc(asset);else if (intersectionObsSupported) observeAssets(asset);else scrollAsset(asset);
  }

  ;

  function setAssetsSrc(asset) {
    for (var i = 0; i < asset.elements.length; i++) {
      if (asset.elements[i].getAttribute('data-bg') || asset.elements[i].tagName.toLowerCase() == 'picture') {
        // this could be an element with a bg image or a <source> element inside a <picture>
        observeSingleAsset(asset.elements[i]);
      } else {
        setSingleAssetSrc(asset.elements[i]);
      }
    }
  }

  ;

  function setSingleAssetSrc(img) {
    if (img.tagName.toLowerCase() == 'picture') {
      setPictureSrc(img);
    } else {
      setSrcSrcset(img);
      var bg = img.getAttribute('data-bg');
      if (bg) img.style.backgroundImage = bg;
      if (!lazySupported || bg) img.removeAttribute("loading");
    }
  }

  ;

  function setPictureSrc(picture) {
    var pictureChildren = picture.children;

    for (var i = 0; i < pictureChildren.length; i++) {
      setSrcSrcset(pictureChildren[i]);
    }

    picture.removeAttribute("loading");
  }

  ;

  function setSrcSrcset(img) {
    var src = img.getAttribute('data-src');
    if (src) img.src = src;
    var srcset = img.getAttribute('data-srcset');
    if (srcset) img.srcset = srcset;
  }

  ;

  function observeAssets(asset) {
    for (var i = 0; i < asset.elements.length; i++) {
      observeSingleAsset(asset.elements[i]);
    }
  }

  ;

  function observeSingleAsset(img) {
    if (!img.getAttribute('data-src') && !img.getAttribute('data-srcset') && !img.getAttribute('data-bg') && img.tagName.toLowerCase() != 'picture') return; // using the native lazyload with no need js lazy-loading

    var threshold = img.getAttribute('data-threshold') || '0px';
    var config = {
      rootMargin: threshold
    };
    var observer = new IntersectionObserver(observerLoadContent.bind(img), config);
    observer.observe(img);
  }

  ;

  function observerLoadContent(entries, observer) {
    if (entries[0].isIntersecting) {
      setSingleAssetSrc(this);
      observer.unobserve(this);
    }
  }

  ;

  function scrollAsset(asset) {
    asset.elements = Array.prototype.slice.call(asset.elements);
    asset.listening = false;
    asset.scrollListener = eventLazyLoad.bind(asset);
    document.addEventListener("scroll", asset.scrollListener);
    asset.resizeListener = eventLazyLoad.bind(asset);
    document.addEventListener("resize", asset.resizeListener);
    eventLazyLoad.bind(asset)(); // trigger before starting scrolling/resizing
  }

  ;

  function eventLazyLoad() {
    var self = this;
    if (self.listening) return;
    self.listening = true;
    setTimeout(function () {
      for (var i = 0; i < self.elements.length; i++) {
        if (self.elements[i].getBoundingClientRect().top <= window.innerHeight && self.elements[i].getBoundingClientRect().bottom >= 0 && getComputedStyle(self.elements[i]).display !== "none") {
          setSingleAssetSrc(self.elements[i]);
          self.elements = self.elements.filter(function (image) {
            return image.hasAttribute("loading");
          });

          if (self.elements.length === 0) {
            if (self.scrollListener) document.removeEventListener("scroll", self.scrollListener);
            if (self.resizeListener) window.removeEventListener("resize", self.resizeListener);
          }
        }
      }

      self.listening = false;
    }, 200);
  }

  ;
  window.LazyLoad = LazyLoad;
  var lazyLoads = document.querySelectorAll('[loading="lazy"]'),
      lazySupported = ('loading' in HTMLImageElement.prototype),
      intersectionObsSupported = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;

  if (lazyLoads.length > 0) {
    new LazyLoad(lazyLoads);
  }

  ;
})(); // mega-header


(function () {
  var header = document.querySelector('#shopify-section-mega-header');
  var dynamicImages = header.querySelectorAll('[loading="lazy"]'); // dynamically added content

  new LazyLoad(dynamicImages);
  var searchBar = header.querySelector("#search");
  var navBar = header.querySelector("#main-nav");

  if (searchBar) {
    searchBar.addEventListener("click", function (e) {
      e.preventDefault();
      var searchTrigger = document.querySelector('[aria-controls="' + e.currentTarget.getAttribute('id') + '"]');

      if (Util.hasClass(searchTrigger, 'search__slide-in')) {
        Util.removeClass(searchTrigger, 'search__slide-in');
        Util.removeClass(navBar, 'hide');
        e.currentTarget.querySelector('.search-icon').style.display = 'contents';
        e.currentTarget.querySelector('.close-icon').style.display = 'none';
      } else {
        Util.addClass(searchTrigger, 'search__slide-in');
        Util.addClass(navBar, 'hide');
        e.currentTarget.querySelector('.search-icon').style.display = 'none';
        e.currentTarget.querySelector('.close-icon').style.display = 'contents';
      }
    });
  }
})(); // File#: _1_modal-window
// Usage: codyhouse.co/license


(function () {
  var Modal = function Modal(element) {
    this.element = element;
    this.triggers = document.querySelectorAll('[aria-controls="' + this.element.getAttribute('id') + '"]');
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.moveFocusEl = null; // focus will be moved to this element when modal is open

    this.modalFocus = this.element.getAttribute('data-modal-first-focus') ? this.element.querySelector(this.element.getAttribute('data-modal-first-focus')) : null;
    this.selectedTrigger = null;
    this.preventScrollEl = this.getPreventScrollEl();
    this.showClass = "modal--is-visible";
    this.moveModal = 'modal--need-container';
    this.initModal();
  };

  Modal.prototype.getPreventScrollEl = function () {
    var scrollEl = false;
    var querySelector = this.element.getAttribute('data-modal-prevent-scroll');
    if (querySelector) scrollEl = document.querySelector(querySelector);
    return scrollEl;
  };

  Modal.prototype.initModal = function () {
    var self = this; //open modal when clicking on trigger buttons

    if (this.triggers) {
      for (var i = 0; i < this.triggers.length; i++) {
        this.triggers[i].addEventListener('click', function (event) {
          event.preventDefault();

          if (Util.hasClass(self.element, self.showClass)) {
            self.closeModal();
            return;
          }

          if (Util.hasClass(self.element, self.moveModal)) {
            var fragment = document.createDocumentFragment();
            fragment.appendChild(self.element);
            document.getElementById('mobile-overlay__store').appendChild(fragment);
          }

          self.selectedTrigger = event.target;
          self.showModal();
          self.initModalEvents();
        });
      }
    } // listen to the openModal event -> open modal without a trigger button


    this.element.addEventListener('openModal', function (event) {
      if (event.detail) self.selectedTrigger = event.detail;
      self.showModal();
      self.initModalEvents();
    }); // listen to the closeModal event -> close modal without a trigger button

    this.element.addEventListener('closeModal', function (event) {
      if (event.detail) self.selectedTrigger = event.detail;
      self.closeModal();
    }); // if modal is open by default -> initialise modal events

    if (Util.hasClass(this.element, this.showClass)) this.initModalEvents();
  };

  Modal.prototype.showModal = function () {
    var self = this;
    Util.addClass(this.element, this.showClass);
    this.getFocusableElements();

    if (this.moveFocusEl) {
      this.moveFocusEl.focus(); // wait for the end of transitions before moving focus

      this.element.addEventListener("transitionend", function cb(event) {
        self.moveFocusEl.focus();
        self.element.removeEventListener("transitionend", cb);
      });
    }

    this.emitModalEvents('modalIsOpen'); // change the overflow of the preventScrollEl

    if (this.preventScrollEl) this.preventScrollEl.style.overflow = 'hidden';
  };

  Modal.prototype.closeModal = function () {
    if (!Util.hasClass(this.element, this.showClass)) return;
    Util.removeClass(this.element, this.showClass);
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.moveFocusEl = null;
    if (this.selectedTrigger) this.selectedTrigger.focus(); //remove listeners

    this.cancelModalEvents();
    this.emitModalEvents('modalIsClose'); // change the overflow of the preventScrollEl

    if (this.preventScrollEl) this.preventScrollEl.style.overflow = '';

    if (Util.hasClass(this.element, this.moveModal)) {
      var fragment = document.createDocumentFragment();
      fragment.appendChild(this.element);
      var parent = document.querySelector('[aria-controls="' + this.element.getAttribute('id') + '"]').parentNode;
      parent.appendChild(fragment);
      document.getElementById('mobile-overlay__store').innerHTML = "";
    }
  };

  Modal.prototype.initModalEvents = function () {
    //add event listeners
    this.element.addEventListener('keydown', this);
    this.element.addEventListener('click', this);
  };

  Modal.prototype.cancelModalEvents = function () {
    //remove event listeners
    this.element.removeEventListener('keydown', this);
    this.element.removeEventListener('click', this);
  };

  Modal.prototype.handleEvent = function (event) {
    switch (event.type) {
      case 'click':
        {
          this.initClick(event);
        }

      case 'keydown':
        {
          this.initKeyDown(event);
        }
    }
  };

  Modal.prototype.initKeyDown = function (event) {
    if (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab') {
      //trap focus inside modal
      this.trapFocus(event);
    } else if ((event.keyCode && event.keyCode == 13 || event.key && event.key == 'Enter') && event.target.closest('.js-modal__close')) {
      event.preventDefault();
      this.closeModal(); // close modal when pressing Enter on close button
    }
  };

  Modal.prototype.initClick = function (event) {
    //close modal when clicking on close button or modal bg layer 
    if (!event.target.closest('.js-modal__close') && !Util.hasClass(event.target, 'js-modal') || Util.hasClass(event.target, 'js-modal__noClose')) return;
    event.preventDefault();
    this.closeModal();
  };

  Modal.prototype.trapFocus = function (event) {
    if (this.firstFocusable == document.activeElement && event.shiftKey) {
      //on Shift+Tab -> focus last focusable element when focus moves out of modal
      event.preventDefault();
      this.lastFocusable.focus();
    }

    if (this.lastFocusable == document.activeElement && !event.shiftKey) {
      //on Tab -> focus first focusable element when focus moves out of modal
      event.preventDefault();
      this.firstFocusable.focus();
    }
  };

  Modal.prototype.getFocusableElements = function () {
    //get all focusable elements inside the modal
    var allFocusable = this.element.querySelectorAll(focusableElString);
    this.getFirstVisible(allFocusable);
    this.getLastVisible(allFocusable);
    this.getFirstFocusable();
  };

  Modal.prototype.getFirstVisible = function (elements) {
    //get first visible focusable element inside the modal
    for (var i = 0; i < elements.length; i++) {
      if (isVisible(elements[i])) {
        this.firstFocusable = elements[i];
        break;
      }
    }
  };

  Modal.prototype.getLastVisible = function (elements) {
    //get last visible focusable element inside the modal
    for (var i = elements.length - 1; i >= 0; i--) {
      if (isVisible(elements[i])) {
        this.lastFocusable = elements[i];
        break;
      }
    }
  };

  Modal.prototype.getFirstFocusable = function () {
    if (!this.modalFocus || !Element.prototype.matches) {
      this.moveFocusEl = this.firstFocusable;
      return;
    }

    var containerIsFocusable = this.modalFocus.matches(focusableElString);

    if (containerIsFocusable) {
      this.moveFocusEl = this.modalFocus;
    } else {
      this.moveFocusEl = false;
      var elements = this.modalFocus.querySelectorAll(focusableElString);

      for (var i = 0; i < elements.length; i++) {
        if (isVisible(elements[i])) {
          this.moveFocusEl = elements[i];
          break;
        }
      }

      if (!this.moveFocusEl) this.moveFocusEl = this.firstFocusable;
    }
  };

  Modal.prototype.emitModalEvents = function (eventName) {
    var event = new CustomEvent(eventName, {
      detail: this.selectedTrigger
    });
    this.element.dispatchEvent(event);
  };

  function isVisible(element) {
    return element.offsetWidth || element.offsetHeight || element.getClientRects().length;
  }

  ;
  window.Modal = Modal; //initialize the Modal objects

  var modals = document.getElementsByClassName('js-modal'); // generic focusable elements string selector

  var focusableElString = '[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary';

  if (modals.length > 0) {
    var modalArrays = [];

    for (var i = 0; i < modals.length; i++) {
      (function (i) {
        modalArrays.push(new Modal(modals[i]));
      })(i);
    }

    window.addEventListener('keydown', function (event) {
      //close modal window on esc
      if (event.keyCode && event.keyCode == 27 || event.key && event.key.toLowerCase() == 'escape') {
        for (var i = 0; i < modalArrays.length; i++) {
          (function (i) {
            modalArrays[i].closeModal();
          })(i);
        }

        ;
      }
    });
  }
})();

(function () {
  var multiSelect = document.querySelectorAll(".multi-select");
  multiSelect.forEach(function (element) {
    // element refers to the DOM node
    var parent = element;
    parent.querySelector('.multi-select__button').addEventListener('click', function (e) {
      if (Util.hasClass(e.currentTarget.nextElementSibling, 'multi-select__options-show')) {
        e.currentTarget.nextElementSibling.classList.remove('multi-select__options-show');
        return;
      }

      if (document.querySelector('.multi-select__options-show')) {
        document.querySelector('.multi-select__options-show').classList.remove('multi-select__options-show');
      }

      parent.querySelector('.multi-select__options').classList.add('multi-select__options-show');
    });
  });
  var selectOptions = document.querySelector('.multi-select__options');
})(); // File#: _1_number-input
// Usage: codyhouse.co/license


var InputNumber = function InputNumber(element) {
  this.element = element;
  this.input = this.element.getElementsByClassName('js-number-input__value')[0];
  this.min = parseFloat(this.input.getAttribute('min'));
  this.max = parseFloat(this.input.getAttribute('max'));
  this.step = parseFloat(this.input.getAttribute('step'));
  if (isNaN(this.step)) this.step = 1;
  this.precision = getStepPrecision(this.step);
  initInputNumberEvents(this);
};

function initInputNumberEvents(input) {
  // listen to the click event on the custom increment buttons
  input.element.addEventListener('click', function (event) {
    event.preventDefault();
    var increment = event.target.closest('.js-number-input__btn');

    if (increment) {
      event.preventDefault();
      updateInputNumber(input, increment);
    }
  }); // when input changes, make sure the new value is acceptable

  input.input.addEventListener('focusout', function (event) {
    var value = parseFloat(input.input.value);
    if (value < input.min) value = input.min;
    if (value > input.max) value = input.max; // check value is multiple of step

    value = checkIsMultipleStep(input, value);
    if (value != parseFloat(input.input.value)) input.input.value = value;
  });
}

;

function getStepPrecision(step) {
  // if step is a floating number, return its precision
  return step.toString().length - Math.floor(step).toString().length - 1;
}

;

function updateInputNumber(input, btn) {
  var value = Util.hasClass(btn, 'number-input__btn--plus') ? parseFloat(input.input.value) + input.step : parseFloat(input.input.value) - input.step;
  if (input.precision > 0) value = value.toFixed(input.precision);
  if (value < input.min) value = input.min;
  if (value > input.max) value = input.max;
  input.input.value = value;
  input.input.dispatchEvent(new CustomEvent('change', {
    bubbles: false
  })); // trigger change event
}

;

function checkIsMultipleStep(input, value) {
  // check if the number inserted is a multiple of the step value
  var remain = value * 10 * input.precision % (input.step * 10 * input.precision);
  if (remain != 0) value = value - remain;
  if (input.precision > 0) value = value.toFixed(input.precision);
  return value;
}

; //initialize the InputNumber objects

var inputNumbers = document.getElementsByClassName('js-number-input');

if (inputNumbers.length > 0) {
  for (var i = 0; i < inputNumbers.length; i++) {
    (function (i) {
      new InputNumber(inputNumbers[i]);
    })(i);
  }
} // File#: _1_parallax-image
// Usage: codyhouse.co/license


(function () {
  var ParallaxImg = function ParallaxImg(element, rotationLevel) {
    this.element = element;
    this.figure = this.element.getElementsByClassName('js-parallax-img__assets')[0];
    this.imgs = this.element.getElementsByTagName('img');
    this.maxRotation = rotationLevel || 2; // rotate level

    if (this.maxRotation > 5) this.maxRotation = 5;
    this.scale = 1;
    this.animating = false;
    initParallax(this);
    initParallaxEvents(this);
  };

  function initParallax(element) {
    element.count = 0;
    window.requestAnimationFrame(checkImageLoaded.bind(element));

    for (var i = 0; i < element.imgs.length; i++) {
      (function (i) {
        var loaded = false;
        element.imgs[i].addEventListener('load', function () {
          if (loaded) return;
          element.count = element.count + 1;
        });

        if (element.imgs[i].complete && !loaded) {
          loaded = true;
          element.count = element.count + 1;
        }
      })(i);
    }
  }

  ;

  function checkImageLoaded() {
    if (this.count >= this.imgs.length) {
      initScale(this);

      if (this.loaded) {
        window.cancelAnimationFrame(this.loaded);
        this.loaded = false;
      }
    } else {
      this.loaded = window.requestAnimationFrame(checkImageLoaded.bind(this));
    }
  }

  ;

  function initScale(element) {
    var maxImgResize = getMaxScale(element);
    element.scale = maxImgResize / Math.sin(Math.PI / 2 - element.maxRotation * Math.PI / 180);
    element.figure.style.transform = 'scale(' + element.scale + ')';
    Util.addClass(element.element, 'parallax-img--loaded');
  }

  ;

  function getMaxScale(element) {
    var minWidth = 0;
    var maxWidth = 0;

    for (var i = 0; i < element.imgs.length; i++) {
      var width = element.imgs[i].getBoundingClientRect().width;
      if (width < minWidth || i == 0) minWidth = width;
      if (width > maxWidth || i == 0) maxWidth = width;
    }

    var scale = Math.ceil(10 * maxWidth / minWidth) / 10;
    if (scale < 1.1) scale = 1.1;
    return scale;
  }

  function initParallaxEvents(element) {
    element.element.addEventListener('mousemove', function (event) {
      if (element.animating) return;
      element.animating = true;
      window.requestAnimationFrame(moveImage.bind(element, event));
    });
  }

  ;

  function moveImage(event, timestamp) {
    var wrapperPosition = this.element.getBoundingClientRect();
    var rotateY = 2 * (this.maxRotation / wrapperPosition.width) * (wrapperPosition.left - event.clientX + wrapperPosition.width / 2);
    var rotateX = 2 * (this.maxRotation / wrapperPosition.height) * (event.clientY - wrapperPosition.top - wrapperPosition.height / 2);
    if (rotateY > this.maxRotation) rotateY = this.maxRotation;
    if (rotateY < -1 * this.maxRotation) rotateY = -this.maxRotation;
    if (rotateX > this.maxRotation) rotateX = this.maxRotation;
    if (rotateX < -1 * this.maxRotation) rotateX = -this.maxRotation;
    this.figure.style.transform = 'scale(' + this.scale + ') rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
    this.animating = false;
  }

  ;
  window.ParallaxImg = ParallaxImg; //initialize the ParallaxImg objects

  var parallaxImgs = document.getElementsByClassName('js-parallax-img');

  if (parallaxImgs.length > 0 && Util.cssSupports('transform', 'translateZ(0px)')) {
    for (var i = 0; i < parallaxImgs.length; i++) {
      (function (i) {
        var rotationLevel = parallaxImgs[i].getAttribute('data-perspective');
        new ParallaxImg(parallaxImgs[i], rotationLevel);
      })(i);
    }
  }

  ;
})(); // File#: _1_pre-header
// Usage: codyhouse.co/license


(function () {
  var preHeader = document.getElementsByClassName('js-pre-header');

  if (preHeader.length > 0) {
    var i;

    (function () {
      var addPreHeaderEvent = function addPreHeaderEvent(element) {
        var close = element.getElementsByClassName('js-pre-header__close-btn')[0];

        if (close) {
          close.addEventListener('click', function (event) {
            event.preventDefault();
            Util.addClass(element, 'pre-header--is-hidden');
          });
        }
      };

      for (i = 0; i < preHeader.length; i++) {
        (function (i) {
          addPreHeaderEvent(preHeader[i]);
        })(i);
      }
    })();
  }
})();

(function ($) {
  $('.card-information__text').each(function () {
    console.log('fire');
    var string = $(this).html();
    string = string.replace(/ ([^ ]*)$/, ' $1');
    $(this).html(string);
  });
})(jQuery);

var QuickAddSelects = /*#__PURE__*/function (_HTMLElement) {
  _inherits(QuickAddSelects, _HTMLElement);

  var _super = _createSuper(QuickAddSelects);

  function QuickAddSelects() {
    var _this2;

    _classCallCheck(this, QuickAddSelects);

    _this2 = _super.call(this);

    _this2.addEventListener('change', _this2.onVariantChange);

    return _this2;
  }

  _createClass(QuickAddSelects, [{
    key: "onVariantChange",
    value: function onVariantChange() {
      this.updateOptions();
      this.updateMasterId(); // this.toggleAddButton(true, '', false);

      if (!this.currentVariant) {} else {
        this.updatePricing();
        this.updateVariantInput();
      }
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      var selected_Options = [];
      var productForm = document.querySelector("#".concat(this.dataset.form));
      var productOptions = productForm.querySelectorAll('.quick-add__option');
      productOptions.forEach(function (productOption) {
        if (productOption.type === 'radio' && productOption.checked) {
          selected_Options.push(productOption.value);
        }

        if (productOption.type === 'select-one') {
          selected_Options.push(productOption.value);
        }
      });
      this.options = selected_Options;
    }
  }, {
    key: "updateMasterId",
    value: function updateMasterId() {
      var _this3 = this;

      this.currentVariant = this.getVariantData().find(function (variant) {
        return !variant.options.map(function (option, index) {
          return _this3.options[index] === option;
        }).includes(false);
      });
    }
  }, {
    key: "updatePricing",
    value: function updatePricing() {
      var productForm = document.querySelector("#".concat(this.dataset.form));
      var productFormButton = productForm.querySelector('button[type="submit"]');
      var productFormButtonText = productFormButton.querySelector('.btn__content-a').textContent.split(" - ");
      var formattedMoney = Shopify.formatMoney(this.currentVariant.price, window.shippingAlerts.currency_format);
      var productFormButtonTextFinal = productFormButtonText[0] + ' - ' + formattedMoney;
      productFormButton.querySelector('.btn__content-a').innerHTML = productFormButtonTextFinal;
    }
  }, {
    key: "updateVariantInput",
    value: function updateVariantInput() {
      var productForm = document.querySelector("#".concat(this.dataset.form));
      var input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change'));
    }
  }, {
    key: "getVariantData",
    value: function getVariantData() {
      var productForms = document.querySelector("#".concat(this.dataset.form));
      console.log(productForms);
      this.variantData = this.variantData || JSON.parse(productForms.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }]);

  return QuickAddSelects;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('quick-add-select', QuickAddSelects);

var QuickAddRadios = /*#__PURE__*/function (_QuickAddSelects) {
  _inherits(QuickAddRadios, _QuickAddSelects);

  var _super2 = _createSuper(QuickAddRadios);

  function QuickAddRadios() {
    _classCallCheck(this, QuickAddRadios);

    return _super2.call(this);
  }

  return _createClass(QuickAddRadios);
}(QuickAddSelects);

customElements.define('quick-add-radios', QuickAddRadios);

var wrappedToggle = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(wrappedToggle, _HTMLElement2);

  var _super3 = _createSuper(wrappedToggle);

  function wrappedToggle() {
    var _this4;

    _classCallCheck(this, wrappedToggle);

    _this4 = _super3.call(this);

    _this4.addEventListener('change', _this4.onVariantChange);

    return _this4;
  }

  _createClass(wrappedToggle, [{
    key: "onVariantChange",
    value: function onVariantChange() {
      this.updateImage();
      this.updateUrl();
      this.updateQuickAdd();
    }
  }, {
    key: "updateImage",
    value: function updateImage() {
      var product_Option = this.querySelector('.radio-switch-v2__input:checked').value;
      var selectedVariant = this.getVariantData().find(function (variant) {
        return variant.option1 == product_Option;
      });
      var image_src = selectedVariant.featured_image.src;
      this.parentElement.querySelector('.variant_image').srcset = image_src + '?crop=center&height=440&width=440';
    }
  }, {
    key: "updateQuickAdd",
    value: function updateQuickAdd() {
      var product_Option = this.querySelector('.radio-switch-v2__input:checked').dataset.value;
      var QuickAdd = this.parentElement.querySelector('quick-add-radios');
      QuickAdd.querySelector("input[data-value=".concat(product_Option, "]")).checked = true;
      this.parentElement.querySelector('[aria-checked=true]').setAttribute("aria-checked", false);
      QuickAdd.querySelector("input[data-value=".concat(product_Option, "]")).parentElement.parentElement.setAttribute("aria-checked", true);
      QuickAdd.querySelector("input[data-value=".concat(product_Option, "]")).dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }
  }, {
    key: "updateUrl",
    value: function updateUrl() {
      var product_Option = this.querySelector('.radio-switch-v2__input:checked').value;
      var selectedVariant = this.getVariantData().find(function (variant) {
        return variant.option1 == product_Option;
      });
      var product_url = this.parentElement.querySelector('.prod-card__img-link');
      var old_variant_url = product_url.href.split('?');
      var new_variant_url = "".concat(old_variant_url[0], "?variant=").concat(selectedVariant.id);
      product_url.href = new_variant_url;
    }
  }, {
    key: "getVariantData",
    value: function getVariantData() {
      var productData = this.parentElement.querySelector('[type="application/json"]');
      this.variantData = this.variantData || JSON.parse(productData.textContent);
      return this.variantData;
    }
  }]);

  return wrappedToggle;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('wrapped-toggle', wrappedToggle); // File#: _1_responsive-sidebar
// Usage: codyhouse.co/license

(function () {
  var Sidebar = function Sidebar(element) {
    this.element = element;
    this.triggers = document.querySelectorAll('[aria-controls="' + this.element.getAttribute('id') + '"]');
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.selectedTrigger = null;
    this.showClass = "sidebar--is-visible";
    this.staticClass = "sidebar--static";
    this.customStaticClass = "";
    this.readyClass = "sidebar--loaded";
    this.layout = false; // this will be static or mobile

    getCustomStaticClass(this); // custom classes for static version

    initSidebar(this);
  };

  function getCustomStaticClass(element) {
    var customClasses = element.element.getAttribute('data-static-class');
    if (customClasses) element.customStaticClass = ' ' + customClasses;
  }

  ;

  function initSidebar(sidebar) {
    initSidebarResize(sidebar); // handle changes in layout -> mobile to static and viceversa

    if (sidebar.triggers) {
      // open sidebar when clicking on trigger buttons - mobile layout only
      for (var i = 0; i < sidebar.triggers.length; i++) {
        sidebar.triggers[i].addEventListener('click', function (event) {
          event.preventDefault();

          if (Util.hasClass(sidebar.element, sidebar.showClass)) {
            sidebar.selectedTrigger = event.target;
            closeSidebar(sidebar);
            return;
          }

          sidebar.selectedTrigger = event.target;
          showSidebar(sidebar);
          initSidebarEvents(sidebar);
        });
      }
    }
  }

  ;

  function showSidebar(sidebar) {
    // mobile layout only
    Util.addClass(sidebar.element, sidebar.showClass);
    getFocusableElements(sidebar);
    Util.moveFocus(sidebar.element);
  }

  ;

  function closeSidebar(sidebar) {
    // mobile layout only
    Util.removeClass(sidebar.element, sidebar.showClass);
    sidebar.firstFocusable = null;
    sidebar.lastFocusable = null;
    if (sidebar.selectedTrigger) sidebar.selectedTrigger.focus();
    sidebar.element.removeAttribute('tabindex'); //remove listeners

    cancelSidebarEvents(sidebar);
  }

  ;

  function initSidebarEvents(sidebar) {
    // mobile layout only
    //add event listeners
    sidebar.element.addEventListener('keydown', handleEvent.bind(sidebar));
    sidebar.element.addEventListener('click', handleEvent.bind(sidebar));
  }

  ;

  function cancelSidebarEvents(sidebar) {
    // mobile layout only
    //remove event listeners
    sidebar.element.removeEventListener('keydown', handleEvent.bind(sidebar));
    sidebar.element.removeEventListener('click', handleEvent.bind(sidebar));
  }

  ;

  function handleEvent(event) {
    // mobile layout only
    switch (event.type) {
      case 'click':
        {
          initClick(this, event);
        }

      case 'keydown':
        {
          initKeyDown(this, event);
        }
    }
  }

  ;

  function initKeyDown(sidebar, event) {
    // mobile layout only
    if (event.keyCode && event.keyCode == 27 || event.key && event.key == 'Escape') {
      //close sidebar window on esc
      closeSidebar(sidebar);
    } else if (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab') {
      //trap focus inside sidebar
      trapFocus(sidebar, event);
    }
  }

  ;

  function initClick(sidebar, event) {
    // mobile layout only
    //close sidebar when clicking on close button or sidebar bg layer 
    if (!event.target.closest('.js-sidebar__close-btn') && !Util.hasClass(event.target, 'js-sidebar')) return;
    event.preventDefault();
    closeSidebar(sidebar);
  }

  ;

  function trapFocus(sidebar, event) {
    // mobile layout only
    if (sidebar.firstFocusable == document.activeElement && event.shiftKey) {
      //on Shift+Tab -> focus last focusable element when focus moves out of sidebar
      event.preventDefault();
      sidebar.lastFocusable.focus();
    }

    if (sidebar.lastFocusable == document.activeElement && !event.shiftKey) {
      //on Tab -> focus first focusable element when focus moves out of sidebar
      event.preventDefault();
      sidebar.firstFocusable.focus();
    }
  }

  ;

  function initSidebarResize(sidebar) {
    // custom event emitted when window is resized - detect only if the sidebar--static@{breakpoint} class was added
    var beforeContent = getComputedStyle(sidebar.element, ':before').getPropertyValue('content');

    if (beforeContent && beforeContent != '' && beforeContent != 'none') {
      checkSidebarLayout(sidebar);
      sidebar.element.addEventListener('update-sidebar', function (event) {
        checkSidebarLayout(sidebar);
      });
    }

    Util.addClass(sidebar.element, sidebar.readyClass);
  }

  ;

  function checkSidebarLayout(sidebar) {
    var layout = getComputedStyle(sidebar.element, ':before').getPropertyValue('content').replace(/\'|"/g, '');
    if (layout == sidebar.layout) return;
    sidebar.layout = layout;
    if (layout != 'static') Util.addClass(sidebar.element, 'is-hidden');
    Util.toggleClass(sidebar.element, sidebar.staticClass + sidebar.customStaticClass, layout == 'static');
    if (layout != 'static') setTimeout(function () {
      Util.removeClass(sidebar.element, 'is-hidden');
    }); // reset element role 

    layout == 'static' ? sidebar.element.removeAttribute('role', 'alertdialog') : sidebar.element.setAttribute('role', 'alertdialog'); // reset mobile behaviour

    if (layout == 'static' && Util.hasClass(sidebar.element, sidebar.showClass)) closeSidebar(sidebar);
  }

  ;

  function getFocusableElements(sidebar) {
    //get all focusable elements inside the drawer
    var allFocusable = sidebar.element.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary');
    getFirstVisible(sidebar, allFocusable);
    getLastVisible(sidebar, allFocusable);
  }

  ;

  function getFirstVisible(sidebar, elements) {
    //get first visible focusable element inside the sidebar
    for (var i = 0; i < elements.length; i++) {
      if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
        sidebar.firstFocusable = elements[i];
        return true;
      }
    }
  }

  ;

  function getLastVisible(sidebar, elements) {
    //get last visible focusable element inside the sidebar
    for (var i = elements.length - 1; i >= 0; i--) {
      if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
        sidebar.lastFocusable = elements[i];
        return true;
      }
    }
  }

  ; //initialize the Sidebar objects

  var sidebar = document.getElementsByClassName('js-sidebar');

  if (sidebar.length > 0) {
    var resetLayout = function resetLayout() {
      for (var i = 0; i < sidebar.length; i++) {
        (function (i) {
          sidebar[i].dispatchEvent(customEvent);
        })(i);
      }

      ;
    };

    for (var i = 0; i < sidebar.length; i++) {
      (function (i) {
        new Sidebar(sidebar[i]);
      })(i);
    } // switch from mobile to static layout


    var customEvent = new CustomEvent('update-sidebar');
    window.addEventListener('resize', function (event) {
      !window.requestAnimationFrame ? setTimeout(function () {
        resetLayout();
      }, 250) : window.requestAnimationFrame(resetLayout);
    });
    window.requestAnimationFrame // init sidebar layout
    ? window.requestAnimationFrame(resetLayout) : resetLayout();
    ;
  }
})(); // File#: _1_reveal-effects
// Usage: codyhouse.co/license


(function () {
  var fxElements = document.getElementsByClassName('reveal-fx');
  var intersectionObserverSupported = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;

  if (fxElements.length > 0) {
    var initObserver = function initObserver() {
      for (var i = 0; i < fxElements.length; i++) {
        observer[i] = new IntersectionObserver(function (entries, observer) {
          if (entries[0].isIntersecting) {
            fxRevealItemObserver(entries[0].target);
            observer.unobserve(entries[0].target);
          }
        }, {
          rootMargin: "0px 0px -" + fxElementDeltas[i] + "px 0px"
        });
        observer[i].observe(fxElements[i]);
      }
    };

    var fxRevealAll = function fxRevealAll() {
      // reveal all elements - small devices
      for (var i = 0; i < fxElements.length; i++) {
        Util.addClass(fxElements[i], 'reveal-fx--is-visible');
      }
    };

    var fxResize = function fxResize() {
      // on resize - check new window height and reveal visible elements
      if (fxChecking) return;
      fxChecking = true;
      !window.requestAnimationFrame ? setTimeout(function () {
        fxReset();
      }, 0) : window.requestAnimationFrame(fxReset);
    };

    var fxReset = function fxReset() {
      viewportHeight = window.innerHeight;
      fxReveal();
    };

    var fxReveal = function fxReveal() {
      // reveal visible elements
      for (var i = 0; i < fxElements.length; i++) {
        (function (i) {
          if (fxRevealedItems.indexOf(i) != -1) return; //element has already been revelead

          if (fxElementIsVisible(fxElements[i], i)) {
            fxRevealItem(i);
            fxRevealedItems.push(i);
          }
        })(i);
      }

      fxResetEvents();
      fxChecking = false;
    };

    var fxRevealItem = function fxRevealItem(index) {
      if (fxElementDelays[index] && fxElementDelays[index] != 0) {
        // wait before revealing element if a delay was added
        setTimeout(function () {
          Util.addClass(fxElements[index], 'reveal-fx--is-visible');
        }, fxElementDelays[index]);
      } else {
        Util.addClass(fxElements[index], 'reveal-fx--is-visible');
      }
    };

    var fxRevealItemObserver = function fxRevealItemObserver(item) {
      var index = Util.getIndexInArray(fxElements, item);
      if (fxRevealedItems.indexOf(index) != -1) return; //element has already been revelead

      fxRevealItem(index);
      fxRevealedItems.push(index);
      fxResetEvents();
      fxChecking = false;
    };

    var fxGetDelays = function fxGetDelays() {
      // get anmation delays
      var delays = [];

      for (var i = 0; i < fxElements.length; i++) {
        delays.push(fxElements[i].getAttribute('data-reveal-fx-delay') ? parseInt(fxElements[i].getAttribute('data-reveal-fx-delay')) : 0);
      }

      return delays;
    };

    var fxGetDeltas = function fxGetDeltas() {
      // get reveal delta
      var deltas = [];

      for (var i = 0; i < fxElements.length; i++) {
        deltas.push(fxElements[i].getAttribute('data-reveal-fx-delta') ? parseInt(fxElements[i].getAttribute('data-reveal-fx-delta')) : fxRevealDelta);
      }

      return deltas;
    };

    var fxDisabled = function fxDisabled(element) {
      // check if elements need to be animated - no animation on small devices
      return !(window.getComputedStyle(element, '::before').getPropertyValue('content').replace(/'|"/g, "") == 'reveal-fx');
    };

    var fxElementIsVisible = function fxElementIsVisible(element, i) {
      // element is inside viewport
      return fxGetElementPosition(element) <= viewportHeight - fxElementDeltas[i];
    };

    var fxGetElementPosition = function fxGetElementPosition(element) {
      // get top position of element
      return element.getBoundingClientRect().top;
    };

    var fxResetEvents = function fxResetEvents() {
      if (fxElements.length > fxRevealedItems.length) return; // remove event listeners if all elements have been revealed

      window.removeEventListener('load', fxReveal);
      window.removeEventListener('resize', fxResize);
    };

    var fxRemoveClasses = function fxRemoveClasses() {
      // Reduced Motion on or Intersection Observer not supported
      while (fxElements[0]) {
        // remove all classes starting with 'reveal-fx--'
        var classes = fxElements[0].getAttribute('class').split(" ").filter(function (c) {
          return c.lastIndexOf('reveal-fx--', 0) !== 0;
        });
        fxElements[0].setAttribute('class', classes.join(" ").trim());
        Util.removeClass(fxElements[0], 'reveal-fx');
      }
    };

    var fxRestart = function fxRestart() {
      // restart the reveal effect -> hide all elements and re-init the observer
      if (Util.osHasReducedMotion() || !intersectionObserverSupported || fxDisabled(fxElements[0])) {
        return;
      } // check if we need to add the event listensers back


      if (fxElements.length <= fxRevealedItems.length) {
        window.addEventListener('load', fxReveal);
        window.addEventListener('resize', fxResize);
      } // remove observer and reset the observer array


      for (var i = 0; i < observer.length; i++) {
        if (observer[i]) observer[i].disconnect();
      }

      observer = []; // remove visible class

      for (var i = 0; i < fxElements.length; i++) {
        Util.removeClass(fxElements[i], 'reveal-fx--is-visible');
      } // reset fxRevealedItems array


      fxRevealedItems = []; // restart observer

      initObserver();
    };

    // deactivate effect if Reduced Motion is enabled
    if (Util.osHasReducedMotion() || !intersectionObserverSupported) {
      fxRemoveClasses();
      return;
    } //on small devices, do not animate elements -> reveal all


    if (fxDisabled(fxElements[0])) {
      fxRevealAll();
      return;
    }

    var fxRevealDelta = 120; // amount (in pixel) the element needs to enter the viewport to be revealed - if not custom value (data-reveal-fx-delta)

    var viewportHeight = window.innerHeight,
        fxChecking = false,
        fxRevealedItems = [],
        fxElementDelays = fxGetDelays(),
        //elements animation delay
    fxElementDeltas = fxGetDeltas(); // amount (in px) the element needs enter the viewport to be revealed (default value is fxRevealDelta) 
    // add event listeners

    window.addEventListener('load', fxReveal);
    window.addEventListener('resize', fxResize);
    window.addEventListener('restartAll', fxRestart); // observe reveal elements

    var observer = [];
    initObserver();
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
    ;
  }
})(); // File#: _1_smooth-scrolling
// Usage: codyhouse.co/license


(function () {
  var SmoothScroll = function SmoothScroll(element) {
    if (!('CSS' in window) || !CSS.supports('color', 'var(--color-var)')) return;
    this.element = element;
    this.scrollDuration = parseInt(this.element.getAttribute('data-duration')) || 300;
    this.dataElementY = this.element.getAttribute('data-scrollable-element-y') || this.element.getAttribute('data-scrollable-element') || this.element.getAttribute('data-element');
    this.scrollElementY = this.dataElementY ? document.querySelector(this.dataElementY) : window;
    this.dataElementX = this.element.getAttribute('data-scrollable-element-x');
    this.scrollElementX = this.dataElementY ? document.querySelector(this.dataElementX) : window;
    this.initScroll();
  };

  SmoothScroll.prototype.initScroll = function () {
    var self = this; //detect click on link

    this.element.addEventListener('click', function (event) {
      event.preventDefault();
      var targetId = event.target.closest('.js-smooth-scroll').getAttribute('href').replace('#', ''),
          target = document.getElementById(targetId),
          targetTabIndex = target.getAttribute('tabindex'),
          windowScrollTop = self.scrollElementY.scrollTop || document.documentElement.scrollTop; // scroll vertically

      if (!self.dataElementY) windowScrollTop = window.scrollY || document.documentElement.scrollTop;
      var scrollElementY = self.dataElementY ? self.scrollElementY : false;
      var fixedHeight = self.getFixedElementHeight(); // check if there's a fixed element on the page

      Util.scrollTo(target.getBoundingClientRect().top + windowScrollTop - fixedHeight, self.scrollDuration, function () {
        // scroll horizontally
        self.scrollHorizontally(target, fixedHeight); //move the focus to the target element - don't break keyboard navigation

        Util.moveFocus(target);
        history.pushState(false, false, '#' + targetId);
        self.resetTarget(target, targetTabIndex);
      }, scrollElementY);
    });
  };

  SmoothScroll.prototype.scrollHorizontally = function (target, delta) {
    var scrollEl = this.dataElementX ? this.scrollElementX : false;
    var windowScrollLeft = this.scrollElementX ? this.scrollElementX.scrollLeft : document.documentElement.scrollLeft;

    var _final2 = target.getBoundingClientRect().left + windowScrollLeft - delta,
        duration = this.scrollDuration;

    var element = scrollEl || window;
    var start = element.scrollLeft || document.documentElement.scrollLeft,
        currentTime = null;
    if (!scrollEl) start = window.scrollX || document.documentElement.scrollLeft; // return if there's no need to scroll

    if (Math.abs(start - _final2) < 5) return;

    var animateScroll = function animateScroll(timestamp) {
      if (!currentTime) currentTime = timestamp;
      var progress = timestamp - currentTime;
      if (progress > duration) progress = duration;
      var val = Math.easeInOutQuad(progress, start, _final2 - start, duration);
      element.scrollTo({
        left: val
      });

      if (progress < duration) {
        window.requestAnimationFrame(animateScroll);
      }
    };

    window.requestAnimationFrame(animateScroll);
  };

  SmoothScroll.prototype.resetTarget = function (target, tabindex) {
    if (parseInt(target.getAttribute('tabindex')) < 0) {
      target.style.outline = 'none';
      !tabindex && target.removeAttribute('tabindex');
    }
  };

  SmoothScroll.prototype.getFixedElementHeight = function () {
    var scrollElementY = this.dataElementY ? this.scrollElementY : document.documentElement;
    var fixedElementDelta = parseInt(getComputedStyle(scrollElementY).getPropertyValue('scroll-padding'));

    if (isNaN(fixedElementDelta)) {
      // scroll-padding not supported
      fixedElementDelta = 0;
      var fixedElement = document.querySelector(this.element.getAttribute('data-fixed-element'));
      if (fixedElement) fixedElementDelta = parseInt(fixedElement.getBoundingClientRect().height);
    }

    return fixedElementDelta;
  }; //initialize the Smooth Scroll objects


  var smoothScrollLinks = document.getElementsByClassName('js-smooth-scroll');

  if (smoothScrollLinks.length > 0 && !Util.cssSupports('scroll-behavior', 'smooth') && window.requestAnimationFrame) {
    // you need javascript only if css scroll-behavior is not supported
    for (var i = 0; i < smoothScrollLinks.length; i++) {
      (function (i) {
        new SmoothScroll(smoothScrollLinks[i]);
      })(i);
    }
  }
})(); // File#: _1_social-sharing
// Usage: codyhouse.co/license


(function () {
  function initSocialShare(button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var social = button.getAttribute('data-social');
      var url = getSocialUrl(button, social);
      social == 'mail' ? window.location.href = url : window.open(url, social + '-share-dialog', 'width=626,height=436');
    });
  }

  ;

  function getSocialUrl(button, social) {
    var params = getSocialParams(social);
    var newUrl = '';

    for (var i = 0; i < params.length; i++) {
      var paramValue = button.getAttribute('data-' + params[i]);
      if (params[i] == 'hashtags') paramValue = encodeURI(paramValue.replace(/\#| /g, ''));

      if (paramValue) {
        social == 'facebook' ? newUrl = newUrl + 'u=' + encodeURIComponent(paramValue) + '&' : newUrl = newUrl + params[i] + '=' + encodeURIComponent(paramValue) + '&';
      }
    }

    if (social == 'linkedin') newUrl = 'mini=true&' + newUrl;
    return button.getAttribute('href') + '?' + newUrl;
  }

  ;

  function getSocialParams(social) {
    var params = [];

    switch (social) {
      case 'twitter':
        params = ['text', 'hashtags'];
        break;

      case 'facebook':
      case 'linkedin':
        params = ['url'];
        break;

      case 'pinterest':
        params = ['url', 'media', 'description'];
        break;

      case 'mail':
        params = ['subject', 'body'];
        break;
    }

    return params;
  }

  ;
  var socialShare = document.getElementsByClassName('js-social-share');

  if (socialShare.length > 0) {
    for (var i = 0; i < socialShare.length; i++) {
      (function (i) {
        initSocialShare(socialShare[i]);
      })(i);
    }
  }
})(); // File#: _1_sub-navigation
// Usage: codyhouse.co/license


(function () {
  var SideNav = function SideNav(element) {
    this.element = element;
    this.control = this.element.getElementsByClassName('js-subnav__control');
    this.navList = this.element.getElementsByClassName('js-subnav__wrapper');
    this.closeBtn = this.element.getElementsByClassName('js-subnav__close-btn');
    this.firstFocusable = getFirstFocusable(this);
    this.showClass = 'subnav__wrapper--is-visible';
    this.collapsedLayoutClass = 'subnav--collapsed';
    initSideNav(this);
  };

  function getFirstFocusable(sidenav) {
    // get first focusable element inside the subnav
    if (sidenav.navList.length == 0) return;
    var focusableEle = sidenav.navList[0].querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary'),
        firstFocusable = false;

    for (var i = 0; i < focusableEle.length; i++) {
      if (focusableEle[i].offsetWidth || focusableEle[i].offsetHeight || focusableEle[i].getClientRects().length) {
        firstFocusable = focusableEle[i];
        break;
      }
    }

    return firstFocusable;
  }

  ;

  function initSideNav(sidenav) {
    checkSideNavLayout(sidenav); // switch from --compressed to --expanded layout

    initSideNavToggle(sidenav); // mobile behavior + layout update on resize

    checkUrl(sidenav);
    onHashChange(sidenav);
  }

  ;

  function checkUrl(sidenav) {
    var elems = document.querySelectorAll('.subnav__link.active');
    [].forEach.call(elems, function (el) {
      el.classList.remove("active");
    });

    if (window.location.hash) {
      var id = window.location.hash.substring(1);
      console.log(id);
      var selected_item = sidenav.navList[0].querySelector('.' + id + '-link');
      Util.addClass(selected_item, 'active');
    }
  }

  function onHashChange(sidenav) {
    window.addEventListener('hashchange', function () {
      checkUrl(sidenav);
    });
  }

  function initSideNavToggle(sidenav) {
    // custom event emitted when window is resized
    sidenav.element.addEventListener('update-sidenav', function (event) {
      checkSideNavLayout(sidenav);
    }); // mobile only

    if (sidenav.control.length == 0 || sidenav.navList.length == 0) return;
    sidenav.control[0].addEventListener('click', function (event) {
      // open sidenav
      openSideNav(sidenav, event);
    });
    sidenav.element.addEventListener('click', function (event) {
      // close sidenav when clicking on close button/bg layer
      if (event.target.closest('.js-subnav__close-btn') || Util.hasClass(event.target, 'js-subnav__wrapper')) {
        closeSideNav(sidenav, event);
      }
    });
  }

  ;

  function openSideNav(sidenav, event) {
    // open side nav - mobile only
    event.preventDefault();
    sidenav.selectedTrigger = event.target;
    event.target.setAttribute('aria-expanded', 'true');
    Util.addClass(sidenav.navList[0], sidenav.showClass);
    sidenav.navList[0].addEventListener('transitionend', function cb(event) {
      sidenav.navList[0].removeEventListener('transitionend', cb);
      sidenav.firstFocusable.focus();
    });
  }

  ;

  function closeSideNav(sidenav, event, bool) {
    // close side sidenav - mobile only
    if (!Util.hasClass(sidenav.navList[0], sidenav.showClass)) return;
    if (event) event.preventDefault();
    Util.removeClass(sidenav.navList[0], sidenav.showClass);
    if (!sidenav.selectedTrigger) return;
    sidenav.selectedTrigger.setAttribute('aria-expanded', 'false');
    if (!bool) sidenav.selectedTrigger.focus();
    sidenav.selectedTrigger = false;
  }

  ;

  function checkSideNavLayout(sidenav) {
    // switch from --compressed to --expanded layout
    var layout = getComputedStyle(sidenav.element, ':before').getPropertyValue('content').replace(/\'|"/g, '');
    if (layout != 'expanded' && layout != 'collapsed') return;
    Util.toggleClass(sidenav.element, sidenav.collapsedLayoutClass, layout != 'expanded');
  }

  ;
  var sideNav = document.getElementsByClassName('js-subnav'),
      SideNavArray = [],
      j = 0;

  if (sideNav.length > 0) {
    for (var i = 0; i < sideNav.length; i++) {
      var beforeContent = getComputedStyle(sideNav[i], ':before').getPropertyValue('content');

      if (beforeContent && beforeContent != '' && beforeContent != 'none') {
        j = j + 1;
      }

      (function (i) {
        SideNavArray.push(new SideNav(sideNav[i]));
      })(i);
    }

    if (j > 0) {
      var doneResizing = function doneResizing() {
        for (var i = 0; i < SideNavArray.length; i++) {
          (function (i) {
            SideNavArray[i].element.dispatchEvent(customEvent);
          })(i);
        }

        ;
      };

      // on resize - update sidenav layout
      var resizingId = false,
          customEvent = new CustomEvent('update-sidenav');
      window.addEventListener('resize', function (event) {
        clearTimeout(resizingId);
        resizingId = setTimeout(doneResizing, 300);
      });
      ;
      window.requestAnimationFrame // init table layout
      ? window.requestAnimationFrame(doneResizing) : doneResizing();
    } // listen for key events


    window.addEventListener('keyup', function (event) {
      if (event.keyCode && event.keyCode == 27 || event.key && event.key.toLowerCase() == 'escape') {
        // listen for esc key - close navigation on mobile if open
        for (var i = 0; i < SideNavArray.length; i++) {
          (function (i) {
            closeSideNav(SideNavArray[i], event);
          })(i);
        }

        ;
      }

      if (event.keyCode && event.keyCode == 9 || event.key && event.key.toLowerCase() == 'tab') {
        // listen for tab key - close navigation on mobile if open when nav loses focus
        if (document.activeElement.closest('.js-subnav__wrapper')) return;

        for (var i = 0; i < SideNavArray.length; i++) {
          (function (i) {
            closeSideNav(SideNavArray[i], event, true);
          })(i);
        }

        ;
      }
    });
  }
})(); // File#: _1_tabs
// Usage: codyhouse.co/license


(function () {
  var Tab = function Tab(element) {
    this.element = element;
    this.tabList = this.element.getElementsByClassName('js-tabs__controls')[0];
    this.listItems = this.tabList.getElementsByTagName('li');
    this.triggers = this.tabList.getElementsByTagName('a');
    this.panelsList = this.element.getElementsByClassName('js-tabs__panels')[0];
    this.panels = Util.getChildrenByClassName(this.panelsList, 'js-tabs__panel');
    this.hideClass = 'is-hidden';
    this.customShowClass = this.element.getAttribute('data-show-panel-class') ? this.element.getAttribute('data-show-panel-class') : false;
    this.layout = this.element.getAttribute('data-tabs-layout') ? this.element.getAttribute('data-tabs-layout') : 'horizontal'; // deep linking options

    this.deepLinkOn = this.element.getAttribute('data-deep-link') == 'on'; // init tabs

    this.initTab();
  };

  Tab.prototype.initTab = function () {
    var _this5 = this;

    //set initial aria attributes
    this.tabList.setAttribute('role', 'tablist');

    for (var i = 0; i < this.triggers.length; i++) {
      var bool = i == 0,
          panelId = this.panels[i].getAttribute('id');
      this.listItems[i].setAttribute('role', 'presentation');
      Util.setAttributes(this.triggers[i], {
        'role': 'tab',
        'aria-selected': bool,
        'aria-controls': panelId,
        'id': 'tab-' + panelId
      });
      Util.addClass(this.triggers[i], 'js-tabs__trigger');
      Util.setAttributes(this.panels[i], {
        'role': 'tabpanel',
        'aria-labelledby': 'tab-' + panelId
      });
      Util.toggleClass(this.panels[i], this.hideClass, !bool);
      if (!bool) this.triggers[i].setAttribute('tabindex', '-1');
    } //listen for Tab events


    this.initTabEvents();
    this.backToHome(); // check deep linking option

    this.initDeepLink();
    window.addEventListener('hashchange', function () {
      _this5.initDeepLink();
    });
  };

  Tab.prototype.initTabEvents = function () {
    var self = this; //click on a new tab -> select content

    this.tabList.addEventListener('click', function (event) {
      console.log(event);
      if (event.target.closest('.js-tabs__trigger')) self.triggerTab(event.target.closest('.js-tabs__trigger'), event);
    }); //arrow keys to navigate through tabs 

    this.tabList.addEventListener('keydown', function (event) {
      ;
      if (!event.target.closest('.js-tabs__trigger')) return;

      if (tabNavigateNext(event, self.layout)) {
        event.preventDefault();
        self.selectNewTab('next');
      } else if (tabNavigatePrev(event, self.layout)) {
        event.preventDefault();
        self.selectNewTab('prev');
      }
    });
  };

  Tab.prototype.selectNewTab = function (direction) {
    var selectedTab = this.tabList.querySelector('[aria-selected="true"]'),
        index = Util.getIndexInArray(this.triggers, selectedTab);
    index = direction == 'next' ? index + 1 : index - 1; //make sure index is in the correct interval 
    //-> from last element go to first using the right arrow, from first element go to last using the left arrow

    if (index < 0) index = this.listItems.length - 1;
    if (index >= this.listItems.length) index = 0;
    this.triggerTab(this.triggers[index]);
    this.triggers[index].focus();
  };

  Tab.prototype.triggerTab = function (tabTrigger, event) {
    var self = this;
    event && event.preventDefault();
    var index = Util.getIndexInArray(this.triggers, tabTrigger); //no need to do anything if tab was already selected

    if (this.triggers[index].getAttribute('aria-selected') == 'true') return;

    for (var i = 0; i < this.triggers.length; i++) {
      var bool = i == index;
      Util.toggleClass(this.panels[i], this.hideClass, !bool);
      if (this.customShowClass) Util.toggleClass(this.panels[i], this.customShowClass, bool);
      this.triggers[i].setAttribute('aria-selected', bool);
      bool ? this.triggers[i].setAttribute('tabindex', '0') : this.triggers[i].setAttribute('tabindex', '-1');
    } // update url if deepLink is on


    if (this.deepLinkOn) {
      history.replaceState(null, '', '#' + tabTrigger.getAttribute('aria-controls'));
    }
  };

  Tab.prototype.initDeepLink = function () {
    if (!this.deepLinkOn) return;
    var hash = window.location.hash.substr(1);
    var self = this;
    if (!hash || hash == '') return;

    for (var i = 0; i < this.panels.length; i++) {
      if (this.panels[i].getAttribute('id') == hash) {
        this.triggerTab(this.triggers[i], false);
        setTimeout(function () {
          self.panels[i].scrollIntoView(true);
        });
        break;
      }
    }

    ;
  };

  Tab.prototype.backToHome = function () {
    var self = this;
    var backHome = this.panelsList.querySelectorAll('.tab__back-home');

    if (backHome) {
      for (var i = 0; i < backHome.length; i++) {
        backHome[i].addEventListener('click', function (e) {
          e.preventDefault();
          var backHomeId = e.target.getAttribute('href');
          self.tabList.querySelector('[href="#tab-home"]').click();
        });
      }
    }
  };

  function tabNavigateNext(event, layout) {
    if (layout == 'horizontal' && (event.keyCode && event.keyCode == 39 || event.key && event.key == 'ArrowRight')) {
      return true;
    } else if (layout == 'vertical' && (event.keyCode && event.keyCode == 40 || event.key && event.key == 'ArrowDown')) {
      return true;
    } else {
      return false;
    }
  }

  ;

  function tabNavigatePrev(event, layout) {
    if (layout == 'horizontal' && (event.keyCode && event.keyCode == 37 || event.key && event.key == 'ArrowLeft')) {
      return true;
    } else if (layout == 'vertical' && (event.keyCode && event.keyCode == 38 || event.key && event.key == 'ArrowUp')) {
      return true;
    } else {
      return false;
    }
  }

  ; //initialize the Tab objects

  var tabs = document.getElementsByClassName('js-tabs');

  if (tabs.length > 0) {
    for (var i = 0; i < tabs.length; i++) {
      (function (i) {
        new Tab(tabs[i]);
      })(i);
    }
  }
})(); // File#: _1_ticker
// Usage: codyhouse.co/license


(function () {
  var Ticker = function Ticker(element) {
    this.element = element;
    this.list = this.element.getElementsByTagName('ul')[0];
    this.items = this.list.children;
    this.paused = false; // clones info

    this.clones = this.list.innerHTML;
    this.clonesNumber = 1;
    this.itemsLength = this.items.length; // animation duration

    this.animationDuration = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ticker-animation-duration'));
    initTicker(this);
  };

  function initTicker(ticker) {
    // clone ticker children
    setTickerWidth(ticker);
    cloneItems(ticker);
    initAnimation(ticker); // resize/font loaded event

    ticker.element.addEventListener('update-ticker', function (event) {
      setTickerWidth(ticker);
      cloneItems(ticker);
    }); // click on control button events

    ticker.element.addEventListener('anim-ticker', function (event) {
      ticker.paused = false;
      Util.removeClass(ticker.element, 'ticker--paused');
    });
    ticker.element.addEventListener('pause-ticker', function (event) {
      ticker.paused = true;
      Util.addClass(ticker.element, 'ticker--paused');
    }); // all set

    Util.addClass(ticker.element, 'ticker--loaded');
  }

  ;

  function setTickerWidth(ticker) {
    var width = 0;

    for (var i = 0; i < ticker.itemsLength; i++) {
      width = width + getItemWidth(ticker.items[i]);
    } // check if we need to update the number of clones


    if (width < window.innerWidth) {
      ticker.clonesNumber = Math.ceil(window.innerWidth / width) * 2 - 1;
    } else {
      ticker.clonesNumber = 1;
    } // update list width


    ticker.list.style.width = (ticker.clonesNumber + 1) * width + 'px';
  }

  ;

  function getItemWidth(item) {
    var style = window.getComputedStyle(item);
    return parseFloat(style.marginRight) + parseFloat(style.marginLeft) + item.offsetWidth;
  }

  ;

  function cloneItems(ticker) {
    ticker.list.innerHTML = ticker.clones;

    for (var i = 0; i < ticker.clonesNumber; i++) {
      ticker.list.insertAdjacentHTML('beforeend', ticker.clones);
    } // update animation duration


    ticker.element.style.setProperty('--ticker-animation-duration', ticker.animationDuration * (ticker.clonesNumber + 1) + 's');
  }

  ;

  function initAnimation(ticker) {
    // init observer - animate ticker only when in viewport
    var observer = new IntersectionObserver(tickerObserve.bind(ticker));
    observer.observe(ticker.element);
  }

  ;

  function tickerObserve(entries) {
    if (entries[0].isIntersecting) {
      if (!this.paused) Util.addClass(this.element, 'ticker--animate');
    } else {
      Util.removeClass(this.element, 'ticker--animate');
    }
  }

  ;

  function initTickerController(controller) {
    // play/pause btn controller
    var tickerContainer = document.getElementById(controller.getAttribute('aria-controls'));
    if (!tickerContainer) return;
    var tickerList = tickerContainer.getElementsByClassName('js-ticker');
    if (tickerList.length < 1) tickerList = [tickerContainer]; // detect click

    controller.addEventListener('click', function (event) {
      var playAnimation = controller.getAttribute('aria-pressed') == 'true';
      var animEvent = playAnimation ? 'anim-ticker' : 'pause-ticker';
      playAnimation ? controller.setAttribute('aria-pressed', 'false') : controller.setAttribute('aria-pressed', 'true');

      for (var i = 0; i < tickerList.length; i++) {
        tickerList[i].dispatchEvent(new CustomEvent(animEvent));
      }
    });
  }

  ; //initialize the Ticker objects

  var tickers = document.getElementsByClassName('js-ticker'),
      requestAnimationFrameSupported = window.requestAnimationFrame,
      reducedMotion = Util.osHasReducedMotion(),
      intersectionObserverSupported = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;

  if (tickers.length > 0) {
    var tickersArray = [];

    for (var i = 0; i < tickers.length; i++) {
      if (!requestAnimationFrameSupported || reducedMotion || !intersectionObserverSupported) {
        // animation is off if requestAnimationFrame/IntersectionObserver is not supported or reduced motion is on
        Util.addClass(tickers[i], 'ticker--anim-off');
      } else {
        (function (i) {
          tickersArray.push(new Ticker(tickers[i]));
        })(i);
      }
    }

    if (tickersArray.length > 0) {
      var doneResizing = function doneResizing() {
        for (var i = 0; i < tickersArray.length; i++) {
          (function (i) {
            tickersArray[i].element.dispatchEvent(customEvent);
          })(i);
        }

        ;
      };

      var resizingId = false,
          customEvent = new CustomEvent('update-ticker'); // on resize -> update ticker width 

      window.addEventListener('resize', function () {
        clearTimeout(resizingId);
        resizingId = setTimeout(doneResizing, 500);
      }); // wait for font to be loaded -> update ticker width

      if (document.fonts) {
        document.fonts.onloadingdone = function (fontFaceSetEvent) {
          doneResizing();
        };
      }

      ; // ticker play/pause buttons

      var tickerControl = document.getElementsByClassName('js-ticker-control');

      if (tickerControl.length > 0) {
        for (var i = 0; i < tickerControl.length; i++) {
          if (!requestAnimationFrameSupported || reducedMotion || !intersectionObserverSupported) {
            Util.addClass(tickerControl[i], 'is-hidden');
          } else {
            (function (i) {
              initTickerController(tickerControl[i]);
            })(i);
          }
        }
      }
    }

    ;
  }
})(); // File#: _1_tilted-img-slideshow
// Usage: codyhouse.co/license


(function () {
  var TiltedSlideshow = function TiltedSlideshow(element, cycle) {
    this.element = element;
    this.list = this.element.getElementsByClassName('js-tilted-slideshow__list')[0];
    this.images = this.list.getElementsByClassName('js-tilted-slideshow__item');
    this.selectedIndex = 0;
    this.animating = false;
    this.cycle = cycle; // classes

    this.orderClasses = ['tilted-slideshow__item--top', 'tilted-slideshow__item--middle', 'tilted-slideshow__item--bottom'];
    this.moveClasses = ['tilted-slideshow__item--move-out', 'tilted-slideshow__item--move-in'];
    this.interactedClass = 'tilted-slideshow--interacted';
    initTiltedSlideshow(this);
  };

  function initTiltedSlideshow(slideshow) {
    if (!animateImgs) removeTransitions(slideshow); // slideshow.cycle = true;

    var Interval;
    console.log(slideshow.cycle);
    slideshow.list.addEventListener('click', function (event) {
      Util.addClass(slideshow.element, slideshow.interactedClass);
      animateImgs ? animateImages(slideshow) : switchImages(slideshow);

      if (slideshow.cycle) {
        clearTimeout(Interval);
        Interval = window.setInterval(function () {
          Util.addClass(slideshow.element, slideshow.interactedClass);
          animateImgs ? animateImages(slideshow) : switchImages(slideshow);
        }, 5000);
      }
    });

    if (slideshow.cycle) {
      console.log('cycle');
      Interval = window.setInterval(function () {
        Util.addClass(slideshow.element, slideshow.interactedClass);
        animateImgs ? animateImages(slideshow) : switchImages(slideshow);
      }, 10000);
    }
  }

  ;

  function removeTransitions(slideshow) {
    // if reduced motion is on or css variables are not supported -> do not animate images
    for (var i = 0; i < slideshow.images.length; i++) {
      slideshow.images[i].style.transition = 'none';
    }
  }

  ;

  function switchImages(slideshow) {
    // if reduced motion is on or css variables are not supported -> switch images without animation
    resetOrderClasses(slideshow);
    resetSelectedIndex(slideshow);
  }

  ;

  function resetSelectedIndex(slideshow) {
    // update the index of the top image
    slideshow.selectedIndex = resetIndex(slideshow, slideshow.selectedIndex + 1);
  }

  ;

  function resetIndex(slideshow, index) {
    // make sure index is < 3
    if (index >= slideshow.images.length) index = index - slideshow.images.length;
    return index;
  }

  ;

  function resetOrderClasses(slideshow) {
    // update the orderClasses for each images
    if (!animateImgs) {
      // top image -> remove top class and add bottom class
      Util.addClass(slideshow.images[slideshow.selectedIndex], slideshow.orderClasses[2]);
      Util.removeClass(slideshow.images[slideshow.selectedIndex], slideshow.orderClasses[0]);
    } // middle image -> remove middle class and add top class


    var middleImage = slideshow.images[resetIndex(slideshow, slideshow.selectedIndex + 1)];
    Util.addClass(middleImage, slideshow.orderClasses[0]);
    Util.removeClass(middleImage, slideshow.orderClasses[1]); // bottom image -> remove bottom class and add middle class

    var bottomImage = slideshow.images[resetIndex(slideshow, slideshow.selectedIndex + 2)];
    Util.addClass(bottomImage, slideshow.orderClasses[1]);
    Util.removeClass(bottomImage, slideshow.orderClasses[2]);
  }

  ;

  function animateImages(slideshow) {
    if (slideshow.animating) return;
    slideshow.animating = true; // reset order classes for middle/bottom images

    resetOrderClasses(slideshow); // animate top image

    var topImage = slideshow.images[slideshow.selectedIndex]; // remove top class and add move out class

    Util.removeClass(topImage, slideshow.orderClasses[0]);
    Util.addClass(topImage, slideshow.moveClasses[0]);
    topImage.addEventListener('transitionend', function cb(event) {
      // remove transition
      topImage.style.transition = 'none';
      topImage.removeEventListener("transitionend", cb);
      setTimeout(function () {
        // add bottom + move-in class, remove move-out class
        Util.removeClass(topImage, slideshow.moveClasses[0]);
        Util.addClass(topImage, slideshow.moveClasses[1] + ' ' + slideshow.orderClasses[2]);
        setTimeout(function () {
          topImage.style.transition = ''; // remove move-in class

          Util.removeClass(topImage, slideshow.moveClasses[1]);
          topImage.addEventListener('transitionend', function cbn(event) {
            // reset animating property and selectedIndex index
            resetSelectedIndex(slideshow);
            slideshow.animating = false;
            topImage.removeEventListener("transitionend", cbn);
          });
        }, 10);
      }, 10);
    });
  }

  ;
  var tiltedSlideshow = document.getElementsByClassName('js-tilted-slideshow'),
      animateImgs = !Util.osHasReducedMotion() && 'CSS' in window && CSS.supports('color', 'var(--color-var)');

  if (tiltedSlideshow.length > 0) {
    for (var i = 0; i < tiltedSlideshow.length; i++) {
      new TiltedSlideshow(tiltedSlideshow[i], true);
    }
  }

  document.addEventListener("shopify:section:load", function () {
    window.dispatchEvent(new CustomEvent('restartAll'));
    console.log('fired');

    if (tiltedSlideshow.length > 0) {
      for (var i = 0; i < tiltedSlideshow.length; i++) {
        new TiltedSlideshow(tiltedSlideshow[i], false);
      }
    }
  }, false);
})(); // File#: _1_toast
// Usage: codyhouse.co/license


(function () {
  var Toasts = function Toasts() {
    this.toastsEl = document.getElementsByClassName('js-toast');
    this.toastsId = getRandomInt(0, 1000);
    this.index = 0;
    this.closingToast = false;
    initToasts(this);
  }; // public method to initialize new toast elements


  Toasts.prototype.initToast = function (element) {
    initSingleToast(this, element);
  };

  function initToasts(obj) {
    // create a wrapper element for each toast variation
    createWrapper(obj, 'top-right');
    createWrapper(obj, 'top-left');
    createWrapper(obj, 'top-center');
    createWrapper(obj, 'bottom-right');
    createWrapper(obj, 'bottom-left');
    createWrapper(obj, 'bottom-center'); // init single toast element

    for (var i = 0; i < obj.toastsEl.length; i++) {
      initSingleToast(obj, obj.toastsEl[i]);
    } // listen for dynamic toast creation


    window.addEventListener('newToast', function (event) {
      initSingleToast(obj, event.detail);
    });
  }

  ;

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
  }

  ;

  function createWrapper(obj, position) {
    var classes = 'top-0 left-0 flex-column';
    if (position == 'top-right') classes = 'top-0 right-0 flex-column';
    if (position == 'top-center') classes = 'top-0 left-50% -translate-x-50% flex-column items-center';
    if (position == 'bottom-right') classes = 'bottom-0 right-0 flex-column-reverse';
    if (position == 'bottom-left') classes = 'bottom-0 left-0 flex-column-reverse';
    if (position == 'bottom-center') classes = 'bottom-0 left-50% -translate-x-50% flex-column-reverse items-center';
    var div = '<div class="toast-wrapper position-fixed flex ' + classes + '" id="toast-wrapper-' + position + '"></div>';
    document.body.insertAdjacentHTML('beforeend', div);
    obj[position] = document.getElementById('toast-wrapper-' + position);
  }

  ;

  function initSingleToast(obj, toast) {
    var id = 'toast-' + obj.toastsId + '-' + obj.index;
    obj.index = obj.index + 1; // store toast info in the Toasts obj

    obj[id] = {};
    obj[id]['interval'] = toast.getAttribute('data-toast-interval') || 5000, obj[id]['intervalId'] = false;
    obj[id]['closing'] = false; // get position type

    var classes = toast.getAttribute('class');
    obj[id]['position'] = 'top-right';
    if (classes.indexOf('toast--top-left') > -1) obj[id]['position'] = 'top-left';
    if (classes.indexOf('toast--top-center') > -1) obj[id]['position'] = 'top-center';
    if (classes.indexOf('toast--bottom-right') > -1) obj[id]['position'] = 'bottom-right';
    if (classes.indexOf('toast--bottom-left') > -1) obj[id]['position'] = 'bottom-left';
    if (classes.indexOf('toast--bottom-center') > -1) obj[id]['position'] = 'bottom-center'; // listen for custom open event

    toast.addEventListener('openToast', function () {
      if (!Util.hasClass(toast, 'toast--hidden') || obj[id]['closing']) return;
      openToast(obj, toast, id);
    }); // close toast

    toast.addEventListener('click', function (event) {
      if (event.target.closest('.js-toast__close-btn')) {
        obj.closingToast = true;
        closeToast(obj, toast, id);
      }
    });
  }

  ;

  function openToast(obj, toast, id) {
    if (obj[id]['intervalId']) {
      clearInterval(obj[id]['intervalId']);
      obj[id]['intervalId'] = false;
    } // place toast - insert in the proper container


    var fragment = document.createDocumentFragment();
    fragment.appendChild(toast);
    obj[obj[id]['position']].appendChild(fragment); // change position

    toast.style.position = 'static'; // show toast

    setTimeout(function () {
      Util.removeClass(toast, 'toast--hidden');
    }); // automatically close after a time interval

    if (obj[id]['interval'] && parseInt(obj[id]['interval']) > 0) {
      setToastInterval(obj, toast, id, obj[id]['interval']);
    }
  }

  ;

  function setToastInterval(obj, toast, id, interval) {
    obj[id]['intervalId'] = setTimeout(function () {
      if (obj.closingToast) return setToastInterval(obj, toast, id, 1000);
      closeToast(obj, toast, id);
    }, interval);
  }

  ;

  function closeToast(obj, toast, id) {
    obj[id]['closing'] = true;
    Util.addClass(toast, 'toast--hidden'); // clear timeout

    if (obj[id]['intervalId']) clearTimeout(obj[id]['intervalId']); // remove toast and animate siblings

    closeToastAnimation(obj, toast, id);
  }

  ;

  function closeToastAnimation(obj, toast, id) {
    // get all next elements 
    var siblings = getToastNextSiblings(toast); // get translate value (could be positive or negative based on position)

    var toastStyle = window.getComputedStyle(toast),
        margin = parseInt(toastStyle.getPropertyValue('margin-top')) || parseInt(toastStyle.getPropertyValue('margin-bottom')); // translate next elements if any

    var translate = toast.offsetHeight + margin;

    if (obj[id]['position'].indexOf('top') > -1) {
      translate = '-' + translate;
    }

    for (var i = 0; i < siblings.length; i++) {
      siblings[i].style.transform = 'translateY(' + translate + 'px)';
    } // remove toast and reset translate


    toast.addEventListener('transitionend', function cb(event) {
      if (event.propertyName != 'opacity') return;
      toast.removeEventListener('transitionend', cb);
      removeToast(toast, siblings, obj, id);
      obj.closingToast = false;
    });
  }

  ;

  function getToastNextSiblings(toast) {
    var array = [];
    var nextSibling = toast.nextElementSibling;

    if (nextSibling) {
      array.push(nextSibling);
      var nextSiblingsIterate = getToastNextSiblings(nextSibling);
      Array.prototype.push.apply(array, nextSiblingsIterate);
    }

    return array;
  }

  ;

  function removeToast(toast, siblings, obj, id) {
    // reset position
    toast.style.position = ''; // move toast back to body

    var fragment = document.createDocumentFragment();
    fragment.appendChild(toast);
    document.body.appendChild(fragment); // reset siblings translate

    for (var i = 0; i < siblings.length; i++) {
      (function (i) {
        // set transition to none
        siblings[i].style.transition = 'none';
        siblings[i].style.transform = '';
        setTimeout(function () {
          siblings[i].style.transition = '';
        }, 10);
      })(i);
    } // reset closing status


    obj[id]['closing'] = false;
  }

  ;
  window.Toasts = Toasts; //initialize the Toasts objects

  var toasts = document.getElementsByClassName('js-toast');

  if (toasts.length > 0) {
    new Toasts();
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];

            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });
    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

(function () {
  // Does the browser actually support the video element?
  var supportsVideo = !!document.createElement('video').canPlayType;
  var videoContainer = document.getElementById('videoContainer');
  var video = document.getElementById('video');
  var videoControls = document.getElementById('video-controls');

  if (supportsVideo && videoContainer) {
    // Obtain handles to main elements
    // Hide the default controls
    video.controls = false; // Display the user defined video controls

    videoControls.style.display = 'block'; // Obtain handles to buttons and other elements

    var playpause = document.getElementById('playpause');
    var stop = document.getElementById('stop');
    var mute = document.getElementById('mute');
    var volinc = document.getElementById('volinc');
    var voldec = document.getElementById('voldec');
    var progress = document.getElementById('progress');
    var progressBar = document.getElementById('progress-bar');
    var fullscreen = document.getElementById('fs'); // Check if the browser supports the Fullscreen API

    var fullScreenEnabled = !!(document.fullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitSupportsFullscreen || document.webkitFullscreenEnabled || document.createElement('video').webkitRequestFullScreen); // If the browser doesn't support the Fulscreen API then hide the fullscreen button

    if (!fullScreenEnabled) {
      fullscreen.style.display = 'none';
    } // Change the volume


    var alterVolume = function alterVolume(dir) {
      var currentVolume = Math.floor(video.volume * 10) / 10;

      if (dir === '+') {
        if (currentVolume < 1) video.volume += 0.1;
      } else if (dir === '-') {
        if (currentVolume > 0) video.volume -= 0.1;
      }
    }; // Set the video container's fullscreen state


    var setFullscreenData = function setFullscreenData(state) {
      videoContainer.setAttribute('data-fullscreen', !!state);
    }; // Checks if the document is currently in fullscreen mode


    var isFullScreen = function isFullScreen() {
      return !!(document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
    }; // Fullscreen


    var handleFullscreen = function handleFullscreen() {
      // If fullscreen mode is active...	
      if (isFullScreen()) {
        // ...exit fullscreen mode
        // (Note: this can only be called on document)
        if (document.exitFullscreen) document.exitFullscreen();else if (document.mozCancelFullScreen) document.mozCancelFullScreen();else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();else if (document.msExitFullscreen) document.msExitFullscreen();
        setFullscreenData(false);
      } else {
        // ...otherwise enter fullscreen mode
        // (Note: can be called on document, but here the specific element is used as it will also ensure that the element's children, e.g. the custom controls, go fullscreen also)
        if (videoContainer.requestFullscreen) videoContainer.requestFullscreen();else if (videoContainer.mozRequestFullScreen) videoContainer.mozRequestFullScreen();else if (videoContainer.webkitRequestFullScreen) {
          // Safari 5.1 only allows proper fullscreen on the video element. This also works fine on other WebKit browsers as the following CSS (set in styles.css) hides the default controls that appear again, and 
          // ensures that our custom controls are visible:
          // figure[data-fullscreen=true] video::-webkit-media-controls { display:none !important; }
          // figure[data-fullscreen=true] .controls { z-index:2147483647; }
          video.webkitRequestFullScreen();
        } else if (videoContainer.msRequestFullscreen) videoContainer.msRequestFullscreen();
        setFullscreenData(true);
      }
    }; // Only add the events if addEventListener is supported (IE8 and less don't support it, but that will use Flash anyway)


    if (document.addEventListener) {
      // Wait for the video's meta data to be loaded, then set the progress bar's max value to the duration of the video
      video.addEventListener('loadedmetadata', function () {
        progress.setAttribute('max', video.duration);
      });

      video.onended = function () {
        playpause.querySelector(".play").style.display = 'block';
        playpause.querySelector(".pause").style.display = 'none';
      }; // Add events for all buttons


      playpause.addEventListener('click', function (e) {
        var _target = e.currentTarget;
        console.log(_target);

        if (video.paused || video.ended) {
          _target.querySelector(".play").style.display = 'none';
          _target.querySelector(".pause").style.display = 'block';
          video.play();
        } else {
          _target.querySelector(".play").style.display = 'block';
          _target.querySelector(".pause").style.display = 'none';
          video.pause();
        }
      });
      mute.addEventListener('click', function (e) {
        var _target = e.currentTarget;

        if (!video.muted) {
          _target.querySelector(".unmuted").style.display = 'block';
          _target.querySelector(".muted").style.display = 'none';
          video.muted = !video.muted;
        } else {
          _target.querySelector(".unmuted").style.display = 'none';
          _target.querySelector(".muted").style.display = 'block';
          video.muted = !video.muted;
        }
      });
      fs.addEventListener('click', function (e) {
        handleFullscreen();
      }); // As the video is playing, update the progress bar

      video.addEventListener('timeupdate', function () {
        // For mobile browsers, ensure that the progress element's max attribute is set
        if (!progress.getAttribute('max')) progress.setAttribute('max', video.duration);
        progress.value = video.currentTime;
        progressBar.style.width = Math.floor(video.currentTime / video.duration * 100) + '%';
      }); // React to the user clicking within the progress bar

      progress.addEventListener('click', function (e) {
        var controlWidth = videoControls.querySelector('.progress-mute-fullscreen').offsetWidth;
        var widthAdjuster = (video.offsetWidth - controlWidth) / 2;
        var eleWidth = (window.innerWidth - video.offsetWidth) / 2 + widthAdjuster;
        var pos = (e.pageX - this.offsetLeft - eleWidth) / this.offsetWidth;
        video.currentTime = pos * video.duration;
      }); // Listen for fullscreen change events (from other controls, e.g. right clicking on the video itself)

      document.addEventListener('fullscreenchange', function (e) {
        setFullscreenData(!!(document.fullScreen || document.fullscreenElement));
      });
      document.addEventListener('webkitfullscreenchange', function () {
        setFullscreenData(!!document.webkitIsFullScreen);
      });
      document.addEventListener('mozfullscreenchange', function () {
        setFullscreenData(!!document.mozFullScreen);
      });
      document.addEventListener('msfullscreenchange', function () {
        setFullscreenData(!!document.msFullscreenElement);
      });
      var i = null;
      video.addEventListener('pause', function () {
        videoControls.classList.remove("focus"); // video has paused, so if the caption fadeout timer has started, cancel it

        clearTimeout(i);
      });
      video.addEventListener('playing', function () {
        // $('#caption').delay(2500).fadeOut();
        videoControls.classList.add("focus");
      });
      videoContainer.addEventListener('mousemove', function () {
        clearTimeout(i); // only start the timer if the video is not paused

        if (!video.paused) {
          videoControls.classList.remove("focus");
          i = setTimeout(function () {
            videoControls.classList.add("focus");
          }, 2500);
        }
      });
    }
  }
})(); // File#: _2_dropdown
// Usage: codyhouse.co/license


(function () {
  var Dropdown = function Dropdown(element) {
    this.element = element;
    this.trigger = this.element.getElementsByClassName('js-dropdown__trigger')[0];
    this.dropdown = this.element.getElementsByClassName('js-dropdown__menu')[0];
    this.triggerFocus = false;
    this.dropdownFocus = false;
    this.hideInterval = false; // sublevels

    this.dropdownSubElements = this.element.getElementsByClassName('js-dropdown__sub-wrapper');
    this.prevFocus = false; // store element that was in focus before focus changed

    this.addDropdownEvents();
  };

  Dropdown.prototype.addDropdownEvents = function () {
    //place dropdown
    var self = this;
    this.placeElement();
    this.element.addEventListener('placeDropdown', function (event) {
      self.placeElement();
    }); // init dropdown

    this.initElementEvents(this.trigger, this.triggerFocus); // this is used to trigger the primary dropdown

    this.initElementEvents(this.dropdown, this.dropdownFocus); // this is used to trigger the primary dropdown
    // init sublevels
    // this.initSublevels(); // if there are additional sublevels -> bind hover/focus events
  };

  Dropdown.prototype.placeElement = function () {
    // remove inline style first
    this.dropdown.removeAttribute('style'); // check dropdown position

    var triggerPosition = this.trigger.getBoundingClientRect(),
        isRight = window.innerWidth < triggerPosition.left + parseInt(getComputedStyle(this.dropdown).getPropertyValue('width'));
    var xPosition = isRight ? 'right: 0px; left: auto;' : 'left: 0px; right: auto;';
    this.dropdown.setAttribute('style', xPosition);
  };

  Dropdown.prototype.initElementEvents = function (element, bool) {
    var self = this;
    element.addEventListener('mouseenter', function () {
      bool = true;
      self.showDropdown();
    });
    element.addEventListener('focus', function () {
      self.showDropdown();
    });
    element.addEventListener('mouseleave', function () {
      bool = false;
      self.hideDropdown();
    });
    element.addEventListener('focusout', function () {
      self.hideDropdown();
    });
  };

  Dropdown.prototype.showDropdown = function () {
    if (this.hideInterval) clearInterval(this.hideInterval); // remove style attribute

    this.dropdown.removeAttribute('style');
    this.placeElement();
    this.showLevel(this.dropdown, true);
  };

  Dropdown.prototype.hideDropdown = function () {
    var self = this;
    if (this.hideInterval) clearInterval(this.hideInterval);
    this.hideInterval = setTimeout(function () {
      var dropDownFocus = document.activeElement.closest('.js-dropdown'),
          inFocus = dropDownFocus && dropDownFocus == self.element; // if not in focus and not hover -> hide

      if (!self.triggerFocus && !self.dropdownFocus && !inFocus) {
        self.hideLevel(self.dropdown, true); // make sure to hide sub/dropdown

        self.hideSubLevels();
        self.prevFocus = false;
      }
    }, 300);
  };

  Dropdown.prototype.initSublevels = function () {
    var self = this;
    var dropdownMenu = this.element.getElementsByClassName('js-dropdown__menu');

    for (var i = 0; i < dropdownMenu.length; i++) {
      var listItems = dropdownMenu[i].children; // bind hover

      new menuAim({
        menu: dropdownMenu[i],
        activate: function activate(row) {
          var subList = row.getElementsByClassName('js-dropdown__menu')[0];
          if (!subList) return;
          Util.addClass(row.querySelector('a'), 'dropdown__item--hover');
          self.showLevel(subList);
        },
        deactivate: function deactivate(row) {
          var subList = row.getElementsByClassName('dropdown__menu')[0];
          if (!subList) return;
          Util.removeClass(row.querySelector('a'), 'dropdown__item--hover');
          self.hideLevel(subList);
        },
        submenuSelector: '.js-dropdown__sub-wrapper'
      });
    } // store focus element before change in focus


    this.element.addEventListener('keydown', function (event) {
      if (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab') {
        self.prevFocus = document.activeElement;
      }
    }); // make sure that sublevel are visible when their items are in focus

    this.element.addEventListener('keyup', function (event) {
      if (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab') {
        // focus has been moved -> make sure the proper classes are added to subnavigation
        var focusElement = document.activeElement,
            focusElementParent = focusElement.closest('.js-dropdown__menu'),
            focusElementSibling = focusElement.nextElementSibling; // if item in focus is inside submenu -> make sure it is visible

        if (focusElementParent && !Util.hasClass(focusElementParent, 'dropdown__menu--is-visible')) {
          self.showLevel(focusElementParent);
        } // if item in focus triggers a submenu -> make sure it is visible


        if (focusElementSibling && !Util.hasClass(focusElementSibling, 'dropdown__menu--is-visible')) {
          self.showLevel(focusElementSibling);
        } // check previous element in focus -> hide sublevel if required 


        if (!self.prevFocus) return;
        var prevFocusElementParent = self.prevFocus.closest('.js-dropdown__menu'),
            prevFocusElementSibling = self.prevFocus.nextElementSibling;
        if (!prevFocusElementParent) return; // element in focus and element prev in focus are siblings

        if (focusElementParent && focusElementParent == prevFocusElementParent) {
          if (prevFocusElementSibling) self.hideLevel(prevFocusElementSibling);
          return;
        } // element in focus is inside submenu triggered by element prev in focus


        if (prevFocusElementSibling && focusElementParent && focusElementParent == prevFocusElementSibling) return; // shift tab -> element in focus triggers the submenu of the element prev in focus

        if (focusElementSibling && prevFocusElementParent && focusElementSibling == prevFocusElementParent) return;
        var focusElementParentParent = focusElementParent.parentNode.closest('.js-dropdown__menu'); // shift tab -> element in focus is inside the dropdown triggered by a siblings of the element prev in focus

        if (focusElementParentParent && focusElementParentParent == prevFocusElementParent) {
          if (prevFocusElementSibling) self.hideLevel(prevFocusElementSibling);
          return;
        }

        if (prevFocusElementParent && Util.hasClass(prevFocusElementParent, 'dropdown__menu--is-visible')) {
          self.hideLevel(prevFocusElementParent);
        }
      }
    });
  };

  Dropdown.prototype.hideSubLevels = function () {
    var visibleSubLevels = this.dropdown.getElementsByClassName('dropdown__menu--is-visible');
    if (visibleSubLevels.length == 0) return;

    while (visibleSubLevels[0]) {
      this.hideLevel(visibleSubLevels[0]);
    }

    var hoveredItems = this.dropdown.getElementsByClassName('dropdown__item--hover');

    while (hoveredItems[0]) {
      Util.removeClass(hoveredItems[0], 'dropdown__item--hover');
    }
  };

  Dropdown.prototype.showLevel = function (level, bool) {
    if (bool == undefined) {
      //check if the sublevel needs to be open to the left
      Util.removeClass(level, 'dropdown__menu--left');
      var boundingRect = level.getBoundingClientRect();
      if (window.innerWidth - boundingRect.right < 5 && boundingRect.left + window.scrollX > 2 * boundingRect.width) Util.addClass(level, 'dropdown__menu--left');
    }

    Util.addClass(level, 'dropdown__menu--is-visible');
    Util.removeClass(level, 'dropdown__menu--is-hidden');
  };

  Dropdown.prototype.hideLevel = function (level, bool) {
    if (!Util.hasClass(level, 'dropdown__menu--is-visible')) return;
    Util.removeClass(level, 'dropdown__menu--is-visible');
    Util.addClass(level, 'dropdown__menu--is-hidden');
    level.addEventListener('transitionend', function cb(event) {
      if (event.propertyName != 'opacity') return;
      level.removeEventListener('transitionend', cb);
      Util.removeClass(level, 'dropdown__menu--is-hidden dropdown__menu--left');
      if (bool && !Util.hasClass(level, 'dropdown__menu--is-visible')) level.setAttribute('style', 'width: 0px');
    });
  };

  window.Dropdown = Dropdown;
  var dropdown = document.getElementsByClassName('js-dropdown');

  if (dropdown.length > 0) {
    // init Dropdown objects
    for (var i = 0; i < dropdown.length; i++) {
      (function (i) {
        new Dropdown(dropdown[i]);
      })(i);
    }
  }
})();

(function () {
  function addRemoveClass(e) {
    if (document.querySelector('.featured-partnership__list h4.active') !== null) {
      document.querySelector('.featured-partnership__list h4.active').classList.remove('active');
    }

    e.target.classList.add("active");
  }

  function templateFilter(obj, data) {
    return obj.querySelector('.wrapper').innerHTML.replace(/{(\w*)}/g, function (m, key) {
      return data.hasOwnProperty(key) ? data[key] : "";
    });
  }

  function removePartner() {
    var container = document.querySelector(".featured-partnership__container");
    container.querySelector('.partner').remove();
  }

  function addPartner(e) {
    var container = document.querySelector(".featured-partnership__container");
    var template = document.getElementById("template");
    var partnerTemplate = template.content.cloneNode(true);
    var _target = e.currentTarget;
    var data = {
      "name": _target.getAttribute('data-name'),
      "copy": _target.getAttribute('data-copy'),
      "url": _target.getAttribute('data-page-url'),
      "image": _target.getAttribute('data-image')
    };
    var partner = templateFilter(partnerTemplate, data);

    if (container.querySelector('.partner')) {
      container.querySelector('.partner').remove();
    }

    container.innerHTML = container.innerHTML + partner;
    var backbtn = container.querySelector('.featured-partnership__back');
    backbtn.addEventListener("click", removePartner);
  }

  if (document.querySelector(".featured-partnership__container")) {
    var partnerName = document.querySelectorAll(".featured-partnership__partner-list-name");
    partnerName.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        addRemoveClass(e);
        addPartner(e);
      });
    });
  }
})(); // File#: _2_multiple-custom-select
// Usage: codyhouse.co/license


(function () {
  var MultiCustomSelect = function MultiCustomSelect(element) {
    this.element = element;
    this.select = this.element.getElementsByTagName('select')[0];
    this.optGroups = this.select.getElementsByTagName('optgroup');
    this.options = this.select.getElementsByTagName('option');
    this.selectId = this.select.getAttribute('id');
    this.trigger = false;
    this.dropdown = false;
    this.customOptions = false;
    this.arrowIcon = this.element.getElementsByTagName('svg');
    this.label = document.querySelector('[for="' + this.selectId + '"]');
    this.selectedOptCounter = 0;
    this.optionIndex = 0; // used while building the custom dropdown
    // label options

    this.noSelectText = this.element.getAttribute('data-no-select-text') || 'Select';
    this.multiSelectText = this.element.getAttribute('data-multi-select-text') || '{n} items selected';
    this.nMultiSelect = this.element.getAttribute('data-n-multi-select') || 1;
    this.noUpdateLabel = this.element.getAttribute('data-update-text') && this.element.getAttribute('data-update-text') == 'off';
    this.insetLabel = this.element.getAttribute('data-inset-label') && this.element.getAttribute('data-inset-label') == 'on'; // init

    initCustomSelect(this); // init markup

    initCustomSelectEvents(this); // init event listeners
  };

  function initCustomSelect(select) {
    // create the HTML for the custom dropdown element
    select.element.insertAdjacentHTML('beforeend', initButtonSelect(select) + initListSelect(select)); // save custom elements

    select.dropdown = select.element.getElementsByClassName('js-multi-select__dropdown')[0];
    select.trigger = select.element.getElementsByClassName('js-multi-select__button')[0];
    select.customOptions = select.dropdown.getElementsByClassName('js-multi-select__option'); // hide default select

    Util.addClass(select.select, 'is-hidden');
    if (select.arrowIcon.length > 0) select.arrowIcon[0].style.display = 'none';
  }

  ;

  function initCustomSelectEvents(select) {
    // option selection in dropdown
    initSelection(select); // click events

    select.trigger.addEventListener('click', function (event) {
      event.preventDefault();
      toggleCustomSelect(select, false);
    });

    if (select.label) {
      // move focus to custom trigger when clicking on <select> label
      select.label.addEventListener('click', function () {
        Util.moveFocus(select.trigger);
      });
    } // keyboard navigation


    select.dropdown.addEventListener('keydown', function (event) {
      if (event.keyCode && event.keyCode == 38 || event.key && event.key.toLowerCase() == 'arrowup') {
        keyboardCustomSelect(select, 'prev', event);
      } else if (event.keyCode && event.keyCode == 40 || event.key && event.key.toLowerCase() == 'arrowdown') {
        keyboardCustomSelect(select, 'next', event);
      }
    });
  }

  ;

  function toggleCustomSelect(select, bool) {
    var ariaExpanded;

    if (bool) {
      ariaExpanded = bool;
    } else {
      ariaExpanded = select.trigger.getAttribute('aria-expanded') == 'true' ? 'false' : 'true';
    }

    select.trigger.setAttribute('aria-expanded', ariaExpanded);

    if (ariaExpanded == 'true') {
      var selectedOption = getSelectedOption(select);
      Util.moveFocus(selectedOption); // fallback if transition is not supported

      select.dropdown.addEventListener('transitionend', function cb() {
        Util.moveFocus(selectedOption);
        select.dropdown.removeEventListener('transitionend', cb);
      });
      placeDropdown(select); // place dropdown based on available space
    }
  }

  ;

  function placeDropdown(select) {
    var triggerBoundingRect = select.trigger.getBoundingClientRect();
    Util.toggleClass(select.dropdown, 'multi-select__dropdown--right', window.innerWidth < triggerBoundingRect.left + select.dropdown.offsetWidth); // check if there's enough space up or down

    var moveUp = window.innerHeight - triggerBoundingRect.bottom < triggerBoundingRect.top;
    Util.toggleClass(select.dropdown, 'multi-select__dropdown--up', moveUp); // check if we need to set a max height

    var maxHeight = moveUp ? triggerBoundingRect.top - 20 : window.innerHeight - triggerBoundingRect.bottom - 20; // set max-height (based on available space) and width

    select.dropdown.setAttribute('style', 'max-height: ' + maxHeight + 'px; width: ' + triggerBoundingRect.width + 'px;');
  }

  ;

  function keyboardCustomSelect(select, direction, event) {
    // navigate custom dropdown with keyboard
    event.preventDefault();
    var index = Util.getIndexInArray(select.customOptions, document.activeElement.closest('.js-multi-select__option'));
    index = direction == 'next' ? index + 1 : index - 1;
    if (index < 0) index = select.customOptions.length - 1;
    if (index >= select.customOptions.length) index = 0;
    Util.moveFocus(select.customOptions[index].getElementsByClassName('js-multi-select__checkbox')[0]);
  }

  ;

  function initSelection(select) {
    // option selection
    select.dropdown.addEventListener('change', function (event) {
      var option = event.target.closest('.js-multi-select__option');
      if (!option) return;
      selectOption(select, option);
    });
    select.dropdown.addEventListener('click', function (event) {
      var option = event.target.closest('.js-multi-select__option');
      if (!option || !Util.hasClass(event.target, 'js-multi-select__option')) return;
      selectOption(select, option);
    });
  }

  ;

  function selectOption(select, option) {
    if (option.hasAttribute('aria-selected') && option.getAttribute('aria-selected') == 'true') {
      // deselecting that option
      option.setAttribute('aria-selected', 'false'); // update native select element

      updateNativeSelect(select, option.getAttribute('data-index'), false);
    } else {
      option.setAttribute('aria-selected', 'true'); // update native select element

      updateNativeSelect(select, option.getAttribute('data-index'), true);
    }

    var triggerLabel = getSelectedOptionText(select);
    select.trigger.getElementsByClassName('js-multi-select__label')[0].innerHTML = triggerLabel[0]; // update trigger label

    Util.toggleClass(select.trigger, 'multi-select__button--active', select.selectedOptCounter > 0);
    updateTriggerAria(select, triggerLabel[1]); // update trigger arai-label
  }

  ;

  function updateNativeSelect(select, index, bool) {
    select.options[index].selected = bool;
    select.select.dispatchEvent(new CustomEvent('change', {
      bubbles: true
    })); // trigger change event
  }

  ;

  function updateTriggerAria(select, ariaLabel) {
    // new label for custom triegger
    select.trigger.setAttribute('aria-label', ariaLabel);
  }

  ;

  function getSelectedOptionText(select) {
    // used to initialize the label of the custom select button
    var noSelectionText = '<span class="multi-select__term">' + select.noSelectText + '</span>';
    if (select.noUpdateLabel) return [noSelectionText, select.noSelectText];
    var label = '';
    var ariaLabel = '';
    select.selectedOptCounter = 0;

    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].selected) {
        if (select.selectedOptCounter != 0) label = label + ', ';
        label = label + '' + select.options[i].text;
        select.selectedOptCounter = select.selectedOptCounter + 1;
      }
    }

    if (select.selectedOptCounter > select.nMultiSelect) {
      label = '<span class="multi-select__details">' + select.multiSelectText.replace('{n}', select.selectedOptCounter) + '</span>';
      ariaLabel = select.multiSelectText.replace('{n}', select.selectedOptCounter) + ', ' + select.noSelectText;
    } else if (select.selectedOptCounter > 0) {
      ariaLabel = label + ', ' + select.noSelectText;
      label = '<span class="multi-select__details">' + label + '</span>';
    } else {
      label = noSelectionText;
      ariaLabel = select.noSelectText;
    }

    if (select.insetLabel && select.selectedOptCounter > 0) label = noSelectionText + label;
    return [label, ariaLabel];
  }

  ;

  function initButtonSelect(select) {
    // create the button element -> custom select trigger
    // check if we need to add custom classes to the button trigger
    var customClasses = select.element.getAttribute('data-trigger-class') ? ' ' + select.element.getAttribute('data-trigger-class') : '';
    var triggerLabel = getSelectedOptionText(select);
    var activeSelectionClass = select.selectedOptCounter > 0 ? ' multi-select__button--active' : '';
    var button = '<button class="js-multi-select__button multi-select__button' + customClasses + activeSelectionClass + '" aria-label="' + triggerLabel[1] + '" aria-expanded="false" aria-controls="' + select.selectId + '-dropdown"><span aria-hidden="true" class="js-multi-select__label multi-select__label">' + triggerLabel[0] + '</span>';

    if (select.arrowIcon.length > 0 && select.arrowIcon[0].outerHTML) {
      button = button + select.arrowIcon[0].outerHTML;
    }

    return button + '</button>';
  }

  ;

  function initListSelect(select) {
    // create custom select dropdown
    var list = '<div class="js-multi-select__dropdown multi-select__dropdown" aria-describedby="' + select.selectId + '-description" id="' + select.selectId + '-dropdown">';
    list = list + getSelectLabelSR(select);

    if (select.optGroups.length > 0) {
      for (var i = 0; i < select.optGroups.length; i++) {
        var optGroupList = select.optGroups[i].getElementsByTagName('option'),
            optGroupLabel = '<li><span class="multi-select__item multi-select__item--optgroup">' + select.optGroups[i].getAttribute('label') + '</span></li>';
        list = list + '<ul class="multi-select__list " aria-controls="adv-filter-gallery" role="listbox" aria-multiselectable="true">' + optGroupLabel + getOptionsList(select, optGroupList) + '</ul>';
      }
    } else {
      list = list + '<ul class="multi-select__list" aria-controls="adv-filter-gallery" role="listbox" aria-multiselectable="true">' + getOptionsList(select, select.options) + '</ul>';
    }

    return list;
  }

  ;

  function getSelectLabelSR(select) {
    if (select.label) {
      return '<p class="sr-only" id="' + select.selectId + '-description">' + select.label.textContent + '</p>';
    } else {
      return '';
    }
  }

  ;

  function getOptionsList(select, options) {
    var list = '';

    for (var i = 0; i < options.length; i++) {
      var selected = options[i].hasAttribute('selected') ? ' aria-selected="true"' : ' aria-selected="false"',
          checked = options[i].hasAttribute('selected') ? 'checked' : '';
      list = list + '<li class="js-multi-select__option" role="option"  data-value="' + options[i].value + '" ' + selected + ' data-label="' + options[i].text + '" data-index="' + select.optionIndex + '"><input aria-hidden="true" class="checkbox js-multi-select__checkbox" data-filter="' + options[i].value + '" type="checkbox" id="' + select.selectId + '-' + options[i].value + '-' + select.optionIndex + '" ' + checked + '><label class="multi-select__item multi-select__item--option" aria-hidden="true" for="' + select.selectId + '-' + options[i].value + '-' + select.optionIndex + '"><span>' + options[i].text + '</span></label></li>';
      select.optionIndex = select.optionIndex + 1;
    }

    ;
    return list;
  }

  ;

  function getSelectedOption(select) {
    // return first selected option
    var option = select.dropdown.querySelector('[aria-selected="true"]');
    if (option) return option.getElementsByClassName('js-multi-select__checkbox')[0];else return select.dropdown.getElementsByClassName('js-multi-select__option')[0].getElementsByClassName('js-multi-select__checkbox')[0];
  }

  ;

  function moveFocusToSelectTrigger(select) {
    if (!document.activeElement.closest('.js-multi-select')) return;
    select.trigger.focus();
  }

  ;

  function checkCustomSelectClick(select, target) {
    // close select when clicking outside it
    if (!select.element.contains(target)) toggleCustomSelect(select, 'false');
  }

  ; //initialize the CustomSelect objects

  var customSelect = document.getElementsByClassName('js-multi-select');

  if (customSelect.length > 0) {
    var selectArray = [];

    for (var i = 0; i < customSelect.length; i++) {
      (function (i) {
        selectArray.push(new MultiCustomSelect(customSelect[i]));
      })(i);
    } // listen for key events


    window.addEventListener('keyup', function (event) {
      if (event.keyCode && event.keyCode == 27 || event.key && event.key.toLowerCase() == 'escape') {
        // close custom select on 'Esc'
        selectArray.forEach(function (element) {
          moveFocusToSelectTrigger(element); // if focus is within dropdown, move it to dropdown trigger

          toggleCustomSelect(element, 'false'); // close dropdown
        });
      }
    }); // close custom select when clicking outside it

    window.addEventListener('click', function (event) {
      selectArray.forEach(function (element) {
        checkCustomSelectClick(element, event.target);
      });
    });
  }
})(); // File#: _3_advanced-filter
// Usage: codyhouse.co/license


(function () {
  // the AdvFilter object is used to handle: 
  // - number of results
  // - form reset
  // - filtering sections label (to show a preview of the option selected by the users)
  var AdvFilter = function AdvFilter(element) {
    this.element = element;
    this.form = this.element.getElementsByClassName('js-adv-filter__form');
    this.resultsList = this.element.getElementsByClassName('js-adv-filter__gallery')[0];
    this.resultsCount = this.element.getElementsByClassName('js-adv-filter__results-count');
    initAdvFilter(this);
  };

  function initAdvFilter(filter) {
    if (filter.form.length > 0) {
      // reset form
      filter.form[0].addEventListener('reset', function (event) {
        setTimeout(function () {
          resetFilters(filter);
          resetGallery(filter);
        });
      }); // update section labels on form change

      filter.form[0].addEventListener('change', function (event) {
        var section = event.target.closest('.js-adv-filter__item');
        if (section) resetSelection(filter, section);else if (Util.is(event.target, '.js-adv-filter__form')) {
          // reset the entire form lables
          var sections = filter.form[0].getElementsByClassName('js-adv-filter__item');

          for (var i = 0; i < sections.length; i++) {
            resetSelection(filter, sections[i]);
          }
        }
      });
    } // reset results count


    if (filter.resultsCount.length > 0) {
      filter.resultsList.addEventListener('filter-selection-updated', function (event) {
        updateResultsCount(filter);
      });
    }
  }

  ;

  function resetFilters(filter) {
    // check if there are custom form elemets - reset appearance
    // custom select
    var customSelect = filter.element.getElementsByClassName('js-select');

    if (customSelect.length > 0) {
      for (var i = 0; i < customSelect.length; i++) {
        customSelect[i].dispatchEvent(new CustomEvent('select-updated'));
      }
    } // custom slider


    var customSlider = filter.element.getElementsByClassName('js-slider');

    if (customSlider.length > 0) {
      for (var i = 0; i < customSlider.length; i++) {
        customSlider[i].dispatchEvent(new CustomEvent('slider-updated'));
      }
    }
  }

  ;

  function resetSelection(filter, section) {
    // change label value based on input types
    var labelSelection = section.getElementsByClassName('js-adv-filter__selection');
    if (labelSelection.length == 0) return; // select

    var select = section.getElementsByTagName('select');

    if (select.length > 0) {
      labelSelection[0].textContent = getSelectLabel(section, select[0]);
      return;
    } // input number


    var number = section.querySelectorAll('input[type="number"]');

    if (number.length > 0) {
      labelSelection[0].textContent = getNumberLabel(section, number);
      return;
    } // input range


    var slider = section.querySelectorAll('input[type="range"]');

    if (slider.length > 0) {
      labelSelection[0].textContent = getSliderLabel(section, slider);
      return;
    } // radio/checkboxes


    var radio = section.querySelectorAll('input[type="radio"]'),
        checkbox = section.querySelectorAll('input[type="checkbox"]');

    if (radio.length > 0) {
      labelSelection[0].textContent = getInputListLabel(section, radio);
      return;
    } else if (checkbox.length > 0) {
      labelSelection[0].textContent = getInputListLabel(section, checkbox);
      return;
    }
  }

  ;

  function getSelectLabel(section, select) {
    if (select.multiple) {
      var label = '',
          counter = 0;

      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].selected) {
          label = label + '' + select.options[i].text;
          counter = counter + 1;
        }

        if (counter > 1) label = section.getAttribute('data-multi-select-text').replace('{n}', counter);
      }

      return label;
    } else {
      return select.options[select.selectedIndex].text;
    }
  }

  ;

  function getNumberLabel(section, number) {
    var counter = 0;

    for (var i = 0; i < number.length; i++) {
      if (number[i].value != number[i].min) counter = counter + 1;
    }

    if (number.length > 1) {
      // multiple input number in this section
      if (counter > 0) {
        return section.getAttribute('data-multi-select-text').replace('{n}', counter);
      } else {
        return section.getAttribute('data-default-text');
      }
    } else {
      if (number[0].value == number[0].min) return section.getAttribute('data-default-text');else return section.getAttribute('data-number-format').replace('{n}', number[0].value);
    }
  }

  ;

  function getSliderLabel(section, slider) {
    var label = '',
        labelFormat = section.getAttribute('data-number-format');

    for (var i = 0; i < slider.length; i++) {
      if (i != 0) label = label + ' - ';
      label = label + labelFormat.replace('{n}', slider[i].value);
    }

    return label;
  }

  ;

  function getInputListLabel(section, inputs) {
    var counter = 0;
    label = '';

    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) {
        var labelElement = inputs[i].parentNode.getElementsByTagName('label');
        if (labelElement.length > 0) label = labelElement[0].textContent;
        counter = counter + 1;
      }
    }

    if (counter > 1) return section.getAttribute('data-multi-select-text').replace('{n}', counter);else if (counter == 0) return section.getAttribute('data-default-text');else return label;
  }

  ;

  function resetGallery(filter) {
    // emit change event + reset filtering 
    filter.form[0].dispatchEvent(new CustomEvent('change'));
    filter.resultsList.dispatchEvent(new CustomEvent('update-filter-results'));
  }

  ;

  function updateResultsCount(filter) {
    var resultItems = filter.resultsList.children,
        counter = 0;

    for (var i = 0; i < resultItems.length; i++) {
      if (isVisible(resultItems[i])) counter = counter + 1;
    }

    filter.resultsCount[0].textContent = counter;
  }

  ;

  function isVisible(element) {
    return element.offsetWidth || element.offsetHeight || element.getClientRects().length;
  }

  ; //initialize the AdvFilter objects

  var advFilter = document.getElementsByClassName('js-adv-filter');

  if (advFilter.length > 0) {
    for (var i = 0; i < advFilter.length; i++) {
      (function (i) {
        new AdvFilter(advFilter[i]);
      })(i);
    }
  } /// Grab the Url parameters and use them to filter products


  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);

  if (urlParams.has('region')) {
    var region = urlParams.get('region');
    console.log(region);
    document.getElementById("urlInput").value = region;
  } // Remove the code below if you want to use a custom filtering function (e.g., you need to fetch your results from a database)
  // The code below is used for filtering of page content (animation of DOM elements, no fetching results from database).  
  // It uses the Filter component (https://codyhouse.co/ds/components/app/filter) - you can modify the custom filtering functions based on your needs
  // Check the info page of the component for info on how to use it: https://codyhouse.co/ds/components/info/filter


  var gallery = document.getElementById('adv-filter-gallery');

  if (gallery) {
    new Filter({
      element: gallery,
      // this is your gallery element
      indexValue: function indexValue(items) {
        // this is the index custom function
        var filteredArray = [],
            value = document.getElementById('index-value').value;

        for (var i = 0; i < items.length; i++) {
          var index = parseInt(items[i].getAttribute('data-sort-index'));
          filteredArray[i] = index >= value;
        }

        return filteredArray;
      },
      urlFilter: function urlFilter(items) {
        var filteredArray = [],
            value = document.getElementById('urlInput').value;

        for (var i = 0; i < items.length; i++) {
          var searchFilter = items[i].getAttribute('data-search');
          filteredArray[i] = searchFilter == '' || searchFilter.toLowerCase().indexOf(value.toLowerCase()) > -1;
        }

        return filteredArray;
      },
      searchInput: function searchInput(items) {
        var filteredArray = [],
            value = document.getElementById('search-products').value;

        for (var i = 0; i < items.length; i++) {
          var searchFilter = items[i].getAttribute('data-search');
          filteredArray[i] = searchFilter == '' || searchFilter.toLowerCase().indexOf(value.toLowerCase()) > -1;
        }

        return filteredArray;
      }
    });
  }
})();

(function () {
  var filter_bar__toggles = document.querySelector('.filter-bar__toggles');

  if (filter_bar__toggles) {
    var btns = filter_bar__toggles.querySelectorAll('.btns__btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var value = e.target.parentElement.querySelector('input').value.replace(/\s+/g, '-').toLowerCase();
        setInputs(value);
      });
    });
  }

  function setInputs($value) {
    var productCardToggles = document.querySelectorAll('wrapped-toggle');
    productCardToggles.forEach(function (toggle) {
      toggle.querySelector("input[data-value=".concat($value, "]")).checked = true;
      toggle.querySelector("input[data-value=".concat($value, "]")).dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
  }
})();

(function ($) {
  function getTriggerTarget(trigger) {
    return $(trigger).attr('aria-controls');
  }

  ;

  function clearModal(target) {
    var $content = $(target).find('#overlay_content');
    var $content_title = $content.find('#overlay_title');
    var $content_type = $content.find('#overlay_type');
    var $content_desc = $content.find('#overlay_description');
    var $content_img = $content.find('#overlay_image').find('img');
    $content_title.text('');
    $content_type.text('');
    $content_desc.text('');
    $content_img.attr("src", '');
  }

  function populateTarget(target, content) {
    var $content = $(target).find('#overlay_content');
    var $content_title = $content.find('#overlay_title');
    var $content_type = $content.find('#overlay_type');
    var $content_desc = $content.find('#overlay_description');
    var $content_img = $content.find('#overlay_image').find('img');
    clearModal(target);
    $content_title.text(content.title);
    $content_type.text(content.type);
    $content_desc.text(content.description);
    $content_img.attr("src", content.image);
  }

  function grabContent(trigger) {
    var content = {
      "title": $(trigger).data('title'),
      "type": $(trigger).data('type'),
      "description": $(trigger).data('description'),
      "image": $(trigger).data('image')
    };
    return content;
  }

  $('.overlay-trigger').on('click', function () {
    var triggerTarget = '#' + getTriggerTarget(this);
    var targetContent = grabContent(this);
    populateTarget(triggerTarget, targetContent);
  });
})(jQuery);

(function () {
  function collapseSection(element) {
    element.style.height = 0 + 'px'; // mark the section as "currently collapsed"

    element.setAttribute('data-collapsed', 'true');
  }

  function expandSection(element) {
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight; // have the element transition to the height of its inner content

    element.style.height = sectionHeight + 'px'; // mark the section as "currently not collapsed"

    element.setAttribute('data-collapsed', 'false');
  }

  var els = document.getElementsByClassName('menu-item__has-children');

  for (var i = 0; i < els.length; i++) {
    els[i].querySelector("button").addEventListener('click', function (e) {
      // addRemoveMenuClass(e)
      e.preventDefault();
      var _target = e.target.parentElement;

      var menu = _target.parentElement.querySelector(".menu-item__children");

      console.log(menu);
      var isCollapsed = menu.getAttribute('data-collapsed') === 'true';

      if (isCollapsed) {
        expandSection(menu);
        menu.setAttribute('data-collapsed', 'false');
        Util.addClass(_target, 'menu-item__children-open');
      } else {
        collapseSection(menu);
        Util.removeClass(_target, 'menu-item__children-open');
      }
    });
  }
})();

(function ($) {
  function reorderImages(_this) {
    var _parent = $(_this).parent();

    $(_this).hide().detach().appendTo(_parent).fadeIn(400);
  }

  $('.image-text__skewed-images').find('img').on('mouseenter', function () {
    // alert('check');
    // $(this).parent().find('img').css('z-index', 1);
    // $(this).css('z-index', 2);
    reorderImages(this);
  });
})(jQuery);

var VariantSelects = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(VariantSelects, _HTMLElement3);

  var _super4 = _createSuper(VariantSelects);

  function VariantSelects() {
    var _this6;

    _classCallCheck(this, VariantSelects);

    _this6 = _super4.call(this);

    _this6.onVariantChange();

    _this6.addEventListener('change', _this6.onVariantChange);

    _this6.updateRecipeGuide();

    _this6.updatedSelectedBlendOption();

    return _this6;
  }

  _createClass(VariantSelects, [{
    key: "onVariantChange",
    value: function onVariantChange() {
      this.updateOptions();
      this.updateMedia();
      this.updateSelectedBlendImage();
      this.updateMasterId();
      this.toggleAddButton(true, '', false); // this.updatePickupAvailability();

      this.checkPersonalisation();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateSelectedBlendImage();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.showCustomSlots();
      }
    }
  }, {
    key: "getVariantData",
    value: function getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), function (select) {
        return select.value;
      });
    }
  }, {
    key: "updateMasterId",
    value: function updateMasterId() {
      var _this7 = this;

      console.log(this.options);
      this.currentVariant = this.getVariantData().find(function (variant) {
        return !variant.options.map(function (option, index) {
          return _this7.options[index] === option;
        }).includes(false);
      });
    }
  }, {
    key: "updateMedia",
    value: function updateMedia() {
      var _this$currentVariant;

      if (!this.currentVariant || !((_this$currentVariant = this.currentVariant) !== null && _this$currentVariant !== void 0 && _this$currentVariant.featured_image)) return;
      var childrens = document.querySelectorAll('.variant_image');
      childrens.forEach(function (elem) {
        elem.classList.remove("is-visible");
      });
      var newMedia = document.querySelectorAll("[data-variant-id=\"".concat(this.currentVariant.featured_media.id, "\"]"));

      for (var i = 0; i < newMedia.length; i++) {
        newMedia[i].classList.add("is-visible");
      }
    }
  }, {
    key: "updateSelectedBlendImage",
    value: function updateSelectedBlendImage() {
      var _this$currentVariant2;

      if (!this.currentVariant || !((_this$currentVariant2 = this.currentVariant) !== null && _this$currentVariant2 !== void 0 && _this$currentVariant2.featured_image)) return;
      console.log('trigger event');
      document.body.dispatchEvent(new Event('variant-blend:change'));
      var childrens = document.querySelectorAll('.blend');
      childrens.forEach(function (elem) {
        elem.classList.remove("is-selected");
      });
      var newMedia = document.querySelectorAll("[data-variant-id=\"".concat(this.currentVariant.featured_image.id, "\"]"));

      for (var i = 0; i < newMedia.length; i++) {
        newMedia[i].classList.add("is-selected");
        newMedia[i].scrollIntoView({
          inline: "center"
        });
      }
    }
  }, {
    key: "updatedSelectedBlendOption",
    value: function updatedSelectedBlendOption() {
      var _this$currentVariant3;

      if (!this.currentVariant || !((_this$currentVariant3 = this.currentVariant) !== null && _this$currentVariant3 !== void 0 && _this$currentVariant3.featured_image)) return;
      var childrens = document.querySelectorAll('.blend');

      var _this = this;

      childrens.forEach(function (elem) {
        elem.addEventListener("click", function (e) {
          elem.scrollIntoView({
            inline: "center"
          });
          _this.querySelectorAll('select')[0].value = elem.getAttribute('data-variant-name');

          _this.querySelectorAll('select')[0].dispatchEvent(new Event("change", {
            bubbles: true
          }));
        });
      });
    }
  }, {
    key: "updateURL",
    value: function updateURL() {
      if (!this.currentVariant) return;
      window.history.replaceState({}, '', "".concat(this.dataset.url, "?variant=").concat(this.currentVariant.id));
    }
  }, {
    key: "updateVariantInput",
    value: function updateVariantInput() {
      var _this8 = this;

      var productForms = document.querySelectorAll("#product-form-".concat(this.dataset.section, ", #product-form-installment"));
      productForms.forEach(function (productForm) {
        var input = productForm.querySelector('input[name="id"]');
        input.value = _this8.currentVariant.id;
        input.dispatchEvent(new Event('change'));
      });
    }
  }, {
    key: "showCustomSlots",
    value: function showCustomSlots() {
      var _document$getElementB;

      var blendSelector = (_document$getElementB = document.getElementById("product-form-".concat(this.dataset.section))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.querySelector('#blend-selectors');
      if (!blendSelector) return;

      if (!this.options.includes("Custom Collection")) {
        this.destroyCustomSlots();
        this.hasSlots = false;
        return;
      } else {
        blendSelector.style.display = 'block';
        this.hasSlots = true;
        this.toggleAddButton(true, '', true);
        this.grabSlotValues();
      }
    }
  }, {
    key: "grabSlotValues",
    value: function grabSlotValues() {
      var _document$getElementB2;

      var blendSelector = (_document$getElementB2 = document.getElementById("product-form-".concat(this.dataset.section))) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.querySelector('#blend-selectors');
      var selects = blendSelector.querySelectorAll('select');

      var _this = this;

      var blends = '';
      var slots = selects.length; // Create Input.

      var input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("id", "blendSelector_results");
      input.setAttribute("name", "properties[Blends]");
      blendSelector.appendChild(input); // how many slots are filled on load?

      selects.forEach(function (select) {
        if (select.value == 'Select blend') {
          return;
        } else {
          if (slots >= 1) {
            slots = slots - 1;
          }

          blends += select.value + ', ';
        }
      });

      if (slots === 0) {
        input.value = blends.replace(/,\s*$/, "");

        _this.toggleAddButton(false, '', true);
      } else {
        _this.toggleAddButton(true, '', true);
      } // how many slots are filled on load?


      blendSelector.addEventListener('change', function () {
        blends = '';
        slots = selects.length;
        selects.forEach(function (select) {
          if (select.value == 'Select blend') {
            return;
          } else {
            if (slots >= 1) {
              slots = slots - 1;
            }

            blends += select.value + ', ';
          }
        });

        if (slots === 0) {
          input.value = blends.replace(/,\s*$/, "");

          _this.toggleAddButton(false, '', true);
        } else {
          _this.toggleAddButton(true, '', true);
        }
      });
    }
  }, {
    key: "destroyCustomSlots",
    value: function destroyCustomSlots() {
      var _document$getElementB3;

      var blendSelector = (_document$getElementB3 = document.getElementById("product-form-".concat(this.dataset.section))) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.querySelector('#blend-selectors');
      blendSelector.style.display = 'none';
      var blendSelectorResult = blendSelector.querySelector('#blendSelector_results');

      if (blendSelectorResult) {
        blendSelectorResult.remove();
      }

      ;
    }
  }, {
    key: "checkStartDate",
    value: function checkStartDate() {
      var _document$getElementB4;

      console.log('fired start date');
      var subscriptionStartDate = (_document$getElementB4 = document.getElementById("product-form-".concat(this.dataset.section))) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.querySelector('#subscription-start-date');
      if (!subscriptionStartDate) return;

      var _this = this;

      var subscription_input = subscriptionStartDate.querySelector('#date-sub-start');

      if (subscription_input.value === '') {
        this.toggleAddButton(false, '', true);
        console.log('disable');
      } else {
        this.toggleAddButton(true, '', true);
        console.log('enable');
      }

      subscription_input.addEventListener('change', function () {
        if (subscription_input.value === '') {
          _this.toggleAddButton(false, '', true);

          console.log('disable');
        } else {
          _this.toggleAddButton(true, '', true);

          console.log('enable');
        }
      });
    }
  }, {
    key: "checkPersonalisation",
    value: function checkPersonalisation() {
      var _this9 = this;

      if (!document.querySelector('input[name="personalisation"]')) return;
      var radios = document.querySelectorAll('input[name="personalisation"]');
      var checkbox = document.querySelector('#personalisation-checkbox');
      radios.forEach(function (radio) {
        if (radio.value == "Personalised" && radio.checked) {
          checkbox.checked = true;

          _this9.createPersonalisationForm();
        } else if (radio.value == 'Blank' && radio.checked) {
          checkbox.checked = false;

          _this9.destroyPersonalisationForm();
        }

        radio.dispatchEvent(new Event("change"));
      });
      checkbox.addEventListener("click", function (e) {
        radios.forEach(function (radio) {
          if (radio.value == "Personalised" && e.target.checked) {
            radio.checked = true;

            _this9.createPersonalisationForm();
          } else if (radio.value == 'Blank' && !e.target.checked) {
            radio.checked = true;

            _this9.destroyPersonalisationForm();
          }

          radio.dispatchEvent(new Event("change"));
        });
      });
    }
  }, {
    key: "createPersonalisationForm",
    value: function createPersonalisationForm() {
      if (!document.querySelector('.product__personalisation')) return;
      var engraving_selector = document.querySelector('.product__personalisation');
      var engravingFormTarget = engraving_selector.querySelector('.product__personalisation-input');
      var engravingContainer = document.createElement('div');
      engravingContainer.className = 'product__personalisation-content-container js-character-count';
      var engravingForm = document.createElement('input');
      engravingForm.className = 'product__personalisation-input-form js-character-count__input';
      engravingForm.type = "text";
      engravingForm.name = "properties[Personalisation line 1]";
      engravingForm.setAttribute("maxlength", "12");
      engravingForm.setAttribute("placeholder", "Personalisation Line 1");
      engravingForm.setAttribute("required", '');
      var engravingCountContainer = document.createElement('div');
      engravingCountContainer.className = 'character-count__helper character-count__helper--dynamic';
      var engravingCopy = document.createElement('p');
      var engravingCount = document.createElement('span');
      engravingCount.classList = 'js-character-count__counter';
      engravingCopy.appendChild(engravingCount);
      engravingCopy.insertAdjacentText('afterbegin', 'Remaining: ');
      engravingCountContainer.appendChild(engravingCopy);
      engravingContainer.appendChild(engravingForm);
      engravingContainer.appendChild(engravingCountContainer);
      var clone = engravingContainer.cloneNode(true);
      clone.querySelector('input').name = "properties[Personalisation line 2]";
      clone.querySelector('input').value = "";
      clone.querySelector('input').setAttribute("placeholder", "Personalisation Line 2");

      if (!engraving_selector.querySelector('.product__personalisation-input-form')) {
        engravingFormTarget.appendChild(engravingContainer);
        engravingFormTarget.appendChild(clone);
        var characterCounts = document.getElementsByClassName('js-character-count');

        if (characterCounts.length > 0) {
          for (var i = 0; i < characterCounts.length; i++) {
            (function (i) {
              new CharacterCount(characterCounts[i]);
            })(i);
          }
        }

        ;
      }
    }
  }, {
    key: "destroyPersonalisationForm",
    value: function destroyPersonalisationForm() {
      if (!document.querySelector('.product__personalisation-input-form')) return;
      var recipe_selector = document.querySelector('.product__personalisation');
      var engravingFormTarget = recipe_selector.querySelector('.product__personalisation-input');
      engravingFormTarget.innerHTML = "";
    }
  }, {
    key: "updateRecipeGuide",
    value: function updateRecipeGuide() {
      if (!document.querySelector('.product__recipe-guide-picker')) return;
      var recipe_selector = document.querySelector('.product__recipe-guide-picker');
      var recipe_input_selectors = recipe_selector.querySelector('.selector__variant-picker').querySelectorAll('input');
      var target_input = recipe_selector.querySelector('#recipe-guide__selected');

      for (var i = 0; i < recipe_input_selectors.length; i++) {
        recipe_input_selectors[i].addEventListener('change', function () {
          target_input.value = this.value;
        });
      }
    }
  }, {
    key: "renderProductInfo",
    value: function renderProductInfo() {
      var _this10 = this;

      fetch("".concat(this.dataset.url, "?variant=").concat(this.currentVariant.id, "&section_id=").concat(this.dataset.section)).then(function (response) {
        return response.text();
      }).then(function (responseText) {
        var _document$getElementB5;

        var id = "price-".concat(_this10.dataset.section);
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var destination = document.getElementById(id);
        var source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        (_document$getElementB5 = document.getElementById("price-".concat(_this10.dataset.section))) === null || _document$getElementB5 === void 0 ? void 0 : _document$getElementB5.classList.remove('visibility-hidden');

        if (!_this10.hasSlots) {
          _this10.toggleAddButton(!_this10.currentVariant.available, window.variantStrings.soldOut);
        }
      });
    }
  }, {
    key: "toggleAddButton",
    value: function toggleAddButton() {
      var _document$getElementB6;

      var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var text = arguments.length > 1 ? arguments[1] : undefined;
      var modifyClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var addButton = (_document$getElementB6 = document.getElementById("product-form-".concat(this.dataset.section))) === null || _document$getElementB6 === void 0 ? void 0 : _document$getElementB6.querySelector('[name="add"]');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButton.querySelector('.btn__content-a').textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButton.querySelector('.btn__content-a').textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }
  }, {
    key: "setUnavailable",
    value: function setUnavailable() {
      var _document$getElementB7, _document$getElementB8;

      var addButton = (_document$getElementB7 = document.getElementById("product-form-".concat(this.dataset.section))) === null || _document$getElementB7 === void 0 ? void 0 : _document$getElementB7.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.querySelector('.btn__content-a').textContent = window.variantStrings.unavailable;
      (_document$getElementB8 = document.getElementById("price-".concat(this.dataset.section))) === null || _document$getElementB8 === void 0 ? void 0 : _document$getElementB8.classList.add('visibility-hidden');
    }
  }]);

  return VariantSelects;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('variant-selects', VariantSelects);

var VariantRadios = /*#__PURE__*/function (_VariantSelects) {
  _inherits(VariantRadios, _VariantSelects);

  var _super5 = _createSuper(VariantRadios);

  function VariantRadios() {
    _classCallCheck(this, VariantRadios);

    return _super5.call(this);
  }

  _createClass(VariantRadios, [{
    key: "updateOptions",
    value: function updateOptions() {
      var fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map(function (fieldset) {
        return Array.from(fieldset.querySelectorAll('input')).find(function (radio) {
          return radio.checked;
        }).value;
      });
    }
  }]);

  return VariantRadios;
}(VariantSelects);

customElements.define('variant-radios', VariantRadios);

var QuantityInput = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(QuantityInput, _HTMLElement4);

  var _super6 = _createSuper(QuantityInput);

  function QuantityInput() {
    var _this11;

    _classCallCheck(this, QuantityInput);

    _this11 = _super6.call(this);
    _this11.input = _this11.querySelector('input');
    _this11.changeEvent = new Event('change', {
      bubbles: true
    });

    _this11.querySelectorAll('button').forEach(function (button) {
      return button.addEventListener('click', _this11.onButtonClick.bind(_assertThisInitialized(_this11)));
    });

    return _this11;
  }

  _createClass(QuantityInput, [{
    key: "onButtonClick",
    value: function onButtonClick(event) {
      event.preventDefault();
      var previousValue = this.input.value;
      event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }]);

  return QuantityInput;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('quantity-input', QuantityInput);

var VariantPickers = /*#__PURE__*/function (_HTMLElement5) {
  _inherits(VariantPickers, _HTMLElement5);

  var _super7 = _createSuper(VariantPickers);

  function VariantPickers() {
    var _this12;

    _classCallCheck(this, VariantPickers);

    _this12 = _super7.call(this);

    _this12.addEventListener('change', _this12.OnVariantChange);

    return _this12;
  }

  _createClass(VariantPickers, [{
    key: "OnVariantChange",
    value: function OnVariantChange() {
      this.updateRadios();
      this.updateSelects();
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantInput();
      this.updatePrice();
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      this.options = this.radios.concat(this.selects);
    }
  }, {
    key: "updateRadios",
    value: function updateRadios() {
      var fieldsets = Array.from(this.parentNode.querySelectorAll('fieldset:not(.option_container--dropdown)'));
      console.log('radio');
      this.radios = fieldsets.map(function (fieldset) {
        if (fieldset.querySelectorAll('input').length) {
          console.log(fieldset.querySelectorAll('input').length);
          var radios = Array.from(fieldset.querySelectorAll('input')).find(function (radio) {
            return radio.checked;
          }).value;
          console.log(radios);
          return radios;
        }
      });
    }
  }, {
    key: "updateSelects",
    value: function updateSelects() {
      var fieldsets = Array.from(this.parentNode.querySelectorAll('fieldset.option_container--dropdown'));
      console.log('select');
      this.selects = fieldsets.map(function (fieldset) {
        if (fieldset.querySelectorAll('select').length) {
          var selects = Array.from(fieldset.querySelectorAll('select'), function (select) {
            return select.value;
          });
          console.log(selects);
          return selects[0];
        }
      });
    }
  }, {
    key: "updateMasterId",
    value: function updateMasterId() {
      var _this13 = this;

      console.log(this.options);
      this.currentVariant = this.getVariantData().find(function (variant) {
        return !variant.options.map(function (option, index) {
          return _this13.options[index] === option;
        }).includes(false);
      });
    }
  }, {
    key: "updateVariantInput",
    value: function updateVariantInput() {
      var _this14 = this;

      var productForms = document.querySelectorAll("#quick-add__form--".concat(this.dataset.form));
      productForms.forEach(function (productForm) {
        var input = productForm.querySelector('input[name="id"]');
        console.log(input);
        input.value = _this14.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }
  }, {
    key: "updatePrice",
    value: function updatePrice() {
      console.log(Shopify.formatMoney(this.currentVariant.price));
      var submitBtn = document.querySelector("#quick-add__form--".concat(this.dataset.form)).querySelector('button[type="submit"]'); //grab copy 

      var submitCopy = submitBtn.querySelector('.btn__content-a').textContent; //clean copy

      submitCopy = submitCopy.slice(0, submitCopy.lastIndexOf('-'));
      var cleanedCopy = submitCopy + '- ' + Shopify.formatMoney(this.currentVariant.price); //inject copy

      submitBtn.querySelector('.btn__content-a').textContent = cleanedCopy;
    }
  }, {
    key: "getVariantData",
    value: function getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.parentNode.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }]);

  return VariantPickers;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('variant-pickers', VariantPickers);

var VariantDropDown = /*#__PURE__*/function (_VariantPickers) {
  _inherits(VariantDropDown, _VariantPickers);

  var _super8 = _createSuper(VariantDropDown);

  function VariantDropDown() {
    _classCallCheck(this, VariantDropDown);

    return _super8.call(this);
  }

  return _createClass(VariantDropDown);
}(VariantPickers);

customElements.define('variant-dropdown', VariantDropDown);